/* eslint-disable */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { api, onedrive_upload } from '../api';
import { T, BG } from '../tema';
import SagsTidslinje from '../SagsTidslinje';
import { useEscapeClose, toast, pollAiOpgave } from '../utils';
import { Knap, RingOpKnap, HjaelpIkon, Filer, sagstype_label, BekræftDialog } from './Ui';
import NyKlient, { KlientKontakterPanel, KlientKontaktLinje } from './NyKlient';
import DokumentGeneratorWizard from './DokumentGeneratorWizard';
// ── Moved from App.js: ONEDRIVE_KATEGORIER, FilPreview, HændelseFiler, HændelseFilTæller ──
// ─────────────────────────────────────────────────────────
// ONEDRIVE FILER — viser og uploader filer for en sag
// ─────────────────────────────────────────────────────────
// René (25/10): kategori-knapperne (gammel OneDrive-mappeinddeling) er
// FJERNET — de 4 dimensionsfiltre fra Hændelser er nu den ENESTE
// klassificering, også for upload. "Type"-filteret er derfor udvidet med
// de gamle kategorinavne der ikke allerede fandtes i den hændelse-type-
// baserede liste, så intet mappenavn mistes. Filtreringen matcher på selve
// OneDrive-mappenavnet (se fil_kategori_fra_sti nedenfor) i stedet for den
// hændelse filen evt. stammer fra — det virker derfor for ALLE filer,
// ikke kun dem der er koblet til en hændelse.
const DIM_RETNINGER = ["Indgående","Udgående","Intern"];
const DIM_PARTER = ["Familieretshuset","Politiet","Klient","Modpart","Advokat (klientens)","Advokat (modpartens)","Retten","Kommunen","Børnehus","Andre myndigheder","SkilsmisseVejen (intern)","Skifteretten","Ankestyrelsen","Mægler/mediator"];
const DIM_TYPER = [
 "Journal","Aktindsigt","Oplysninger","Dom","Klager","Indkaldelse",
 "Sagsopstart","Retten","Bilag klient","Afgørelser","Børnesamtaler",
 "Kommunikation","Mødenotater","Partshøring","Sagsakter","Underretninger",
 "Video","Lyd","Nyttige bilag","Log og data",
 "Anmodning","Afgørelse","Dokument","Aftale","Brev/korrespondance","Møde",
 "Telefonopkald","Mail","Notat","Klage","Erklæring","Samtykkeerklæring","Bilag fra klienten",
];
const DIM_STATUSSER = ["Kladde","Sendt/Indsendt","Modtaget","Afventer svar","Besvaret","Afsluttet/Lukket","Anket","Bortfaldet"];
function fil_kategori_fra_sti(sti) {
 return (sti || "").split("/")[3] || "";
}
// ─────────────────────────────────────────────────────────
// HÆNDELSE FILER — viser filer fra OneDrive på en hændelse
// ─────────────────────────────────────────────────────────
// ─────────────────────────────────────────────────────────
// FIL VIEWER — sidelæns swipe med preview
// ─────────────────────────────────────────────────────────
// Lille komponent der viser papirklips-ikon med antal filer
function FilPreview({ fil }) {
 const [indlæser, setIndlæser] = React.useState(false);
 const [vis_overlay, setVisOverlay] = React.useState(false);
 const [blob_url, setBlobUrl] = React.useState(null);
 // Cleanup: revoke blob URL ved unmount eller når blob_url ændres
 // for at undgå memory leak (Bug 10)
 React.useEffect(() => {
 return () => {
 if (blob_url) {
 URL.revokeObjectURL(blob_url);
 }
 };
 }, [blob_url]);
 const url = fil.download_url;
 if (!url) return null;
 const mime = (fil.mime_type || '').toLowerCase();
 const navn = (fil.original_navn || fil.visningsnavn || '').toLowerCase();
 const er_pdf = mime.includes('pdf') || navn.endsWith('.pdf');
 const er_billede = mime.includes('image') || navn.match(/\.(jpg|jpeg|png|gif|bmp|webp)$/);
 const er_video = mime.includes('video') || navn.match(/\.(mp4|mov|avi|webm|mkv)$/);
 const er_lyd = mime.includes('audio') || navn.match(/\.(mp3|wav|ogg|m4a|aac)$/);
 const er_word = mime.includes('word') || navn.match(/\.(doc|docx)$/);
 const kan_preview = er_pdf || er_billede || er_video || er_lyd || er_word;
 if (!kan_preview) return null;
 const type_label = er_pdf?"dokument":er_billede?"billede":er_video?"video":er_lyd?"lyd":"Word-fil";
 const åbn = async (e) => {
 e.preventDefault();
 e.stopPropagation();
 setIndlæser(true);
 try {
 // Hent fil som blob — undgår Content-Disposition: attachment
 const res = await fetch(url);
 const blob = await res.blob();
 const lokal = URL.createObjectURL(blob);
 setBlobUrl(lokal);
 setVisOverlay(true);
 } catch (err) {
 // Fallback: åbn i nyt vindue
 window.open(url, '_blank');
 }
 setIndlæser(false);
 };
 const luk = () => {
 setVisOverlay(false);
 if (blob_url) { URL.revokeObjectURL(blob_url); setBlobUrl(null); }
 };
 // Lyd: ingen overlay — vis inline afspiller direkte
 if (er_lyd) return (
   <div style={{ marginTop:6 }}>
     {!blob_url && <button onClick={åbn}
       style={{ background:"rgba(63,212,199,0.08)", border:"1px solid rgba(63,212,199,0.2)", borderRadius:6, padding:"4px 10px", color:"#3fd4c7", fontSize:12, cursor:indlæser?"wait":"pointer" }}>
       {indlæser ? "⏳ Henter..." : "▶ Afspil"}
     </button>}
     {blob_url && <audio controls src={blob_url} style={{ width:"100%", height:36, marginTop:4, borderRadius:4 }} />}
   </div>
 );

 return (
 <> <button onClick={åbn}
 style={{ background:"rgba(63,212,199,0.08)", border:"1px solid rgba(63,212,199,0.2)", borderRadius:6, padding:"4px 10px", color:"#3fd4c7", fontSize:12, cursor:indlæser?"wait":"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 {indlæser ? " Henter..." : er_lyd ? "▶ Afspil" : er_video ? "▶ Afspil video" : "▶ Vis " + type_label}
 </button>
 {vis_overlay && blob_url && require("react-dom").createPortal(
 <div style={{ position:"fixed", top:0, left:0, width:"100vw", height:"100vh", background:"rgba(0,0,0,0.92)", zIndex:99999 }}
 onClick={luk}>
 {/* Header */}
 <div style={{ position:"absolute", top:0, left:0, right:0, height:48, padding:"0 20px", display:"flex", justifyContent:"space-between", alignItems:"center", background:"rgba(0,0,0,0.6)", zIndex:1 }}
 onClick={e => e.stopPropagation()}> <div style={{ color:"#e2e8f0", fontSize:14, fontWeight:500, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", flex:1, marginRight:16 }}>{fil.visningsnavn || fil.original_navn}</div> <div style={{ display:"flex", gap:10, alignItems:"center", flexShrink:0 }}> <button onClick={(e) => { e.stopPropagation(); const w = window.open(blob_url); if(w) w.onload = () => w.print(); }}
 style={{ color:"#e2e8f0", fontSize:12, textDecoration:"none", padding:"6px 14px", border:"1px solid rgba(255,255,255,0.2)", borderRadius:6, background:"none", cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Udskriv
 </button> <a href={url} target="_blank" rel="noreferrer"
 style={{ color:"#3fd4c7", fontSize:12, textDecoration:"none", padding:"6px 14px", border:"1px solid rgba(63,212,199,0.3)", borderRadius:6 }}>
 ↓ Download
 </a> <button onClick={(e) => { e.stopPropagation(); window.open('/api/filer/' + fil.id + '/stream', '_blank'); }}
 style={{ color:"#a78bfa", fontSize:12, padding:"6px 14px", border:"1px solid rgba(167,139,250,0.3)", borderRadius:6, background:"none", cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Åbn i nyt vindue
 </button> <button onClick={luk}
 style={{ background:"rgba(255,255,255,0.1)", border:"none", borderRadius:6, padding:"6px 14px", color:"#fff", fontSize:16, cursor:"pointer", fontWeight:700 }}>×</button> </div> </div>
 {/* Indhold — fylder hele skærmen minus header */}
 <div style={{ position:"absolute", top:48, left:10, right:10, bottom:10 }}
 onClick={e => e.stopPropagation()}>
 {(er_pdf || er_word) && <iframe
 src={er_word ? "https://view.officeapps.live.com/op/embed.aspx?src="+encodeURIComponent(url) : blob_url}
 style={{ width:"100%", height:"100%", border:"none", borderRadius:8, background:"#fff" }}
 title={fil.visningsnavn} />}
 {er_billede && <img src={blob_url} alt={fil.visningsnavn} style={{ width:"100%", height:"100%", objectFit:"contain" }} />}
 {er_video && <video controls style={{ width:"100%", height:"100%", objectFit:"contain", background:"#000", borderRadius:8 }} src={blob_url} />}
 {er_lyd && <audio controls src={blob_url} style={{ width:"100%", maxWidth:'100%', height:36, marginTop:6 }} />}
 </div> </div>,
 document.body
 )}
 </>
 );
}
function LydTransskription({ fil_id, fil_navn }) {
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [vis_transskription, setVisTransskription] = React.useState(false);
  const [taler_navne, setTalerNavne] = React.useState({});
  const [rediger_taler, setRedigerTaler] = React.useState(null);
  const [nyt_navn, setNytNavn] = React.useState('');
  const [søg, setSøg] = React.useState('');
  const [reload_key, setReloadKey] = React.useState(0);

  const genindekser = () => {
    api(`filer/${fil_id}/indekser`, "POST").then(() => setReloadKey(k => k + 1));
  };

  React.useEffect(() => {
    if (!fil_id) return;
    let afbrudt = false;
    let timer = null;
    setLoading(true);
    setData(null);
    const hent = () => {
      api(`filer/${fil_id}/transskription`).then(d => {
        if (afbrudt) return;
        setData(d);
        if (d.taler_navne) setTalerNavne(d.taler_navne);
        if (d.status === 'under_indeksering' || d.status === 'ikke_indekseret') {
          timer = setTimeout(hent, 5000);
        } else if (d.status === 'klar' && !d.referat) {
          // Transskription klar men referat mangler — poll videre
          setLoading(false);
          timer = setTimeout(hent, 5000);
        } else {
          setLoading(false);
        }
      }).catch(err => {
        if (afbrudt) return;
        console.error('[LydTransskription] fejl:', err);
        setLoading(false);
      });
    };
    hent();
    return () => {
      afbrudt = true;
      if (timer) clearTimeout(timer);
    };
  }, [fil_id, reload_key]);

  const gem_taler_navn = (taler) => {
    if (!nyt_navn.trim()) return;
    api(`filer/${fil_id}/taler-navn`, "PATCH", { taler, navn: nyt_navn });
    setTalerNavne(prev => ({ ...prev, [taler]: nyt_navn }));
    setRedigerTaler(null);
    setNytNavn('');
  };

  const erstat_taler_navne = (tekst) => {
    if (!tekst) return tekst;
    let resultat = tekst;
    Object.entries(taler_navne).forEach(([taler, navn]) => {
      resultat = resultat.replace(new RegExp(taler, 'gi'), navn);
    });
    return resultat;
  };

  // Find unikke talere i transskriptionen. v1.12 pkt 4: pyannote-diarisering
  // introducerer nye talerlabels — "Medarbejder"/"Ekstern" (kendt retning) og
  // "Taler A"/"Taler B" (ukendt retning, jf. server.py's _bestem_taler_rolle_labels)
  // — udover de allerede understøttede "Taler N"/"SPEAKER_N". "Ukendt" er
  // bevidst UDELADT: det er den permanente fallback for ikke-diariserede
  // filer (kun ét talerfelt, intet at navngive/skelne).
  const find_talere = (tekst) => {
    if (!tekst) return [];
    const matches = tekst.match(/\b(Taler [A-Z0-9]+|SPEAKER_\d+|Medarbejder|Ekstern)\b/g) || [];
    return [...new Set(matches)];
  };

  if (loading || (data?.status === 'klar' && !data?.referat)) {
    const fase = data === null                                    ? 'Henter status...' :
                 data?.status === 'ikke_indekseret'              ? 'Venter på at starte...' :
                 data?.status === 'under_indeksering'            ? 'Transskriberer tale med Whisper...' :
                 (data?.status === 'klar' && !data?.referat)     ? 'Genererer referat via Claude...' :
                                                                   'Behandler...';
    return (
      <div style={{ margin:'8px 0', padding:'10px 12px', background:'rgba(255,255,255,0.04)', borderRadius:6 }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:6 }}>
          <div style={{ fontSize:12, color:'#7a8fa6' }}>⏳ {fase}</div>
          <div style={{ fontSize:11, color:'rgba(255,255,255,0.3)' }}>opdaterer hvert 5. sek.</div>
        </div>
        <div style={{ height:4, background:'rgba(255,255,255,0.08)', borderRadius:2, overflow:'hidden' }}>
          <div style={{ height:'100%', background:'#0a84ff', borderRadius:2,
            animation:'sv-progress 1.5s ease-in-out infinite alternate' }} />
        </div>
        <style>{`@keyframes sv-progress { from { width:15% } to { width:85% } }`}</style>
      </div>
    );
  }

  if (!data || data.status === 'ikke_understottet') return null;

  if (data.status === 'under_indeksering' || data.status === 'ikke_indekseret') return (
    <div style={{ margin:'8px 0', padding:'8px 12px', background:'rgba(255,193,7,0.08)', border:'1px solid rgba(255,193,7,0.2)', borderRadius:6, fontSize:12, color:'#fab219' }}>
      ⏳ Transskribering i gang...
    </div>
  );

  if (data.status === 'fejlet') return (
    <div style={{ margin:'8px 0', padding:'8px 12px', background:'rgba(255,59,48,0.06)', border:'1px solid rgba(255,59,48,0.2)', borderRadius:6, fontSize:12, color:'#ff6b60', display:'flex', alignItems:'center', gap:8 }}>
      <span>Transskribering fejlede</span>
      <button onClick={(e) => { e.stopPropagation(); genindekser(); }} style={{ fontSize:11, padding:'2px 8px', background:'rgba(255,59,48,0.15)', border:'1px solid rgba(255,59,48,0.3)', borderRadius:4, color:'#ff6b60', cursor:'pointer' }}>
        Prøv igen
      </button>
    </div>
  );

  if (!data.transskription) return null;

  const talere = find_talere(data.transskription);

  return (
    <div style={{ marginTop:10, borderTop:'1px solid rgba(255,255,255,0.07)', paddingTop:10 }}>

      {/* Mini afspiller koblet til transskription */}
      <audio
        id={`audio-${fil_id}`}
        src={`/api/filer/${fil_id}/stream`}
        style={{ width:'100%', height:32, marginBottom:10, borderRadius:4 }}
        controls
      />

      {/* Referat */}
      {data.referat && (
        <div style={{ background:'rgba(10,132,255,0.08)', border:'1px solid rgba(10,132,255,0.2)', borderRadius:8, padding:'10px 14px', marginBottom:10 }}>
          <div style={{ fontSize:11, color:'#0a84ff', fontWeight:600, marginBottom:6, textTransform:'uppercase', letterSpacing:'0.05em' }}>📋 Referat</div>
          <div style={{ fontSize:13, color:'#c8d6e5', whiteSpace:'pre-wrap', lineHeight:1.6 }}>{data.referat}</div>
        </div>
      )}

      {/* Taler-navngivning */}
      {talere.length > 0 && (
        <div style={{ marginBottom:10 }}>
          <div style={{ fontSize:11, color:'#7a8fa6', marginBottom:6 }}>👥 Navngiv talere:</div>
          <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
            {talere.map(taler => (
              <div key={taler} style={{ display:'flex', alignItems:'center', gap:4, background:'rgba(255,255,255,0.05)', borderRadius:6, padding:'4px 8px' }}>
                {rediger_taler === taler ? (
                  <>
                    <input autoFocus value={nyt_navn} onChange={e => setNytNavn(e.target.value)}
                      onKeyDown={e => { if (e.key === 'Enter') gem_taler_navn(taler); if (e.key === 'Escape') setRedigerTaler(null); }}
                      style={{ fontSize:12, background:'transparent', border:'none', outline:'none', color:'#e2e8f0', width:120 }}
                      placeholder={taler_navne[taler] || taler} />
                    <button onClick={() => gem_taler_navn(taler)} style={{ fontSize:11, background:'#0a84ff', color:'#fff', border:'none', borderRadius:4, padding:'2px 6px', cursor:'pointer' }}>Gem</button>
                  </>
                ) : (
                  <button onClick={() => { setRedigerTaler(taler); setNytNavn(taler_navne[taler] || ''); }}
                    style={{ fontSize:12, background:'transparent', border:'none', color: taler_navne[taler] ? '#0a84ff' : '#7a8fa6', cursor:'pointer', padding:0 }}>
                    {taler_navne[taler] ? `${taler} → ${taler_navne[taler]}` : `${taler} (klik for at navngive)`}
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Søgefelt */}
      <div style={{ marginBottom:8 }}>
        <input
          placeholder="🔍 Søg i transskription..."
          value={søg || ''}
          onChange={e => setSøg(e.target.value)}
          style={{ width:'100%', background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.1)',
            borderRadius:6, padding:'5px 10px', color:'#e2e8f0', fontSize:12, outline:'none' }}
        />
      </div>

      {/* Transskription toggle */}
      <a href={`/api/filer/${fil_id}/transskription/pdf`} target="_blank" rel="noreferrer"
        style={{ fontSize:12, background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:6, padding:'4px 10px', color:'#7a8fa6', textDecoration:'none', marginBottom:8, display:'inline-block' }}>
        ⬇ Download referat
      </a>

      <button onClick={e => { e.stopPropagation(); setVisTransskription(!vis_transskription); }}
        style={{ fontSize:12, background:'rgba(255,255,255,0.05)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:6, padding:'4px 10px', color:'#7a8fa6', cursor:'pointer', marginBottom: vis_transskription ? 8 : 0 }}>
        {vis_transskription ? '▲ Skjul transskription' : '▼ Vis fuld transskription'}
      </button>

      {vis_transskription && (
        <div style={{ background:'rgba(0,0,0,0.2)', borderRadius:8, padding:'10px 14px', maxHeight:400, overflowY:'auto' }}>
          <div style={{ fontSize:12, color:'#c8d6e5', whiteSpace:'pre-wrap', lineHeight:1.7, fontFamily:'monospace' }}>
            {søg ? erstat_taler_navne(data.transskription).split(new RegExp(`(${søg})`, 'gi')).map((del, i) =>
              del.toLowerCase() === søg.toLowerCase()
                ? <mark key={i} style={{ background:'#fab219', color:'#000', borderRadius:2 }}>{del}</mark>
                : del
            ) : erstat_taler_navne(data.transskription)}
          </div>
        </div>
      )}
    </div>
  );
}

function HændelseFiler({ haendelse_id, åben }) {
 const [filer, setFiler] = React.useState(null);
 const [levering_dialog, setLeveringDialog] = React.useState(null);
 React.useEffect(() => {
 if (!haendelse_id) return;
 // Skip hvis ID er Date.now()-timestamp (midlertidig ID før DB-persist) — undgår autoriser-overflow
 if (haendelse_id > 2147483647) return;
 api("filer/haendelse/" + haendelse_id).then(data => {
 if (data?.filer) setFiler(data.filer);
 }).catch(err => { console.error(err); toast("En handling fejlede — prøv igen", "fejl"); });
 }, [haendelse_id]);
 if (!filer || filer.length === 0) return null;
 const fil_ikon = (f) => {
 const m = (f.mime_type||'').toLowerCase();
 const n = (f.original_navn||'').toLowerCase();
 if (m.includes('pdf') || n.endsWith('.pdf')) return '';
 if (m.includes('image') || n.match(/\.(jpg|jpeg|png|gif)$/)) return '';
 if (m.includes('video') || n.match(/\.(mp4|mov|avi)$/)) return '';
 if (m.includes('audio') || n.match(/\.(mp3|wav|ogg)$/)) return '';
 if (m.includes('word') || n.match(/\.(doc|docx)$/)) return '';
 if (m.includes('excel') || n.match(/\.(xls|xlsx)$/)) return '';
 return '';
 };
 const levering_farve = s => s==="sendt"?"#27ae60":s==="sendes_ikke"?"#e74c3c":"#f59e0b";
 const levering_label = s => s==="sendt"?" Sendt":s==="sendes_ikke"?" Sendes ikke":" Ikke sendt";
 // Kompakt visning: kun antal
 if (!åben) return <span style={{ color:"#3fd4c7", fontSize:12 }}> {filer.length}</span>;
 // Fuld visning med preview + leveringsstatus
 return (
 <> <div style={{ paddingLeft:44, marginTop:10 }}> <div style={{ fontSize:12, color:"#b0bec5", letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:8 }}>
 Filer ({filer.length})
 </div>
 {filer.map(f => (
 <div key={f.id} className="sv-card-pop" style={{ background:"rgba(8,12,30,0.55)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:8, padding:"10px 12px", marginBottom:6, backdropFilter:"blur(12px)", WebkitBackdropFilter:"blur(12px)", animationDelay:`${filer.indexOf(f)*0.04}s` }}> <div style={{ display:"flex", alignItems:"center", gap:8 }}> <span style={{ fontSize:18, flexShrink:0 }}>{fil_ikon(f)}</span> <div style={{ flex:1, minWidth:0 }}> <div style={{ fontSize:13, color:"#e2e8f0", fontWeight:500, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{f.visningsnavn || f.original_navn}</div> <div style={{ fontSize:12, color:"#b0bec5", marginTop:2 }}>
 {f.størrelse ? (f.størrelse < 1048576 ? (f.størrelse/1024).toFixed(0)+" KB" : (f.størrelse/1048576).toFixed(1)+" MB") : ""}
 {f.uploadet_af_navn ? " · "+f.uploadet_af_navn : ""}
 </div> </div> <div style={{ display:"flex", gap:6, flexShrink:0, alignItems:"center" }}> <button onClick={e => { e.stopPropagation(); setLeveringDialog({ fil_id: f.id, status: f.leveringsstatus, begrundelse: "" }); }}
 style={{ fontSize:12, padding:"3px 10px", borderRadius:5, cursor:"pointer", border:"none", background:`${levering_farve(f.leveringsstatus)}18`, color:levering_farve(f.leveringsstatus), fontFamily:"'Inter',system-ui,sans-serif" }}>
 {levering_label(f.leveringsstatus)}
 </button>
 {f.download_url && (
 <a href={f.download_url} target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()}
 style={{ fontSize:12, padding:"3px 10px", borderRadius:5, background:"rgba(63,212,199,0.1)", border:"1px solid rgba(63,212,199,0.3)", color:"#3fd4c7", textDecoration:"none", fontFamily:"'Inter',system-ui,sans-serif" }}>
 ↓ Download
 </a>
 )}
 </div> </div> <FilPreview fil={f} />
        {(f.mime_type?.includes('audio/') || f.mime_type?.includes('video/') ||
          /\.(mp3|wav|m4a|ogg|mp4|mov|m4v)$/i.test(f.original_navn || '')) &&
          <LydTransskription fil_id={f.id} fil_navn={f.original_navn} />} </div>
 ))}
 </div>
 {/* Levering dialog */}
 {levering_dialog && (
 <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.7)", zIndex:9000, display:"flex", alignItems:"center", justifyContent:"center" }}
 onClick={() => setLeveringDialog(null)}> <div style={{ background:"rgba(10,14,46,0.98)", border:T.kort_kant, borderRadius:18, padding:"24px 28px", width:380 }}
 onClick={e => e.stopPropagation()}> <div style={{ fontSize:15, fontWeight:600, color:"#3fd4c7", marginBottom:16 }}>Leveringsstatus</div> <div style={{ display:"flex", flexDirection:"column", gap:8, marginBottom:14 }}>
 {[["ikke_sendt"," Ikke sendt endnu","#f59e0b"],["sendt"," Sendt til klient","#27ae60"],["sendes_ikke"," Sendes ikke","#e74c3c"]].map(([val, label, farve]) => (
 <button key={val} onClick={() => setLeveringDialog(p => ({...p, status: val}))}
 style={{ padding:"10px 14px", borderRadius:8, border:`2px solid ${levering_dialog.status===val ? farve : "rgba(255,255,255,0.1)"}`, background: levering_dialog.status===val ? `${farve}15` : "transparent", color: levering_dialog.status===val ? farve : "#64748b", fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", cursor:"pointer", textAlign:"left" }}>
 {label}
 </button>
 ))}
 </div>
 {levering_dialog.status === "sendes_ikke" && (
 <textarea value={levering_dialog.begrundelse} onChange={e => setLeveringDialog(p => ({...p, begrundelse: e.target.value}))}
 placeholder="Begrundelse (påkrævet)..." spellCheck="true" lang="da" rows={3}
 className="sv-input"
 style={{ width:"100%", background:"rgba(8,12,30,0.65)", border:"1px solid rgba(255,255,255,0.09)", borderRadius:8, padding:"10px 12px", color:"#e2e8f0", fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", resize:"none", boxSizing:"border-box", marginBottom:12 }} />
 )}
 <div style={{ display:"flex", gap:8 }}> <button onClick={() => setLeveringDialog(null)} style={{ flex:1, background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.1)", borderRadius:8, padding:"10px", color:"#b0bec5", fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>Annuller</button> <button onClick={async () => {
 if (levering_dialog.status === "sendes_ikke" && !levering_dialog.begrundelse?.trim()) return;
 await api("filer/"+levering_dialog.fil_id+"/levering", "PATCH", { status: levering_dialog.status, begrundelse: levering_dialog.begrundelse });
 setFiler(p => p.map(fl => fl.id === levering_dialog.fil_id ? {...fl, leveringsstatus: levering_dialog.status} : fl));
 setLeveringDialog(null);
 }} style={{ flex:1, background:"#3fd4c7", border:"none", borderRadius:8, padding:"10px", color:"#fff", fontWeight:700, fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>Gem</button> </div> </div> </div>
 )}
 </>
 );
}
// Bagudkompatibel wrapper
function HændelseFilTæller({ haendelse_id }) {
 return <HændelseFiler haendelse_id={haendelse_id} åben={false} />;
}
// ── Moved from App.js: MoederListe, MoedeForm, GuidePanel, OneDriveFiler ────
// ═════════════════════════════════════════════════════════════
// MØDER-LISTE på sag-overview
// ═════════════════════════════════════════════════════════════
function MoederListe({ sag_id, refresh_key, onOpen }) {
 const [moeder, setMoeder] = useState([]);
 const [indlæser, setIndlæser] = useState(true);
 const hent = React.useCallback(() => {
 if (!sag_id) return;
 setIndlæser(true);
 api(`kalender/sag/${sag_id}`).then(d => {
 if (d?.moeder) setMoeder(d.moeder);
 setIndlæser(false);
 }).catch(() => setIndlæser(false));
 }, [sag_id]);
 React.useEffect(() => { hent(); }, [hent, refresh_key]);
 if (indlæser) return <div style={{ fontSize:12, color:T.dæmpet, padding:6 }}>Henter møder...</div>;
 if (moeder.length === 0) return <div style={{ fontSize:13, color:T.dæmpet, fontStyle:"italic" }}>Ingen møder — tryk + for at oprette</div>;
 const nu = new Date();
 const kommende = moeder.filter(m => m.metadata?.start_tid && new Date(m.metadata.start_tid) >= nu).slice(0, 3);
 const fortid = moeder.filter(m => !m.metadata?.start_tid || new Date(m.metadata.start_tid) < nu).slice(0, 3);
 const renderMoede = (m, idx) => {
 const start = m.metadata?.start_tid ? new Date(m.metadata.start_tid) : null;
 const er_kommende = start && start >= new Date();
 const via = m.metadata?.oprettet_via === "outlook" ? "" : "";
 const dot_farve = er_kommende ? T.turkis : "rgba(148,163,184,0.4)";
 return (
 <div key={m.id}
 onClick={() => onOpen(m)}
 className="sv-card-pop"
 style={{
 padding:"10px 12px", borderRadius:10, marginBottom:5,
 display:"flex", alignItems:"center", gap:10, cursor:"pointer",
 background:"rgba(8,12,30,0.55)",
 border:`1px solid ${er_kommende ? T.turkis + "22" : "rgba(255,255,255,0.06)"}`,
 backdropFilter:"blur(12px)", WebkitBackdropFilter:"blur(12px)",
 transition:"all 0.2s cubic-bezier(0.34,1.56,0.64,1)",
 animationDelay:`${idx * 0.06}s`,
 position:"relative", overflow:"hidden",
 }}
 onMouseOver={e => {
 e.currentTarget.style.background = er_kommende ? `rgba(63,212,199,0.08)` : "rgba(255,255,255,0.05)";
 e.currentTarget.style.borderColor = er_kommende ? `${T.turkis}44` : "rgba(255,255,255,0.1)";
 e.currentTarget.style.transform = "translateY(-1px)";
 }}
 onMouseOut={e => {
 e.currentTarget.style.background = "rgba(8,12,30,0.55)";
 e.currentTarget.style.borderColor = er_kommende ? `${T.turkis}22` : "rgba(255,255,255,0.06)";
 e.currentTarget.style.transform = "translateY(0)";
 }}> <div style={{ width:6, height:6, borderRadius:"50%", background:dot_farve, flexShrink:0,
 boxShadow: er_kommende ? `0 0 8px ${T.turkis}88` : "none" }} /> <span style={{ fontSize:14, flexShrink:0 }}>{via}</span> <div style={{ flex:1, minWidth:0 }}> <div style={{ fontSize:13, color:T.creme, fontWeight:500, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{m.titel}</div> <div style={{ fontSize:11, color:T.dæmpet }}>
 {start ? start.toLocaleString("da-DK", { day:"numeric", month:"short", hour:"2-digit", minute:"2-digit" }) : "—"}
 {m.metadata?.lokation ? ` · ${m.metadata.lokation}` : ""}
 </div> </div> <span style={{ fontSize:11, color:T.dæmpet, flexShrink:0, opacity:0.6 }}>›</span> </div>
 );
 };
 return (
 <>
 {kommende.length > 0 && (
 <> <div style={{ fontSize:10, color:T.turkis, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:4 }}>Kommende</div>
 {kommende.map((m,i) => renderMoede(m, i))}
 </>
 )}
 {fortid.length > 0 && (
 <> <div style={{ fontSize:10, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginTop:8, marginBottom:4 }}>Tidligere</div>
 {fortid.map((m,i) => renderMoede(m, kommende.length+i))}
 </>
 )}
 </>
 );
}
// ═════════════════════════════════════════════════════════════
// MØDE-FORMULAR — Sprint J
// ═════════════════════════════════════════════════════════════
function MoedeForm({ dialog, setDialog, alle_brugere, travlhed, setTravlhed, onClose, onSucces }) {
 const i_dag = new Date().toISOString().split('T')[0];
 const dato = dialog.dato || i_dag;
 const start_tid = dialog.start_tid || '10:00';
 const slut_tid = dialog.slut_tid || '11:00';
 // Hent travlhed når kalender-bruger eller dato ændres
 React.useEffect(() => {
 if (!dialog.kalender_bruger_ids?.length || !dato) { setTravlhed(null); return; }
 const t = setTimeout(async () => {
 try {
 const start = new Date(`${dato}T00:00:00`);
 const slut = new Date(`${dato}T23:59:59`);
 const r = await api("kalender/travlhed", "POST", {
 bruger_ids: dialog.kalender_bruger_ids,
 start_tid: start.toISOString(),
 slut_tid: slut.toISOString(),
 });
 if (r?.travlhed) {
 const map = {};
 r.travlhed.forEach(t => { map[t.bruger_id] = t; });
 setTravlhed(map);
 }
 } catch (e) { console.warn('[TRAVLHED]', e.message); }
 }, 400);
 return () => clearTimeout(t);
 }, [dialog.kalender_bruger_ids, dato, setTravlhed]);
 const toggleBruger = (id) => setDialog(p => ({
 ...p,
 kalender_bruger_ids: (p.kalender_bruger_ids || []).includes(id)
 ? p.kalender_bruger_ids.filter(x => x !== id)
 : [...(p.kalender_bruger_ids || []), id],
 }));
 const kan_oprette = dialog.titel?.trim() && dato && start_tid && slut_tid && (dialog.kalender_bruger_ids?.length > 0);
 return (
 <> <div style={{ marginBottom:12 }}> <label style={{ fontSize:11, color:T.dæmpet, display:"block", marginBottom:4 }}>Titel *</label> <input
 value={dialog.titel || ""}
 onChange={e => setDialog(p => ({ ...p, titel: e.target.value }))}
 placeholder="Fx: Møde med klient om samvær"
 className="sv-input"
 style={{ width:"100%", background:"rgba(8,12,30,0.65)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:8, padding:"10px 12px", color:T.creme, fontSize:13, boxSizing:"border-box" }}
 /> </div> <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:10, marginBottom:12 }}> <div> <label style={{ fontSize:11, color:T.dæmpet, display:"block", marginBottom:4 }}>Dato *</label> <input type="date" value={dato} onChange={e => setDialog(p => ({ ...p, dato: e.target.value }))}
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"9px 10px", color:T.creme, fontSize:13, colorScheme:"dark", boxSizing:"border-box" }} /> </div> <div> <label style={{ fontSize:11, color:T.dæmpet, display:"block", marginBottom:4 }}>Start *</label> <input type="time" value={start_tid} onChange={e => setDialog(p => ({ ...p, start_tid: e.target.value }))}
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"9px 10px", color:T.creme, fontSize:13, colorScheme:"dark", boxSizing:"border-box" }} /> </div> <div> <label style={{ fontSize:11, color:T.dæmpet, display:"block", marginBottom:4 }}>Slut *</label> <input type="time" value={slut_tid} onChange={e => setDialog(p => ({ ...p, slut_tid: e.target.value }))}
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"9px 10px", color:T.creme, fontSize:13, colorScheme:"dark", boxSizing:"border-box" }} /> </div> </div> <div style={{ marginBottom:12 }}> <label style={{ fontSize:11, color:T.dæmpet, display:"block", marginBottom:4 }}>Lokation</label> <input
 value={dialog.lokation || ""}
 onChange={e => setDialog(p => ({ ...p, lokation: e.target.value }))}
 placeholder="Fx: Kontoret, Teams, Hotel Struer"
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"10px 12px", color:T.creme, fontSize:13, boxSizing:"border-box" }}
 /> </div> <div style={{ marginBottom:12 }}> <label style={{ fontSize:11, color:T.dæmpet, display:"block", marginBottom:4 }}>Beskrivelse</label> <textarea
 value={dialog.beskrivelse || ""}
 onChange={e => setDialog(p => ({ ...p, beskrivelse: e.target.value }))}
 placeholder="Valgfri — agenda, forberedelse, osv."
 rows={3}
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"10px 12px", color:T.creme, fontSize:13, boxSizing:"border-box", resize:"vertical" }}
 /> </div> <div style={{ marginBottom:12 }}> <label style={{ fontSize:11, color:T.dæmpet, display:"block", marginBottom:4 }}>
 Deltagere (emails, kommasepareret)
 <HjaelpIkon tekst="Personer der får en invitation. Klientens email er auto-indsat hvis kendt. Tilføj gerne modpart, advokat, myndighed osv." /> </label> <input
 value={dialog.deltagere_tekst || ""}
 onChange={e => setDialog(p => ({ ...p, deltagere_tekst: e.target.value }))}
 placeholder="klient@email.dk, modpart@email.dk"
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"10px 12px", color:T.creme, fontSize:13, boxSizing:"border-box" }}
 /> </div> <div style={{ marginBottom:12 }}> <label style={{ fontSize:11, color:T.dæmpet, display:"block", marginBottom:6 }}>
 I hvilken(s) kalender? *
 <HjaelpIkon tekst="Vælg en eller flere brugeres Outlook-kalendere. Events oprettes i ALLE valgte kalendere. Kan fx være primær + sekundær sagsbehandler — eller en helt tredje bruger hvis du booker for en kollega." /> </label>
 {dialog.kan_ikke_skifte_kalender && (
 <div style={{ fontSize:11, color:"#fbbf24", marginBottom:6 }}>
 Kalendere kan ikke ændres på eksisterende møde. Slet og opret nyt hvis nødvendigt.
 </div>
 )}
 <div style={{ display:"flex", flexWrap:"wrap", gap:6, opacity: dialog.kan_ikke_skifte_kalender ? 0.6 : 1 }}>
 {alle_brugere.map(b => {
 const valgt = (dialog.kalender_bruger_ids || []).includes(b.id);
 return (
 <button key={b.id}
 onClick={() => !dialog.kan_ikke_skifte_kalender && toggleBruger(b.id)}
 disabled={dialog.kan_ikke_skifte_kalender}
 style={{
 padding:"7px 12px", borderRadius:8, fontSize:12,
 cursor: dialog.kan_ikke_skifte_kalender ? "not-allowed" : "pointer",
 fontFamily:"'Inter',system-ui,sans-serif",
 background: valgt ? T.turkis+"25" : "rgba(255,255,255,0.04)",
 border: `1px solid ${valgt ? T.turkis : "rgba(255,255,255,0.08)"}`,
 color: valgt ? T.turkis : T.dæmpet, fontWeight: valgt ? 600 : 400,
 }}>
 {valgt ? " " : ""}{b.navn}
 </button>
 );
 })}
 </div> </div>
 {/* Travlhed-visning */}
 {dialog.kalender_bruger_ids?.length > 0 && travlhed && (
 <div style={{ marginBottom:14, padding:"10px 12px", background:"rgba(255,255,255,0.02)", border:"1px solid rgba(255,255,255,0.06)", borderRadius:8 }}> <div style={{ fontSize:11, color:T.dæmpet, letterSpacing:"0.05em", marginBottom:8 }}>
 Kalender-overblik ({dato}) — rødt = optaget, grønt = valgt møde-tid
 </div>
 {dialog.kalender_bruger_ids.map(bid => {
 const t = travlhed[bid];
 if (!t) return null;
 if (t.fejl) return (
 <div key={bid} style={{ fontSize:11, color:"#fbbf24", marginBottom:6 }}> {t.navn}: kunne ikke hente kalender ({t.status})</div>
 );
 // Tegn en simpel timeline: 48 halvtimer × 30 min (fra 00:00 til 24:00)
 const av = t.availabilityView || "";
 // Beregn selected-slot (hvor møder ligger)
 const [startH, startM] = String(start_tid).split(':').map(Number);
 const [slutH, slutM] = String(slut_tid).split(':').map(Number);
 const start_idx = Math.floor((startH * 60 + startM) / 30);
 const slut_idx = Math.ceil((slutH * 60 + slutM) / 30);
 return (
 <div key={bid} style={{ marginBottom:8 }}> <div style={{ fontSize:11, color:"#cbd5e1", marginBottom:3 }}>{t.navn}</div> <div style={{ display:"flex", height:16, background:"rgba(255,255,255,0.04)", borderRadius:3, overflow:"hidden" }}>
 {Array.from({length: 48}).map((_, i) => {
 const char = av[i] || "0";
 const er_valgt = i >= start_idx && i < slut_idx;
 const busy = char === "1" || char === "2" || char === "3";
 return (
 <div key={i} title={`${Math.floor(i/2).toString().padStart(2,"0")}:${i%2===0?"00":"30"} — ${busy?"optaget":"fri"}`}
 style={{ flex:1,
 background: er_valgt && busy ? "#ff4757"
 : er_valgt ? T.groen
 : busy ? "rgba(255,107,107,0.4)"
 : "transparent",
 borderRight: i===23 ? "1px solid rgba(255,255,255,0.15)" : "none",
 }} />
 );
 })}
 </div> <div style={{ display:"flex", justifyContent:"space-between", fontSize:9, color:"rgba(255,255,255,0.3)", marginTop:2 }}> <span>00</span><span>06</span><span>12</span><span>18</span><span>24</span> </div>
 {(() => {
 const konflikter = av.slice(start_idx, slut_idx).split('').filter(c => c === '1' || c === '2').length;
 if (konflikter > 0) return (
 <div style={{ fontSize:11, color:"#ff4757", marginTop:2, fontWeight:500 }}>
 Konflikt: {konflikter * 30} min optaget i valgt tid
 </div>
 );
 return null;
 })()}
 </div>
 );
 })}
 </div>
 )}
 <div style={{ display:"flex", gap:10 }}>
 {dialog.mode === 'rediger' && (
 <button
 disabled={dialog.loading}
 onClick={async () => {
 if (!window.confirm(`Slet mødet "${dialog.titel}"?\n\nDet fjernes fra BÅDE appen OG alle Outlook-kalendere.`)) return;
 setDialog(p => ({ ...p, loading: true }));
 try {
 const r = await api(`kalender/haendelse/${dialog.haendelse_id}`, "DELETE");
 if (r?.succes) {
 toast(` Møde slettet`, "success");
 if (onSucces) onSucces();
 onClose();
 } else {
 toast(r?.fejl || "Kunne ikke slette", "fejl");
 setDialog(p => ({ ...p, loading:false }));
 }
 } catch (e) { console.error('[Dialog] slet fejl:', e); toast("Fejl — prøv igen", "fejl"); setDialog(p => ({ ...p, loading:false })); }
 }}
 style={{ padding:"10px 16px", borderRadius:8, border:`1px solid ${T.roed}55`, background:`${T.roed}15`, color:T.roed, fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Slet
 </button>
 )}
 <button onClick={onClose}
 style={{ flex:1, padding:"10px", borderRadius:8, border:T.skillelinje, background:"transparent", color:T.dæmpet, fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Annuller
 </button> <button
 disabled={!kan_oprette || dialog.loading}
 onClick={async () => {
 const start = new Date(`${dato}T${start_tid}`);
 const slut = new Date(`${dato}T${slut_tid}`);
 if (isNaN(start.getTime()) || isNaN(slut.getTime()) || slut <= start) {
 toast("Ugyldig tid — slut skal være efter start", "fejl"); return;
 }
 setDialog(p => ({ ...p, loading: true }));
 try {
 const deltagere = (dialog.deltagere_tekst || "").split(/[,;\n]+/).map(e => e.trim()).filter(e => e.includes('@'));
 const er_rediger = dialog.mode === 'rediger';
 const body = {
 sag_id: dialog.sag_id,
 titel: dialog.titel.trim(),
 beskrivelse: dialog.beskrivelse || "",
 lokation: dialog.lokation || "",
 start_tid: start.toISOString(),
 slut_tid: slut.toISOString(),
 kalender_bruger_ids: dialog.kalender_bruger_ids,
 deltagere_emails: deltagere,
 };
 const r = er_rediger
 ? await api(`kalender/haendelse/${dialog.haendelse_id}`, "PATCH", body)
 : await api("kalender/opret", "POST", body);
 if (r?.succes) {
 setDialog(p => ({ ...p, loading:false, resultat:r }));
 toast(er_rediger ? " Møde opdateret" : ` Møde oprettet i ${r.oprettede.length} kalender(e)`, "success");
 if (onSucces) onSucces();
 if (er_rediger) onClose(); // luk direkte ved rediger (ingen resultat-view)
 } else {
 toast(r?.fejl || (er_rediger ? "Kunne ikke opdatere" : "Kunne ikke oprette"), "fejl");
 setDialog(p => ({ ...p, loading:false }));
 }
 } catch (e) {
 console.error('[Dialog] gem fejl:', e);
 toast("Fejl — prøv igen", "fejl");
 setDialog(p => ({ ...p, loading:false }));
 }
 }}
 style={{
 flex:2, padding:"10px", borderRadius:8, border:"none",
 background: kan_oprette && !dialog.loading ? T.turkis : "rgba(255,255,255,0.06)",
 color: kan_oprette && !dialog.loading ? "#fff" : "#64748b",
 fontSize:13, fontWeight:700,
 cursor: kan_oprette && !dialog.loading ? "pointer" : "not-allowed",
 fontFamily:"'Inter',system-ui,sans-serif"
 }}>
 {dialog.loading ? " Gemmer..." : dialog.mode === 'rediger' ? " Gem ændringer" : " Opret møde"}
 </button> </div> </>
 );
}
// ── PERFEKTIONSMÅLER + GUIDE-PILLER til sagsforsiden ───────────────
function GuidePanel({ sag_id }) {
 const [data, setData] = useState(null);
 const [guides, setGuides] = useState([]);
 useEffect(() => {
 if (!sag_id) return;
 api("guide/sag/" + sag_id + "/anbefalinger").then(d => { if (d?.anbefalinger) setData(d); });
 api("guide/sag/" + sag_id + "/kontekst").then(d => { if (d?.guides) setGuides(d.guides); });
 }, [sag_id]);
 if (!data) return null;
 const score = data.sag_status?.score_perfektion || 0;
 const farve = score >= 80 ? "#69db7c" : score >= 50 ? "#ffd43b" : "#ff6b6b";
 return (
 <div className="sv-3d-tilt" style={{ position:"relative", overflow:"hidden", background:"rgba(255,255,255,0.03)", border:`1px solid ${farve}22`, borderRadius:18, padding:"18px 22px", marginBottom:14, backdropFilter:"blur(20px)", WebkitBackdropFilter:"blur(20px)", boxShadow:`0 4px 32px rgba(0,0,0,0.2), 0 0 0 1px ${farve}11 inset` }}>
 {/* Accent strip */}
 <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:`linear-gradient(90deg, ${farve}, ${farve}44, transparent)`, borderRadius:"18px 18px 0 0", pointerEvents:"none" }} />
 {/* Glow orb */}
 <div style={{ position:"absolute", top:-20, right:-20, width:120, height:120, borderRadius:"50%", background:`${farve}12`, filter:"blur(30px)", pointerEvents:"none" }} /> <div style={{ display:"flex", alignItems:"center", gap:16, marginBottom: data.anbefalinger.length > 0 ? 14 : 0 }}>
 {/* Animated score ring */}
 <div style={{ position:"relative", width:64, height:64, flexShrink:0 }}> <svg width="64" height="64" viewBox="0 0 64 64"> <circle cx="32" cy="32" r="26" stroke="rgba(255,255,255,0.06)" strokeWidth="5" fill="none" /> <circle cx="32" cy="32" r="26" stroke={farve} strokeWidth="5" fill="none"
 strokeDasharray={`${(score/100) * 163.4} 163.4`} strokeLinecap="round"
 transform="rotate(-90 32 32)" style={{ transition:"stroke-dasharray 1s cubic-bezier(0.34,1.56,0.64,1)", filter:`drop-shadow(0 0 6px ${farve}66)` }} /> </svg> <div style={{ position:"absolute", inset:0, display:"flex", alignItems:"center", justifyContent:"center" }}> <span style={{ fontSize:16, fontWeight:800, color:farve, letterSpacing:"-0.03em", textShadow:`0 0 10px ${farve}55` }}>{score}</span> </div> </div> <div style={{ flex:1 }}> <div style={{ fontSize:11, color:farve, letterSpacing:"0.12em", textTransform:"uppercase", fontWeight:700, marginBottom:4 }}>Perfektionsmåler</div> <div style={{ fontSize:14, fontWeight:600, color:"#f1f5f9", lineHeight:1.3 }}>
 {score >= 80 ? "Sagen er i god form" : score >= 50 ? "Sagen mangler nogle oplysninger" : "Flere ting mangler — se anbefalinger"}
 </div>
 {/* Score bar */}
 <div style={{ marginTop:8, height:4, background:"rgba(255,255,255,0.06)", borderRadius:2, overflow:"hidden" }}> <div style={{ height:"100%", width:`${score}%`, background:`linear-gradient(90deg, ${farve}88, ${farve})`, borderRadius:2, transition:"width 1s cubic-bezier(0.34,1.56,0.64,1)", boxShadow:`0 0 8px ${farve}44` }} /> </div> </div> </div>
 {data.anbefalinger.length > 0 && (
 <div style={{ display:"flex", flexDirection:"column", gap:5 }}>
 {data.anbefalinger.slice(0, 5).map((a, i) => {
 const p_farve = a.prioritet === "kritisk" ? "#ff6b6b" : a.prioritet === "hoej" ? "#fbbf24" : "#60a5fa";
 return (
 <div key={i} style={{ display:"flex", alignItems:"center", gap:10, padding:"8px 12px", background:"rgba(255,255,255,0.025)", border:`1px solid rgba(255,255,255,0.05)`, borderLeft:`3px solid ${p_farve}`, borderRadius:"0 6px 6px 0", transition:"background 0.15s" }}
 onMouseOver={e=>e.currentTarget.style.background="rgba(255,255,255,0.04)"}
 onMouseOut={e=>e.currentTarget.style.background="rgba(255,255,255,0.025)"}> <div style={{ flex:1 }}> <div style={{ fontSize:13, fontWeight:600, color:"#e2e8f0" }}>{a.titel}</div>
 {a.beskrivelse && <div style={{ fontSize:11, color:"#94a3b8", marginTop:1 }}>{a.beskrivelse}</div>}
 </div> <span style={{ fontSize:10, padding:"2px 8px", borderRadius:10, background:`${p_farve}20`, color:p_farve, textTransform:"uppercase", letterSpacing:"0.06em", fontWeight:700, flexShrink:0 }}>{a.prioritet}</span> </div>
 );
 })}
 </div>
 )}
 </div>
 );
}
function UploadLinksPanel({ sag }) {
 const panel = { background:"rgba(255,255,255,0.06)", border:T.kort_kant, borderRadius:16, backdropFilter:"blur(20px)", WebkitBackdropFilter:"blur(20px)" };
 const [tokens, setTokens] = React.useState([]);
 const [lader, setLader] = React.useState(true);
 const [opretter, setOpretter] = React.useState(false);
 const [kopiert_id, setKopiertId] = React.useState(null);
 // FEJL-009-fix: portal-nøgle — ingen UI fandtes for POST /api/portal/generer-noegle,
 // selvom endpointet var fuldt funktionelt (kun tilgængeligt via direkte API-kald).
 const [portal_genererer, setPortalGenererer] = React.useState(false);
 const [portal_resultat, setPortalResultat] = React.useState(null); // { noegle, link, udloeber, levetid_dage }
 const [portal_kopieret, setPortalKopieret] = React.useState(false);

 const hent = React.useCallback(() => {
   setLader(true);
   api('upload-portal/sag/' + sag.id)
     .then(d => { setTokens(d.tokens || []); setLader(false); })
     .catch(() => setLader(false));
 }, [sag.id]);

 React.useEffect(() => { hent(); }, [hent]);

 async function opret_link() {
   const besked = window.prompt('Valgfri besked til klienten (lad stå tom for ingen besked):');
   if (besked === null) return;
   setOpretter(true);
   try {
     const d = await api('upload-portal/opret', 'POST', { sag_id: sag.id, besked: besked || null });
     if (d.upload_url) {
       await navigator.clipboard.writeText(d.upload_url).catch(() => {});
       alert('Upload-link oprettet og kopieret:\n\n' + d.upload_url);
     }
     hent();
   } catch (e) {
     alert('Kunne ikke oprette link: ' + (e.message || 'ukendt fejl'));
   } finally {
     setOpretter(false);
   }
 }

 async function deaktiver(token_id) {
   if (!window.confirm('Deaktiver dette upload-link?')) return;
   await api('upload-portal/token/' + token_id, 'DELETE').catch(() => {});
   hent();
 }

 async function kopier(url, id) {
   await navigator.clipboard.writeText(url).catch(() => {});
   setKopiertId(id);
   setTimeout(() => setKopiertId(null), 2000);
 }

 // FEJL-009-fix: genererer/roterer klientens portal-nøgle (POST /api/portal/generer-noegle)
 // og viser den i en kopiérbar boks — ingen UI-indgang fandtes tidligere.
 async function generer_portal_noegle() {
   setPortalGenererer(true);
   setPortalKopieret(false);
   try {
     const d = await api('portal/generer-noegle', 'POST', { klient_id: sag.klient_id, sag_id: sag.id });
     if (d?.noegle) setPortalResultat(d);
     else alert('Kunne ikke generere portal-nøgle: ' + (d?.fejl || 'ukendt fejl'));
   } catch (e) {
     alert('Kunne ikke generere portal-nøgle: ' + (e.message || 'ukendt fejl'));
   } finally {
     setPortalGenererer(false);
   }
 }

 const app_url = window.location.origin;
 const portal_url = portal_resultat ? `${app_url}/portal?noegle=${portal_resultat.noegle}` : '';
 async function kopier_portal_url() {
   await navigator.clipboard.writeText(portal_url).catch(() => {});
   setPortalKopieret(true);
   setTimeout(() => setPortalKopieret(false), 2000);
 }

 return (
 <div className="sv-panel-animated" style={{ animationDelay:"0.05s" }}>
   <div style={{ ...panel, padding:"20px", marginBottom:14, position:"relative", overflow:"hidden" }}>
     <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:`linear-gradient(90deg, ${T.turkis}, #60a5fa44, transparent)`, borderRadius:"16px 16px 0 0", pointerEvents:"none" }} />
     <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
       <div>
         <div style={{ fontSize:13, fontWeight:700, color:T.turkis, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:2 }}>📥 Upload-links</div>
         <div style={{ fontSize:12, color:T.dæmpet }}>Generer sikre links til klienten til upload af dokumenter</div>
       </div>
       <button onClick={opret_link} disabled={opretter} style={{ background:`linear-gradient(135deg, ${T.turkis}, #2ca89f)`, border:"none", borderRadius:9, padding:"9px 18px", color:"#04150f", fontSize:12, fontWeight:700, cursor: opretter ? "default" : "pointer", opacity: opretter ? 0.7 : 1, fontFamily:"'Inter',system-ui,sans-serif" }}>
         {opretter ? "Opretter…" : "+ Opret link"}
       </button>
     </div>
     {/* FEJL-009-fix: portal-nøgle-generering — separat fra upload-links ovenfor */}
     <div style={{ borderTop:"1px solid rgba(255,255,255,0.07)", marginTop:4, paddingTop:14 }}>
       <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10, gap:12, flexWrap:"wrap" }}>
         <div>
           <div style={{ fontSize:13, fontWeight:700, color:T.turkis, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:2 }}>🔑 Klientportal-nøgle</div>
           <div style={{ fontSize:12, color:T.dæmpet }}>Generer/roter adgang til klientens sagsoverblik i klientportalen</div>
         </div>
         <button onClick={generer_portal_noegle} disabled={portal_genererer} style={{ background:`linear-gradient(135deg, ${T.turkis}, #2ca89f)`, border:"none", borderRadius:9, padding:"9px 18px", color:"#04150f", fontSize:12, fontWeight:700, cursor: portal_genererer ? "default" : "pointer", opacity: portal_genererer ? 0.7 : 1, fontFamily:"'Inter',system-ui,sans-serif", whiteSpace:"nowrap" }}>
           {portal_genererer ? "Genererer…" : "Generer portal-nøgle"}
         </button>
       </div>
       {portal_resultat && (
         <div style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:10, padding:"12px 16px", marginBottom:4 }}>
           <div style={{ display:"flex", alignItems:"center", gap:10 }}>
             <input readOnly value={portal_url} onFocus={e => e.target.select()} style={{ flex:1, minWidth:0, background:"rgba(0,0,0,0.25)", border:"1px solid rgba(255,255,255,0.1)", borderRadius:7, padding:"7px 10px", color:T.creme, fontSize:12, fontFamily:"monospace" }} />
             <button onClick={kopier_portal_url} style={{ background: portal_kopieret ? "rgba(52,211,153,0.15)" : "rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.12)", borderRadius:7, color: portal_kopieret ? "#34d399" : T.creme, fontSize:11, padding:"7px 12px", cursor:"pointer", flexShrink:0 }}>
               {portal_kopieret ? "✓ Kopieret" : "Kopiér"}
             </button>
           </div>
           <div style={{ fontSize:11, color:T.dæmpet, marginTop:6 }}>
             Nøgle: <span style={{ fontFamily:"monospace" }}>{portal_resultat.noegle}</span> · Udløber {portal_resultat.udloeber}
             {portal_resultat.levetid_dage ? ` (${portal_resultat.levetid_dage} dage)` : ""}
           </div>
         </div>
       )}
     </div>
     <div style={{ borderTop:"1px solid rgba(255,255,255,0.07)", marginTop:14, paddingTop:14 }}>
     {lader ? (
       <div style={{ color:T.dæmpet, fontSize:13, textAlign:"center", padding:"20px 0" }}>Henter…</div>
     ) : tokens.length === 0 ? (
       <div style={{ color:T.dæmpet, fontSize:13, textAlign:"center", padding:"20px 0" }}>Ingen upload-links endnu. Opret et link og send det til klienten.</div>
     ) : tokens.map(t => {
       const url = app_url + '/upload/' + t.token;
       const udloebet = t.udloebet ? new Date(t.udloebet) < new Date() : false;
       return (
         <div key={t.id} style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:10, padding:"12px 16px", marginBottom:8, display:"flex", alignItems:"center", gap:12 }}>
           <div style={{ flex:1, minWidth:0 }}>
             <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:4 }}>
               <span style={{ fontSize:11, fontWeight:700, padding:"2px 7px", borderRadius:10, background: t.aktiv && !udloebet ? "rgba(52,211,153,0.12)" : "rgba(255,255,255,0.05)", color: t.aktiv && !udloebet ? "#34d399" : "#64748b", border: `1px solid ${t.aktiv && !udloebet ? "rgba(52,211,153,0.25)" : "rgba(255,255,255,0.08)"}` }}>
                 {!t.aktiv ? "Deaktiveret" : udloebet ? "Udløbet" : "Aktiv"}
               </span>
               <span style={{ fontSize:11, color:T.dæmpet }}>{t.antal_uploads || 0} upload{t.antal_uploads !== 1 ? "s" : ""}</span>
               <span style={{ fontSize:11, color:T.dæmpet }}>· Oprettet {new Date(t.created_at).toLocaleDateString('da-DK')}</span>
             </div>
             <div style={{ fontSize:12, color:"#94a3b8", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{url}</div>
             {t.besked && <div style={{ fontSize:11, color:T.dæmpet, marginTop:3, fontStyle:"italic" }}>"{t.besked}"</div>}
           </div>
           <div style={{ display:"flex", gap:6, flexShrink:0 }}>
             <button onClick={() => kopier(url, t.id)} style={{ background: kopiert_id===t.id ? "rgba(52,211,153,0.15)" : "rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.12)", borderRadius:7, color: kopiert_id===t.id ? "#34d399" : T.creme, fontSize:11, padding:"5px 10px", cursor:"pointer" }}>
               {kopiert_id===t.id ? "✓ Kopieret" : "Kopiér"}
             </button>
             {t.aktiv && !udloebet && (
               <button onClick={() => deaktiver(t.id)} style={{ background:"rgba(251,113,133,0.08)", border:"1px solid rgba(251,113,133,0.2)", borderRadius:7, color:"#fb7185", fontSize:11, padding:"5px 10px", cursor:"pointer" }}>Deaktivér</button>
             )}
           </div>
         </div>
       );
     })}
     </div>
   </div>
 </div>
 );
}

// ─────────────────────────────────────────────────────────
// AI-SØGNING PÅ SAGEN — udtrukket fra aktiv_tab==="haendelser" (René
// 24/10: samme søgefunktion skal også være tilgængelig i Sagsakter).
// Ingen adfærdsændring for Hændelser-fanen — ren udtrækning af den
// eksisterende JSX/logik til en delt lokal komponent, kaldt fra begge
// faner nedenfor med den samme søgestate (ai_soeg_*), så et svar følger
// med ved fane-skift i stedet for at nulstilles.
// ─────────────────────────────────────────────────────────
function AiSoegningBoks({ valgt, ai_soeg_spg, setAiSoegSpg, ai_soeg_loader, setAiSoegLoader, ai_soeg_svar, setAiSoegSvar }) {
 const soeg = async () => {
 if (!ai_soeg_spg.trim() || ai_soeg_loader) return;
 setAiSoegLoader(true); setAiSoegSvar(null);
 const r = await api("ai-sag/soeg", "POST", { sag_id: valgt.id, spørgsmål: ai_soeg_spg });
 if (r?.svar != null) { setAiSoegSvar(r); setAiSoegLoader(false); }
 else if (r?.opgave_id) pollAiOpgave(r.opgave_id, d => { setAiSoegSvar(d); setAiSoegLoader(false); }, () => setAiSoegLoader(false));
 else setAiSoegLoader(false);
 };
 return (
 <div style={{ position:"relative", overflow:"hidden", background:"rgba(63,212,199,0.05)", border:`1px solid ${T.turkis}33`, borderRadius:18, padding:"16px 18px", marginBottom:14, boxShadow:`0 0 40px rgba(63,212,199,0.06), inset 0 1px 0 rgba(63,212,199,0.08)` }}>
 {/* Accent strip */}
 <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:`linear-gradient(90deg, ${T.turkis}, ${T.turkis}44, transparent)`, borderRadius:"18px 18px 0 0", pointerEvents:"none" }} />
 {/* Ambient glow */}
 <div style={{ position:"absolute", top:-20, right:20, width:120, height:120, borderRadius:"50%", background:`${T.turkis}08`, filter:"blur(30px)", pointerEvents:"none" }} /> <div style={{ position:"relative", fontSize:12, color:T.turkis, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:10, display:"flex", alignItems:"center", gap:6 }}>
 AI-søgning på sagen
 <span style={{ fontSize:12, color:T.dæmpet, textTransform:"none", letterSpacing:"normal" }}>— stil et spørgsmål om hændelserne</span> </div> <div style={{ display:"flex", gap:8 }}> <input
 value={ai_soeg_spg}
 onChange={e => setAiSoegSpg(e.target.value)}
 onKeyDown={e => { if (e.key === "Enter") soeg(); }}
 placeholder='Fx "Hvad sagde Familieretshuset om samvær?" eller "Hvornår var seneste møde?"'
 spellCheck="true" lang="da"
 className="sv-input"
 style={{ flex:1, background:"rgba(8,12,30,0.65)", border:`1px solid ${ai_soeg_spg ? T.turkis+"44" : "rgba(255,255,255,0.07)"}`, borderRadius:9, padding:"10px 14px", color:"#e2e8f0", fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", transition:"all 0.25s cubic-bezier(0.4,0,0.2,1)" }}
 /> <button
 onClick={soeg}
 disabled={ai_soeg_loader || !ai_soeg_spg.trim()}
 style={{ background: ai_soeg_loader ? "rgba(63,212,199,0.2)" : T.turkis, border:"none", borderRadius:9, padding:"10px 18px", color:"#ffffff", fontWeight:700, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", cursor:ai_soeg_loader||!ai_soeg_spg.trim()?"not-allowed":"pointer", opacity:!ai_soeg_spg.trim()?0.4:1, whiteSpace:"nowrap" }}>
 {ai_soeg_loader ? "" : "Spørg →"}
 </button> </div>
 {ai_soeg_svar && (
 <div style={{ marginTop:12, animation:"fadeUp 0.25s ease" }}> <div style={{ fontSize:13, color:"#e2e8f0", lineHeight:1.75, whiteSpace:"pre-wrap", marginBottom: ai_soeg_svar.relevante_haendelser?.length > 0 ? 10 : 0 }}>{ai_soeg_svar.svar}</div>
 {ai_soeg_svar.relevante_haendelser?.length > 0 && (
 <div style={{ display:"flex", flexWrap:"wrap", gap:6 }}>
 {ai_soeg_svar.relevante_haendelser.map(h => (
 <span key={h.id} style={{ fontSize:12, padding:"3px 10px", borderRadius:5, background:"rgba(63,212,199,0.1)", border:`1px solid ${T.turkis}33`, color:T.turkis }}>
 {h.dato} — {h.titel}
 </span>
 ))}
 </div>
 )}
 <button onClick={() => { setAiSoegSvar(null); setAiSoegSpg(""); }} style={{ marginTop:8, background:"none", border:"none", color:T.dæmpet, fontSize:12, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif", padding:0 }}>
 × Ryd svar
 </button> </div>
 )}
 </div>
 );
}

function OneDriveFiler({ sag }) {
 // René (24/10): samme søgefunktion som i Hændelser (SagsTidslinje.jsx)
 // skal også findes i Sagsakter — filtrerer den allerede hentede filliste
 // for den valgte kategori på filnavn, ingen ekstra API-kald.
 const [fil_søg, setFilSøg] = useState("");
 // René (24/10): "filtrene skal fungere som i Hændelser" — samme 4
 // dimensionsfiltre (retning/part/type/status), samme client-side mønster.
 const [filter_retning, setFilterRetning] = useState("");
 const [filter_part, setFilterPart] = useState("");
 const [filter_dim_type, setFilterDimType] = useState("");
 const [filter_dim_status, setFilterDimStatus] = useState("");
 const [filer, setFiler] = useState([]);
 const [indlæser, setIndlæser] = useState(false);
 const [uploader, setUploader] = useState(false);
 const [fejl, setFejl] = useState(null);
 const fil_ref = useRef(null);
 const aktiv_request = useRef(0);
 const [aktiv_preview, setAktivPreview] = React.useState(null);
 const [preview_blob, setPreviewBlob] = React.useState(null);
 const [preview_lader, setPreviewLader] = React.useState(false);
 React.useEffect(() => { return () => { if (preview_blob) URL.revokeObjectURL(preview_blob); }; }, [preview_blob]);
 const åbn_preview = async (f) => {
   const _m = (f.mime_type || '').toLowerCase(); const _n = (f.original_navn || f.visningsnavn || '').toLowerCase();
   const er_visbar = _m.includes('pdf') || _n.endsWith('.pdf') || _m.includes('image') || !!_n.match(/\.(jpg|jpeg|png|gif|webp)$/) || _m.includes('video') || !!_n.match(/\.(mp4|mov|webm)$/) || _m.includes('audio') || !!_n.match(/\.(mp3|wav|ogg|m4a)$/);
   setPreviewBlob(null); setAktivPreview(f);
   if (er_visbar) { setPreviewLader(true); try { const res = await fetch('/api/filer/' + f.id + '/stream', { credentials: 'include' }); const blob = await res.blob(); setPreviewBlob(URL.createObjectURL(blob)); } catch(e) {} setPreviewLader(false); }
 };
 const luk_preview = () => { setAktivPreview(null); if (preview_blob) { URL.revokeObjectURL(preview_blob); setPreviewBlob(null); } };
 const hent_filer = React.useCallback(async () => {
 if (!sag?.id) return;
 const req_id = ++aktiv_request.current;
 setIndlæser(true); setFejl(null);
 const data = await api(`filer/sag/${sag.id}`);
 if (aktiv_request.current !== req_id) return;
 if (data?.filer) setFiler(data.filer);
 else if (data?.fejl) setFejl(data.fejl);
 setIndlæser(false);
 }, [sag?.id]);
 useEffect(() => { hent_filer(); }, [hent_filer]);
 const [upload_progress, setUploadProgress] = useState(null); // null | 0-100
 const upload_fil = async (e) => {
 const fil = e.target.files?.[0];
 if (!fil) return;
 // Filstørrelse-validering (max 500MB — video/lyd)
 const MAX_MB = 500;
 if (fil.size > MAX_MB * 1024 * 1024) {
 setFejl(`Filen er for stor (${(fil.size/1024/1024).toFixed(1)} MB). Maks ${MAX_MB} MB.`);
 e.target.value = "";
 return;
 }
 // René (25/10): uploads havner nu i en mappe med samme navn som det
 // aktive type-filter (i stedet for en separat kategori-knap) — fallback
 // til "Journal" når intet type-filter er valgt.
 const kategori = filter_dim_type || "Journal";
 setUploader(true); setFejl(null); setUploadProgress(0);
 try {
 // 1. Hent upload-session fra korrekt endpoint (filer/upload-session)
 const session = await api("filer/upload-session", "POST", {
 sag_id: sag.id,
 kategori,
 filnavn: fil.name,
 visningsnavn: fil.name,
 });
 if (!session?.upload_url) throw new Error(session?.fejl || "Kunne ikke starte upload");
 setUploadProgress(20);
 // 2. Upload til OneDrive (chunked for store filer)
 await onedrive_upload(session.upload_url, fil, (pct) => setUploadProgress(20 + Math.round(pct * 0.5)));
 setUploadProgress(70);
 // 3. Registrer fil i databasen (så den er søgbar, sporbar, leveringsstyret)
 const reg = await api("filer/registrer", "POST", {
 sag_id: sag.id,
 kategori,
 original_navn: fil.name,
 visningsnavn: fil.name,
 størrelse: fil.size,
 mime_type: fil.type,
 onedrive_sti: session.onedrive_sti,
 });
 if (reg?.fejl) console.error("Registrering fejl:", reg.fejl);
 setUploadProgress(100);
 // 4. Opdatér filliste
 await hent_filer();
 } catch (err) {
 setFejl("Upload fejlede — prøv igen"); console.error("[UPLOAD] fejl:", err);
 }
 setUploader(false); setUploadProgress(null);
 if (e.target) e.target.value = "";
 };
 const fmt_størrelse = b => b < 1048576 ? (b/1024).toFixed(0)+" KB" : (b/1048576).toFixed(1)+" MB";
 const fmt_dato = d => new Date(d).toLocaleDateString("da-DK", { day:"numeric", month:"short", year:"numeric" });
 const fil_ikon = type => type?.includes("pdf") ? "" : type?.includes("image") ? "" : type?.includes("word") || type?.includes("document") ? "" : type?.includes("excel") || type?.includes("sheet") ? "" : type?.includes("video") ? "" : type?.includes("audio") ? "" : "";
 const filer_vist = React.useMemo(() => {
 const q = fil_søg.trim().toLowerCase();
 return filer.filter(f => {
 if (q && !((f.visningsnavn || f.original_navn || f.navn || "").toLowerCase().includes(q))) return false;
 if (filter_retning && f.retning !== filter_retning) return false;
 if (filter_part && f.part !== filter_part) return false;
 if (filter_dim_type && fil_kategori_fra_sti(f.onedrive_sti).toLowerCase() !== filter_dim_type.toLowerCase()) return false;
 if (filter_dim_status && f.haendelse_status !== filter_dim_status) return false;
 return true;
 });
 }, [filer, fil_søg, filter_retning, filter_part, filter_dim_type, filter_dim_status]);
 const har_aktive_dim_filtre = filter_retning || filter_part || filter_dim_type || filter_dim_status;
 const dim_filter_sel = { background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.09)", borderRadius:7, padding:"6px 10px", color:T.dæmpet, fontSize:12, fontFamily:"'Inter',system-ui,sans-serif", colorScheme:"dark", cursor:"pointer" };
 return (
 <div> <input ref={fil_ref} type="file" onChange={upload_fil} style={{ display:"none" }}
 accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.xlsx,.xls,.mp4,.mp3,.wav" />
 {/* Dimensionsfiltre — samme 4 filtre som Hændelser (retning/part/type/status).
 René (25/10): erstatter de gamle kategori-knapper helt — "type" styrer nu
 også hvilken OneDrive-mappe nye uploads havner i (se upload_fil). */}
 <div style={{ display:"flex", flexWrap:"wrap", gap:6, marginBottom:10, padding:"10px 12px", background:"rgba(63,212,199,0.04)", border:`1px solid ${T.turkis}18`, borderRadius:9 }}>
 <select style={{...dim_filter_sel, color: filter_retning ? T.turkis : T.dæmpet, border: filter_retning ? `1px solid ${T.turkis}55` : dim_filter_sel.border }} value={filter_retning} onChange={e => setFilterRetning(e.target.value)}>
 <option value="">Alle retninger</option>
 {DIM_RETNINGER.map(v => <option key={v} value={v}>{v}</option>)}
 </select>
 <select style={{...dim_filter_sel, color: filter_part ? T.turkis : T.dæmpet, border: filter_part ? `1px solid ${T.turkis}55` : dim_filter_sel.border }} value={filter_part} onChange={e => setFilterPart(e.target.value)}>
 <option value="">Alle parter</option>
 {DIM_PARTER.map(v => <option key={v} value={v}>{v}</option>)}
 </select>
 <select style={{...dim_filter_sel, color: filter_dim_type ? T.turkis : T.dæmpet, border: filter_dim_type ? `1px solid ${T.turkis}55` : dim_filter_sel.border }} value={filter_dim_type} onChange={e => setFilterDimType(e.target.value)}>
 <option value="">Alle typer</option>
 {DIM_TYPER.map(v => <option key={v} value={v}>{v}</option>)}
 </select>
 <select style={{...dim_filter_sel, color: filter_dim_status ? T.turkis : T.dæmpet, border: filter_dim_status ? `1px solid ${T.turkis}55` : dim_filter_sel.border }} value={filter_dim_status} onChange={e => setFilterDimStatus(e.target.value)}>
 <option value="">Alle statusser</option>
 {DIM_STATUSSER.map(v => <option key={v} value={v}>{v}</option>)}
 </select>
 {har_aktive_dim_filtre && (
 <button onClick={() => { setFilterRetning(""); setFilterPart(""); setFilterDimType(""); setFilterDimStatus(""); }} style={{ background:"rgba(251,113,133,0.1)", border:"1px solid rgba(251,113,133,0.3)", borderRadius:7, padding:"6px 10px", color:T.roed, fontSize:12, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Nulstil filtre
 </button>
 )}
 </div>
 {/* Søgefelt — samme søgefunktion som Hændelser (SagsTidslinje.jsx) */}
 <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:12 }}>
 <div style={{ position:"relative", flex:1 }}> <span style={{ position:"absolute", left:12, top:"50%", transform:"translateY(-50%)", fontSize:14, color:T.dæmpet, pointerEvents:"none", userSelect:"none" }}></span> <input
 value={fil_søg}
 onChange={e => setFilSøg(e.target.value)}
 placeholder="Søg i sagsakter... (filnavn)"
 style={{
 width:"100%", boxSizing:"border-box",
 background:"rgba(255,255,255,0.06)",
 border: fil_søg ? `1px solid ${T.turkis}80` : "1px solid rgba(255,255,255,0.12)",
 borderRadius:8, padding:"8px 14px 8px 38px",
 color:"#e2e8f0", fontSize:13, fontFamily:"'Inter',system-ui,sans-serif",
 outline:"none", transition:"border-color 0.2s, box-shadow 0.2s",
 boxShadow: fil_søg ? `0 0 0 3px ${T.turkis}1f` : "none",
 }}
 /> {fil_søg && (
 <button onClick={() => setFilSøg("")} style={{ position:"absolute", right:10, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", color:T.dæmpet, cursor:"pointer", fontSize:14, padding:"2px 4px" }}></button>
 )} </div>
 {fil_søg && (
 <span style={{ fontSize:11, color:T.dæmpet, whiteSpace:"nowrap" }}>{filer_vist.length} af {filer.length}</span>
 )}
 </div>
 {/* Header med upload knap */}
 <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase" }}>
 {filter_dim_type || "Alle filer"} {!indlæser && `— ${filer_vist.length} fil${filer_vist.length !== 1 ? "er" : ""}`}
 </div> <div style={{ display:"flex", gap:8 }}> <button onClick={() => hent_filer()} style={{ background:"none", border:T.skillelinje, borderRadius:7, padding:"6px 12px", color:T.dæmpet, fontSize:12, fontFamily:"'Inter',system-ui,sans-serif", cursor:"pointer" }}>
 ↻ Opdatér
 </button> <button onClick={() => fil_ref.current?.click()} disabled={uploader} style={{
 background:uploader?"rgba(63,212,199,0.2)":T.turkis, border:"none", borderRadius:7,
 padding:"6px 14px", color:"#ffffff", fontSize:12, fontWeight:700,
 fontFamily:"'Inter',system-ui,sans-serif", cursor:uploader?"wait":"pointer",
 }}>
 {uploader ? " Uploader..." : "+ Upload fil"}
 </button> </div> </div>
 {/* Upload progress */}
 {upload_progress !== null && (
 <div style={{ marginBottom:12 }}> <div style={{ display:"flex", justifyContent:"space-between", fontSize:12, color:T.dæmpet, marginBottom:4 }}> <span>Uploader...</span><span>{upload_progress}%</span> </div> <div style={{ height:4, background:"rgba(0,0,0,0.1)", borderRadius:2, overflow:"hidden" }}> <div style={{ height:"100%", width:upload_progress+"%", background:T.turkis, borderRadius:2, transition:"width 0.3s ease" }} /> </div> </div>
 )}
 {fejl && (
 <div style={{ background:"rgba(255,107,107,0.08)", border:"1px solid rgba(255,107,107,0.25)", borderRadius:8, padding:"10px 14px", marginBottom:12, fontSize:12, color:T.roed }}>
 {fejl}
 </div>
 )}
 {/* Filliste */}
 {indlæser ? (
 <div style={{ textAlign:"center", padding:"28px", color:T.dæmpet, fontSize:13 }}>Henter filer fra OneDrive...</div>
 ) : filer_vist.length === 0 ? (
 (fil_søg || har_aktive_dim_filtre) ? (
 <div style={{ background:"rgba(8,12,30,0.6)", border:"1px dashed rgba(255,255,255,0.08)", borderRadius:16, padding:"32px", textAlign:"center" }}> <div style={{ fontSize:32, marginBottom:10 }}></div> <div style={{ color:T.lys, fontSize:13, marginBottom:6 }}>{fil_søg ? `Ingen filer matcher "${fil_søg}"` : "Ingen filer matcher de valgte filtre"}</div> <div style={{ color:T.dæmpet, fontSize:12 }}>Prøv et andet søgeord eller filter, eller ryd søgningen/filtrene</div> </div>
 ) : (
 <div style={{ background:"rgba(8,12,30,0.6)", border:"1px dashed rgba(255,255,255,0.08)", borderRadius:16, padding:"32px", textAlign:"center" }}
 onDragOver={e => e.preventDefault()}
 onDrop={e => { e.preventDefault(); const f = e.dataTransfer.files[0]; if (f) { const dt = new DataTransfer(); dt.items.add(f); fil_ref.current.files = dt.files; upload_fil({ target: { files: [f], value: "" } }); }}}> <div style={{ fontSize:32, marginBottom:10 }}></div> <div style={{ color:T.lys, fontSize:13, marginBottom:6 }}>Ingen filer endnu på sagen</div> <div style={{ color:T.dæmpet, fontSize:12 }}>Klik "+ Upload fil" eller træk filer hertil</div> </div>
 )
 ) : (
 <div style={{ position:"relative", background:"rgba(8,12,30,0.55)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:16, overflow:"hidden", backdropFilter:"blur(16px)", WebkitBackdropFilter:"blur(16px)" }}> <div style={{ position:"absolute", top:0, left:0, right:0, height:2, background:`linear-gradient(90deg, ${T.turkis}55, ${T.turkis}22, transparent)`, pointerEvents:"none", zIndex:1 }} />
 {filer_vist.map((f, i) => (
 <div key={f.id} className="sv-card-pop" style={{ padding:"12px 16px", borderBottom:i<filer_vist.length-1?T.skillelinje:"none", display:"flex", alignItems:"center", gap:12, animationDelay:`${i*0.04}s`, transition:"background 0.15s" }}
 onMouseOver={e=>e.currentTarget.style.background="rgba(63,212,199,0.04)"}
 onMouseOut={e=>e.currentTarget.style.background="transparent"}> <span style={{ fontSize:22, flexShrink:0 }}>{fil_ikon(f.mime_type || f.type)}</span> <div style={{ flex:1, minWidth:0 }}> <div style={{ fontSize:13, color:T.creme, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{f.visningsnavn || f.original_navn || f.navn}</div> <div style={{ fontSize:12, color:T.dæmpet, marginTop:2 }}>
 {fmt_størrelse(f.størrelse)} · {fmt_dato(f.uploadet_dato || f.ændret)}
 {f.haendelse_titel && <span> · Fra: {f.haendelse_titel}</span>}
 {f.sidst_redigeret_dato && <span style={{ color:"#a78bfa", marginLeft:6 }}>✏️ Redigeret {fmt_dato(f.sidst_redigeret_dato)}{f.sidst_redigeret_navn ? ' af ' + f.sidst_redigeret_navn : ''}</span>}
 </div> </div> <div style={{ display:"flex", gap:6, flexShrink:0 }}>
 <button onClick={() => åbn_preview(f)}
   style={{ background:"rgba(167,139,250,0.12)", border:"1px solid rgba(167,139,250,0.3)", borderRadius:6, padding:"5px 10px", color:"#a78bfa", fontSize:12, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
   Åbn
 </button>
 {(f.download_url || f.onedrive_sti) && (
 <a href={f.download_url || "#"} target="_blank" rel="noreferrer"
   style={{ background:"rgba(63,212,199,0.1)", border:`1px solid ${T.turkis}33`, borderRadius:6, padding:"5px 10px", color:T.turkis, fontSize:12, textDecoration:"none", fontFamily:"'Inter',system-ui,sans-serif" }}>
   ↓ Download
 </a>
 )}
 </div> </div>
 ))}
 </div>
 )}
 {aktiv_preview && require("react-dom").createPortal(
 <div style={{ position:"fixed", top:0, left:0, width:"100vw", height:"100vh", background:"rgba(0,0,0,0.92)", zIndex:99999 }} onClick={luk_preview}>
 <div style={{ position:"absolute", top:0, left:0, right:0, height:48, padding:"0 20px", display:"flex", justifyContent:"space-between", alignItems:"center", background:"rgba(0,0,0,0.6)", zIndex:1 }} onClick={e => e.stopPropagation()}>
 <div style={{ color:"#e2e8f0", fontSize:14, fontWeight:500, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", flex:1, marginRight:16 }}>{aktiv_preview.visningsnavn || aktiv_preview.original_navn}</div>
 <div style={{ display:"flex", gap:10, alignItems:"center", flexShrink:0 }}>
 {aktiv_preview.web_url && (() => { const _m = (aktiv_preview.mime_type || '').toLowerCase(); const _n = (aktiv_preview.visningsnavn || aktiv_preview.original_navn || '').toLowerCase(); const er_word_prev = _m.includes('word') || !!_n.match(/\.(doc|docx)$/); return er_word_prev; })() && (
   <button onClick={(e) => { e.stopPropagation(); fetch('/api/filer/' + aktiv_preview.id + '/rediger', { method:'POST', headers:{'Content-Type':'application/json'} }).catch(()=>{}); const er_mobil = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent); const url = er_mobil ? aktiv_preview.web_url : 'ms-word:ofe|u|' + aktiv_preview.web_url; window.open(url, '_blank'); }}
     style={{ color:"#fff", fontSize:12, padding:"6px 14px", border:"none", borderRadius:6, background:"rgba(167,139,250,0.75)", cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif", fontWeight:600 }}>✏️ Rediger</button>
 )}
 <button onClick={(e) => { e.stopPropagation(); window.open(aktiv_preview.web_url || '/api/filer/' + aktiv_preview.id + '/stream', '_blank'); }}
   style={{ color:"#a78bfa", fontSize:12, padding:"6px 14px", border:"1px solid rgba(167,139,250,0.3)", borderRadius:6, background:"none", cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>Åbn i nyt vindue</button>
 {aktiv_preview.download_url && (
   <a href={aktiv_preview.download_url} target="_blank" rel="noreferrer"
     style={{ color:"#3fd4c7", fontSize:12, textDecoration:"none", padding:"6px 14px", border:"1px solid rgba(63,212,199,0.3)", borderRadius:6 }}>↓ Download</a>
 )}
 <button onClick={luk_preview}
   style={{ background:"rgba(255,255,255,0.1)", border:"none", borderRadius:6, padding:"6px 14px", color:"#fff", fontSize:16, cursor:"pointer", fontWeight:700 }}>✕</button>
 </div>
 </div>
 <div style={{ position:"absolute", top:48, left:10, right:10, bottom:10 }} onClick={e => e.stopPropagation()}>
 {preview_lader && <div style={{ color:"#e2e8f0", textAlign:"center", paddingTop:60, fontSize:14 }}>⏳ Henter fil...</div>}
 {!preview_lader && (() => {
   const _m = (aktiv_preview.mime_type || '').toLowerCase();
   const _n = (aktiv_preview.original_navn || '').toLowerCase();
   const er_pdf = _m.includes('pdf') || _n.endsWith('.pdf');
   const er_billede = _m.includes('image') || !!_n.match(/\.(jpg|jpeg|png|gif|webp)$/);
   const er_video = _m.includes('video') || !!_n.match(/\.(mp4|mov|webm)$/);
   const er_lyd = _m.includes('audio') || !!_n.match(/\.(mp3|wav|ogg|m4a)$/);
   const er_word = _m.includes('word') || !!_n.match(/\.(doc|docx)$/);
   if (preview_blob) {
     if (er_pdf) return <iframe src={preview_blob} style={{ width:"100%", height:"100%", border:"none", borderRadius:8, background:"#fff" }} title={aktiv_preview.visningsnavn} />;
     if (er_billede) return <img src={preview_blob} alt={aktiv_preview.visningsnavn} style={{ width:"100%", height:"100%", objectFit:"contain" }} />;
     if (er_video) return <video controls src={preview_blob} style={{ width:"100%", height:"100%", objectFit:"contain", background:"#000", borderRadius:8 }} />;
     if (er_lyd) return <audio controls src={preview_blob} style={{ width:"100%", maxWidth:"100%", height:36, marginTop:20 }} />;
   }
   if (er_word && aktiv_preview.download_url) return <iframe src={"https://view.officeapps.live.com/op/embed.aspx?src=" + encodeURIComponent(aktiv_preview.download_url)} style={{ width:"100%", height:"100%", border:"none", borderRadius:8, background:"#fff" }} title={aktiv_preview.visningsnavn} />;
   if (er_word && aktiv_preview.web_url) return <iframe src={aktiv_preview.web_url} style={{ width:"100%", height:"100%", border:"none", borderRadius:8, background:"#fff" }} title={aktiv_preview.visningsnavn} />;
   return <div style={{ color:"#e2e8f0", textAlign:"center", paddingTop:80, fontSize:14 }}><div style={{ fontSize:48, marginBottom:16 }}>📄</div><div>Denne filtype kan ikke vises som preview</div><div style={{ marginTop:8, color:"#94a3b8", fontSize:12 }}>Brug ↓ Download for at åbne filen</div><button onClick={() => window.open(aktiv_preview.web_url || '/api/filer/' + aktiv_preview.id + '/stream', '_blank')} style={{ marginTop:20, color:"#a78bfa", fontSize:14, padding:"10px 24px", border:"1px solid rgba(167,139,250,0.4)", borderRadius:8, background:"rgba(167,139,250,0.12)", cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>Åbn fil til redigering</button></div>;
 })()}
 </div>
 </div>,
 document.body
 )}
 </div>
 );
}
// ── KlientOversigt block ─────────────────────────────────────────────────────
// ─────────────────────────────────────────────────────────
// HÆNDELSESREGISTRERING — note + filer på én gang
// ─────────────────────────────────────────────────────────
const HAENDELSE_TYPER_KO = [
 { value:"note", label:"Note", ikon:"", farve:"#60a5fa" },
 { value:"aktindsigt", label:"Aktindsigt", ikon:"", farve:"#38bdf8" },
 { value:"mail_ind", label:"Mail indgående", ikon:"", farve:"#34d399" },
 { value:"mail_ud", label:"Mail udgående", ikon:"↗", farve:"#10b981" },
 { value:"opkald", label:"Opkald", ikon:"", farve:"#f59e0b" },
 { value:"moede", label:"Møde/referat", ikon:"", farve:"#a78bfa" },
 { value:"dokument", label:"Dokument", ikon:"", farve:"#fb923c" },
 { value:"myndighedsbrev",label:"Myndighedsbrev", ikon:"", farve:"#e879f9" },
 { value:"aftale", label:"Aftale/kontrakt", ikon:"", farve:"#4ade80" },
 { value:"faktura", label:"Faktura/honorar", ikon:"", farve:"#fbbf24" },
];
function HændelseRegistrering({ sagId, sager, setSager, setValgt, filRef, onGenererDokument, maal_haendelse_id, onMaalAabnet, fjern_nye_haendelse }) {
 const [vis_form, setVisForm] = useState(false);
 const [form, setForm] = useState({ type:"note", titel:"", beskrivelse:"", deadline:"", deadline_titel:"", filer:[] });
 const [begivenhedsdato, setBegivenhedsdato] = useState(null); // null = ikke valgt, string = dato
 const [fejl, setFejl] = useState("");
 const intern_fil_ref = React.useRef(null);
 const [deadline_dialog, setDeadlineDialog] = useState(null); // { id, mode:"rediger"|"slet", deadline:"", årsag:"" }
 const [rediger_haendelse, setRedigerHaendelse] = useState(null); // { id, titel, beskrivelse, type, begivenhedsdato }
 const [flyt_dialog, setFlytDialog] = useState(null); // { id, titel, filer_antal }
 const [flyt_søg, setFlytSøg] = useState('');
 const [flyt_bekræft, setFlytBekræft] = useState(null);
 const [flyt_loading, setFlytLoading] = useState(false);
 const [flyt_fejl, setFlytFejl] = useState('');
 const [sag_søg, setSagSøg] = useState("");
 const [filter_type, setFilterType] = useState("alle"); // alle | note | mail | opkald | moede | dokument | deadline | aktindsigt
 const [filter_periode, setFilterPeriode] = useState("alt"); // alt | 7 | 30 | 90 | aar
 // ── Strukturerede dimensioner — state ──
 const [dim_retning, setDimRetning] = useState("");
 const [dim_part, setDimPart] = useState("");
 const [dim_haendelse_type, setDimHaendelseType] = useState("");
 const [dim_emne, setDimEmne] = useState("");
 const [dim_status, setDimStatus] = useState("");
 // Filter-state for dimensioner
 const [filter_retning, setFilterRetning] = useState("");
 const [filter_part, setFilterPart] = useState("");
 const [filter_dim_type, setFilterDimType] = useState("");
 const [filter_dim_status, setFilterDimStatus] = useState("");
 const [upload_filer, setUploadFiler] = useState([]); // { fil, visningsnavn, kategori, status, fejl }
 const [upload_kategori, setUploadKategori] = useState("Journal");
 const [uploader, setUploader] = useState(false);
 const [upload_status, setUploadStatus] = useState(null); // null | "uploader" | "success" | "fejl"
 const [upload_progress, setUploadProgress] = useState({ done: 0, total: 0 });
 const upload_ref = React.useRef(null);
 const edit_upload_ref = React.useRef(null);
 const [edit_upload_filer, setEditUploadFiler] = useState([]);
 const [edit_upload_kategori, setEditUploadKategori] = useState("Journal");
 const [edit_uploading, setEditUploading] = useState(false);
 const [edit_upload_progress, setEditUploadProgress] = useState({ done: 0, total: 0 });
 React.useEffect(() => { if (!rediger_haendelse) { setEditUploadFiler([]); setEditUploadKategori("Journal"); setEditUploading(false); setEditUploadProgress({ done: 0, total: 0 }); } }, [rediger_haendelse]);
 const sag = sager.find(s => s.id === sagId);
 const [haendelser, setHaendelser] = useState([]);
 const [haendelse_filer, setHaendelseFiler] = useState({}); // { haendelse_id: [filer] }
 const hent_haendelser = React.useCallback(() => {
 if (!sagId) return;
 api("haendelser/" + sagId).then(data => {
 if (data && data.haendelser) {
 // "Nye hændelser"-fremhævning (v2): backend returnerer er_set pr.
 // hændelse (haendelse_set, markeret via POST .../:id/set når brugeren
 // eksplicit åbner/klikker hændelsen -- se marker_haendelse_set).
 setHaendelser(data.haendelser.map(h => ({
 id: h.id,
 type: h.type,
 ikon: { note:"", aktindsigt:"", mail:"", mail_ind:"", mail_ud:"↗", opkald:"", moede:"", dokument:"", myndighedsbrev:"", aftale:"", faktura:"", deadline:"", deadline_udfoert:"" }[h.type] || "",
 titel: h.titel,
 beskrivelse: h.beskrivelse,
 deadline: h.deadline,
 deadline_titel: h.deadline_titel || "",
 filer: h.filer || [],
 dato: new Date(h.begivenhedsdato || h.oprettet_dato).toLocaleDateString("da-DK", { day:"numeric", month:"short", year:"numeric" }),
 dato_raw: h.begivenhedsdato || h.oprettet_dato, // ISO-string til filter-beregning
 begivenhedsdato: h.begivenhedsdato,
 begivenhedstid: h.begivenhedstid || null,
 tidspunkt: h.begivenhedstid ? h.begivenhedstid.slice(0,5) : (h.begivenhedsdato ? "" : new Date(h.oprettet_dato).toLocaleTimeString("da-DK", { hour:"2-digit", minute:"2-digit" })),
 er_ny: !h.er_set,
 forfatter: h.forfatter_navn || "Ukendt",
 // Strukturerede dimensioner
 retning: h.retning || null,
 part: h.part || null,
 haendelse_type: h.haendelse_type || null,
 emne: h.emne || null,
 haendelse_status: h.haendelse_status || null,
 // v1.12 pkt 6 — godkend-notat-flow (AI-journalnotater, Telavox)
 notat_status: h.notat_status || null,
 notat_godkendt_af: h.notat_godkendt_af || null,
 notat_godkendt_af_navn: h.notat_godkendt_af_navn || null,
 notat_godkendt_kl: h.notat_godkendt_kl || null,
 })));
 }
 }).catch(err => { console.error(err); toast("En handling fejlede — prøv igen", "fejl"); });
 }, [sagId]);
 React.useEffect(() => { hent_haendelser(); }, [hent_haendelser]);
 // Markér én hændelse som set -- kaldes når brugeren eksplicit åbner/klikker
 // den i tidslinjen. Opdaterer lokalt med det samme (badge/fremhævning
 // forsvinder for netop DEN hændelse), og genberegner sagens har_nye_haendelser
 // i sagslisten ud fra om der stadig er andre usete hændelser tilbage på sagen
 // -- så oversigten ikke skal genindlæses for at følge med.
 const marker_haendelse_set = React.useCallback((haendelse_id) => {
 setHaendelser(p => {
 const ny = p.map(h => h.id === haendelse_id ? { ...h, er_ny: false } : h);
 const stadig_nye = ny.some(h => h.er_ny);
 setSager(s => s.map(sag => sag.id === sagId ? { ...sag, har_nye_haendelser: stadig_nye } : sag));
 return ny;
 });
 // René: "den skal forsvinde af sig selv når den er set" -- fjern med det
 // samme fra Overblik-widgeten, ikke først ved næste poll.
 fjern_nye_haendelse && fjern_nye_haendelse(haendelse_id);
 api("haendelser/" + haendelse_id + "/set", "POST").catch(() => {});
 }, [sagId, setSager, fjern_nye_haendelse]);
 // Maria (via René): "Hvis man retter i deadline gennem hændelse, retter
 // den ikke på den deadline der står på forsiden/overblik." Backend
 // propagerer nu korrekt til sager.næste_deadline ved PATCH (se
 // routes/haendelser.js) -- denne helper holder den ALLEREDE indlæste
 // sager-liste + den evt. åbne sag (valgt) i sync med det samme, så
 // Sagsliste/Overblik ikke kræver en manuel genindlæsning for at følge med.
 const synk_sag_deadline = React.useCallback((ny_deadline, ny_titel) => {
 const info = beregn_deadline_info(ny_deadline);
 setSager(p => p.map(s => s.id === sagId ? { ...s, deadline: ny_deadline, deadline_titel: ny_titel || "", deadline_txt: info.txt, deadline_farve: info.farve } : s));
 if (setValgt) setValgt(p => (p && p.id === sagId) ? { ...p, deadline: ny_deadline, deadline_titel: ny_titel || "", deadline_txt: info.txt, deadline_farve: info.farve } : p);
 }, [sagId, setSager, setValgt]);
 const valgt_type = HAENDELSE_TYPER_KO.find(t => t.value === form.type);
 const tilfoej_filer = (e) => {
 const nye = Array.from(e.target.files).map(f => ({
 id: Date.now() + Math.random(),
 navn: f.name,
 størrelse: f.size,
 type: f.type,
 }));
 setForm(p => ({ ...p, filer: [...p.filer, ...nye] }));
 e.target.value = "";
 };
 const fjern_fil = (id) => setForm(p => ({ ...p, filer: p.filer.filter(f => f.id !== id) }));
 const gem = async () => {
 if (!form.titel.trim()) { setFejl("Titel er påkrævet"); return; }
 // René: "en deadline tittel ikke er den samme som hendelses
 // overskrifteten... i hendelses oprettelsen skal der udfyldes en deadline
 // tittel når der dettes en deadline dato"
 if (form.deadline && !form.deadline_titel.trim()) { setFejl("Deadline-titel er påkrævet når der er sat en deadline"); return; }
 setFejl("");
 const bruger_data = JSON.parse(sessionStorage.getItem("sv_bruger") || "{}");
 const forfatter_navn = bruger_data.navn || "Ukendt";
 const ny = {
 id: Date.now(),
 type: form.type,
 ikon: valgt_type?.ikon || "",
 titel: form.titel,
 beskrivelse: form.beskrivelse,
 deadline: form.deadline,
 deadline_titel: form.deadline_titel,
 filer: form.filer,
 dato: new Date().toLocaleDateString("da-DK", { day:"numeric", month:"short", year:"numeric" }),
 tidspunkt: new Date().toLocaleTimeString("da-DK", { hour:"2-digit", minute:"2-digit" }),
 forfatter: forfatter_navn,
 };
 setSager(p => p.map(s => s.id === sagId
 ? { ...s, haendelse_log: [ny, ...(s.haendelse_log || [])] }
 : s
 ));
 setHaendelser(p => [ny, ...p]);
 try {
 // Klokkeslæt tastes ALDRIG manuelt -- hentes fra PC'ens ur, og kun når
 // hændelsen dateres til i dag (ved tilbagedatering er det reelle tidspunkt ukendt).
 const i_dag_iso = new Date().toISOString().split("T")[0];
 const endelig_dato = begivenhedsdato || i_dag_iso;
 const auto_tid = endelig_dato === i_dag_iso ? new Date().toTimeString().slice(0,5) : null;
 const h_res = await api("haendelser", "POST", {
 sag_id: sagId,
 type: form.type,
 titel: form.titel,
 beskrivelse: form.beskrivelse,
 deadline: form.deadline || null,
 deadline_titel: form.deadline ? form.deadline_titel.trim() : null,
 begivenhedsdato: endelig_dato,
 begivenhedstid: auto_tid,
 retning: dim_retning || null,
 part: dim_part || null,
 haendelse_type: dim_haendelse_type || null,
 emne: dim_emne || null,
 haendelse_status: dim_status || null,
 });
 // Upload filer til OneDrive og registrer i DB
 if (upload_filer.length > 0 && h_res?.haendelse?.id) {
 const haendelse_id = h_res.haendelse.id;
 setUploadStatus("uploader");
 setUploadProgress({ done: 0, total: upload_filer.length });
 let ok_count = 0;
 let fejl_filer = [];
 for (let i = 0; i < upload_filer.length; i++) {
 const uf = upload_filer[i];
 setUploadProgress({ done: i, total: upload_filer.length, aktuel: uf.visningsnavn || uf.fil.name });
 try {
 const session = await api("filer/upload-session", "POST", {
 sag_id: sagId,
 haendelse_id,
 kategori: uf.kategori,
 filnavn: uf.fil.name,
 visningsnavn: uf.visningsnavn || uf.fil.name,
 });
 if (session?.upload_url) {
 await onedrive_upload(session.upload_url, uf.fil, (pct) => {
 setUploadProgress(prev => ({...prev, pct}));
 });
 await api("filer/registrer", "POST", {
 sag_id: sagId,
 haendelse_id,
 kategori: uf.kategori,
 original_navn: uf.fil.name,
 visningsnavn: uf.visningsnavn || uf.fil.name,
 størrelse: uf.fil.size,
 mime_type: uf.fil.type,
 onedrive_sti: session.onedrive_sti,
 });
 ok_count++;
 } else {
 fejl_filer.push(uf.fil.name + ": " + (session?.fejl || "Kunne ikke starte upload"));
 }
 } catch(upload_err) {
 console.error('[Upload] fejl for', uf.fil.name, ':', upload_err);
 fejl_filer.push(uf.fil.name + ": Upload fejlede");
 }
 }
 setUploadProgress({ done: upload_filer.length, total: upload_filer.length });
 if (fejl_filer.length > 0) {
 setUploadStatus("fejl");
 setFejl(`${ok_count} af ${upload_filer.length} filer uploadet. Fejl: ${fejl_filer.join(", ")}`);
 } else {
 setUploadStatus("success");
 }
 setUploadFiler([]);
 // Luk formular og vis bekræftelse
 setVisForm(false);
 if (fejl_filer.length === 0) setTimeout(() => setUploadStatus(null), 4000);
 }
 } catch(err) {
 console.error("Fejl ved gemning af hændelse:", err);
 setFejl("Hændelse kunne ikke gemmes — prøv igen"); console.error("[HAENDELSE] gem fejl:", err);
 }
 // Nulstil formular efter upload er færdig
 setForm({ type:"note", titel:"", beskrivelse:"", deadline:"", deadline_titel:"", filer:[] });
 setBegivenhedsdato(null);
 // Nulstil dimensioner
 setDimRetning(""); setDimPart(""); setDimHaendelseType(""); setDimEmne(""); setDimStatus("");
 // Hent opdaterede hændelser
 hent_haendelser();
 };
 const panel = { background:"rgba(8,12,30,0.55)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:16, backdropFilter:"blur(20px)", WebkitBackdropFilter:"blur(20px)" };
 const fmt_størrelse = (b) => b < 1048576 ? (b/1024).toFixed(0) + " KB" : (b/1048576).toFixed(1) + " MB";
 const fil_ikon = (navn) => navn?.endsWith(".pdf") ? "" : navn?.match(/\.(jpg|jpeg|png)$/i) ? "" : navn?.match(/\.(doc|docx)$/i) ? "" : "";
 return (
 <div> <input ref={intern_fil_ref} type="file" multiple onChange={tilfoej_filer}
 accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.xlsx,.xls,.mp4,.mov,.avi,.mp3,.wav,.ogg,.m4a,.txt,.csv,.eml,.msg,.zip,.rar" style={{ display:"none" }} />
 {/* Registrér knap */}
 <button onClick={() => setVisForm(!vis_form)}
 onMouseOver={e => {
 if (!vis_form) {
 e.currentTarget.style.transform="translateY(-2px) scale(1.01)";
 e.currentTarget.style.boxShadow="0 12px 32px rgba(63,212,199,0.35), 0 4px 8px rgba(0,0,0,0.25)";
 }
 }}
 onMouseOut={e => {
 if (!vis_form) {
 e.currentTarget.style.transform="translateY(0) scale(1)";
 e.currentTarget.style.boxShadow="0 6px 20px rgba(63,212,199,0.22), 0 2px 6px rgba(0,0,0,0.18)";
 }
 }}
 style={{
 width:"100%",
 background: vis_form
 ? "rgba(255,255,255,0.04)"
 : "linear-gradient(135deg, #3fd4c7 0%, #2bc4b4 45%, #5b8df8 100%)",
 border: vis_form ? "1px solid rgba(255,255,255,0.08)" : "none",
 borderRadius:12, padding:"15px",
 color: vis_form ? "rgba(255,255,255,0.35)" : "#ffffff",
 fontWeight:700, fontSize:14, cursor:"pointer",
 fontFamily:"'Inter',system-ui,sans-serif", marginBottom:14,
 transition:"all 0.3s cubic-bezier(0.34,1.56,0.64,1)",
 boxShadow: vis_form ? "none" : "0 6px 20px rgba(63,212,199,0.22), 0 2px 6px rgba(0,0,0,0.18)",
 letterSpacing:"0.03em", display:"flex", alignItems:"center", justifyContent:"center", gap:8,
 }}>
 {vis_form
 ? <><span style={{ fontSize:16, fontWeight:400 }}></span> Annuller</>
 : <><span style={{ fontSize:18 }}>+</span> Registrér hændelse</>}
 </button>
 {/* Upload bekræftelse (vises også når formular er lukket) */}
 {!vis_form && upload_status === "success" && (
 <div style={{ background:"rgba(39,174,96,0.08)", border:"1px solid rgba(39,174,96,0.3)", borderRadius:10, padding:"12px 16px", marginBottom:14, fontSize:13, color:"#27ae60", animation:"sv-panel-enter 0.4s cubic-bezier(0.34,1.56,0.64,1) both" }}>
 Hændelse gemt — {upload_progress.total} fil{upload_progress.total > 1 ? "er" : ""} uploadet til OneDrive
 </div>
 )}
 {!vis_form && upload_status === "uploader" && (
 <div style={{ background:"rgba(63,212,199,0.06)", border:`1px solid ${T.turkis}33`, borderRadius:10, padding:"12px 16px", marginBottom:14, fontSize:13, color:T.turkis }}>
 Uploader {upload_progress.aktuel || "filer"} til OneDrive... ({upload_progress.done}/{upload_progress.total})
 </div>
 )}
 {/* Formular */}
 {vis_form && (
 <div className="sv-card-pop" style={{
 position:"relative", overflow:"hidden",
 background:"rgba(8,12,30,0.75)",
 border:`1px solid ${valgt_type?.farve ? valgt_type.farve + "22" : "rgba(255,255,255,0.07)"}`,
 borderRadius:16, padding:"22px 20px 20px", marginBottom:16,
 backdropFilter:"blur(28px)", WebkitBackdropFilter:"blur(28px)",
 boxShadow:"0 8px 32px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.04)",
 transition:"border-color 0.3s ease",
 }}>
 {/* gradient accent top line — shifts with type color */}
 <div style={{ position:"absolute", top:0, left:0, right:0, height:2,
 background: valgt_type?.farve
 ? `linear-gradient(90deg, ${valgt_type.farve}, ${valgt_type.farve}55, transparent)`
 : `linear-gradient(90deg, ${T.turkis}, rgba(167,139,250,0.5), transparent)`,
 borderRadius:"16px 16px 0 0", pointerEvents:"none", transition:"background 0.3s ease" }} /> <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:20 }}> <div style={{
 width:32, height:32, borderRadius:9,
 background: valgt_type?.farve ? `${valgt_type.farve}18` : "rgba(63,212,199,0.12)",
 border:`1px solid ${valgt_type?.farve ? valgt_type.farve + "30" : "rgba(63,212,199,0.2)"}`,
 display:"flex", alignItems:"center", justifyContent:"center", fontSize:15, flexShrink:0,
 transition:"all 0.3s ease",
 }}>{valgt_type?.ikon || ""}</div> <div style={{
 fontSize:11, fontWeight:700, letterSpacing:"0.18em", textTransform:"uppercase",
 background: valgt_type?.farve
 ? `linear-gradient(90deg, ${valgt_type.farve}, #f1f5f9)`
 : `linear-gradient(90deg, ${T.turkis}, #f1f5f9)`,
 WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent", backgroundClip:"text",
 transition:"all 0.3s ease",
 }}>
 Ny hændelse — {valgt_type?.label || "Note"}
 </div> </div>
 {/* Begivenhedsdato — PÅKRÆVET */}
 {(() => {
 const i_dag = new Date().toISOString().split("T")[0];
 const er_i_dag = begivenhedsdato === i_dag;
 const er_anden = begivenhedsdato && begivenhedsdato !== i_dag && begivenhedsdato !== "vælg";
 return (
 <div style={{ marginBottom:16 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:8 }}>
 Dato for modtagelse/handling <span style={{ color:T.roed }}>*</span> </div> <div style={{ display:"flex", gap:8, marginBottom:8 }}> <button onClick={() => setBegivenhedsdato(i_dag)}
 style={{ flex:1, padding:"10px", borderRadius:8, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", cursor:"pointer",
 background: er_i_dag ? `${T.turkis}22` : "rgba(255,255,255,0.04)",
 border: er_i_dag ? `2px solid ${T.turkis}` : T.skillelinje,
 color: er_i_dag ? T.turkis : T.dæmpet, fontWeight: er_i_dag ? 700 : 400,
 }}>
 Modtaget i dag
 </button> <button onClick={() => setBegivenhedsdato("vælg")}
 style={{ flex:1, padding:"10px", borderRadius:8, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", cursor:"pointer",
 background: (begivenhedsdato === "vælg" || er_anden) ? `${T.turkis}22` : "rgba(255,255,255,0.04)",
 border: (begivenhedsdato === "vælg" || er_anden) ? `2px solid ${T.turkis}` : T.skillelinje,
 color: (begivenhedsdato === "vælg" || er_anden) ? T.turkis : T.dæmpet,
 fontWeight: (begivenhedsdato === "vælg" || er_anden) ? 700 : 400,
 }}>
 Vælg dato
 </button> </div>
 {(begivenhedsdato === "vælg" || er_anden) && (
 <input type="date" value={er_anden ? begivenhedsdato : ""}
 onChange={e => setBegivenhedsdato(e.target.value)}
 max={i_dag}
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:`1px solid ${T.turkis}55`, borderRadius:8, padding:"10px 12px", color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", colorScheme:"dark", boxSizing:"border-box" }} />
 )}
 {er_i_dag && <div style={{ fontSize:12, color:T.turkis, marginTop:4 }}> {new Date().toLocaleDateString("da-DK", {day:"numeric",month:"long",year:"numeric"})}</div>}
 {er_anden && <div style={{ fontSize:12, color:T.turkis, marginTop:4 }}> {new Date(begivenhedsdato).toLocaleDateString("da-DK", {day:"numeric",month:"long",year:"numeric"})}</div>}
 {!begivenhedsdato && <div style={{ fontSize:12, color:T.roed, marginTop:4 }}>Vælg dato for hændelsen</div>}
 </div>
 );
 })()}
 {/* Type valg */}
 <div style={{ marginBottom:16 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:8 }}>Type</div> <div style={{ display:"flex", flexWrap:"wrap", gap:6 }}>
 {HAENDELSE_TYPER_KO.map(t => {
 const aktiv = form.type === t.value;
 return (
 <button key={t.value} onClick={() => setForm(p => ({ ...p, type: t.value }))} style={{
 padding:"7px 12px", borderRadius:7, fontSize:12,
 border:`1px solid ${aktiv ? t.farve + "88" : "rgba(255,255,255,0.08)"}`,
 background: aktiv ? `linear-gradient(135deg, ${t.farve}20, ${t.farve}0a)` : "rgba(255,255,255,0.04)",
 color: aktiv ? t.farve : T.dæmpet,
 cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif",
 transition:"all 0.2s cubic-bezier(0.34,1.56,0.64,1)",
 display:"flex", alignItems:"center", gap:5,
 boxShadow: aktiv ? `0 0 16px ${t.farve}30, inset 0 1px 0 rgba(255,255,255,0.08)` : "none",
 transform: aktiv ? "scale(1.04)" : "scale(1)",
 fontWeight: aktiv ? 600 : 400,
 }}> <span>{t.ikon}</span> {t.label}
 </button>
 );
 })}
 </div> </div>
 {/* Titel */}
 <div style={{ marginBottom:14 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:7 }}>
 Titel <span style={{ color:T.turkis }}>*</span> </div> <input value={form.titel} onChange={e => { setForm(p => ({...p, titel:e.target.value})); setFejl(""); }}
 placeholder={`fx "Aktindsigt modtaget fra Familieretshuset" eller "Klientmøde 45 min."`}
 className="sv-input"
 style={{ width:"100%", background:"rgba(12,15,30,0.6)", border:`1px solid ${fejl?"rgba(251,113,133,0.4)":"rgba(255,255,255,0.07)"}`, borderRadius:9, padding:"13px 14px", color:T.creme, fontSize:14, fontFamily:"'Inter',system-ui,sans-serif", boxSizing:"border-box", transition:"all 0.25s cubic-bezier(0.4,0,0.2,1)" }} />
 {fejl && <div style={{ color:T.roed, fontSize:12, marginTop:5, fontWeight:500 }}>{fejl}</div>}
 </div>
 {/* Beskrivelse */}
 <div style={{ marginBottom:14 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:7 }}>Beskrivelse og noter</div> <textarea onInput={e=>{e.target.style.height="auto";e.target.style.height=e.target.scrollHeight+"px";}} value={form.beskrivelse} onChange={e => setForm(p => ({...p, beskrivelse:e.target.value}))}
 placeholder="Beskriv indholdet, hvad der skete, hvad der blev aftalt, særlige bemærkninger..."
 rows={4} spellCheck="true" lang="da"
 className="sv-input"
 style={{ width:"100%", background:"rgba(12,15,30,0.6)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:9, padding:"13px 14px", color:T.creme, fontSize:13, resize:"none", lineHeight:1.75, fontFamily:"'Inter',system-ui,sans-serif", boxSizing:"border-box", transition:"all 0.25s cubic-bezier(0.4,0,0.2,1)" }} /> </div>
 {/* Deadline */}
 <div style={{ marginBottom:16 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:7 }}>Deadline (valgfri)</div> <input type="date" value={form.deadline} onChange={e => { setForm(p => ({...p, deadline:e.target.value})); setFejl(""); }}
 min={new Date().toISOString().split("T")[0]}
 style={{ background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:9, padding:"11px 14px", color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", colorScheme:"dark" }} />
 {form.deadline && (
 <span style={{ marginLeft:10, fontSize:12, color:T.gul }}>
 {new Date(form.deadline).toLocaleDateString("da-DK", { weekday:"long", day:"numeric", month:"long" })}
 </span>
 )}
 {form.deadline && (
 <div style={{ marginTop:10 }}>
 <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:7 }}>
 Deadline-titel <span style={{ color:T.turkis }}>*</span>
 <span style={{ fontSize:11, fontWeight:400, textTransform:"none", letterSpacing:0, color:T.dæmpet, marginLeft:6 }}>— hvad skal der følges op på?</span>
 </div>
 <input value={form.deadline_titel} onChange={e => { setForm(p => ({...p, deadline_titel:e.target.value})); setFejl(""); }}
 placeholder='fx "Følg op på om aktindsigten er modtaget"'
 className="sv-input"
 style={{ width:"100%", background:"rgba(12,15,30,0.6)", border:`1px solid ${fejl && !form.deadline_titel.trim() ? "rgba(251,113,133,0.4)" : "rgba(255,255,255,0.07)"}`, borderRadius:9, padding:"11px 14px", color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", boxSizing:"border-box", transition:"all 0.25s cubic-bezier(0.4,0,0.2,1)" }} />
 </div>
 )}
 </div>
 {/* ── Strukturerede dimensioner ── */}
 {(() => {
 const RETNINGER = ["", "Indgående", "Udgående", "Intern"];
 const PARTER = ["", "Familieretshuset", "Politiet", "Klient", "Modpart", "Advokat (klientens)", "Advokat (modpartens)", "Retten", "Kommunen", "Børnehus", "Andre myndigheder", "SkilsmisseVejen (intern)", "Skifteretten", "Ankestyrelsen", "Mægler/mediator"];
 const DIM_TYPER = ["", "Aktindsigt", "Anmodning", "Afgørelse", "Dokument", "Partshøring", "Aftale", "Brev/korrespondance", "Møde", "Telefonopkald", "Mail", "Notat", "Klage", "Indkaldelse", "Erklæring", "Samtykkeerklæring", "Bilag fra klienten"];
 const EMNER = ["", "Forældremyndighed", "Samvær", "Bopæl", "Bidrag", "Bodeling", "Separation", "Skilsmisse", "Tvangsfuldbyrding"];
 const STATUSSER = ["", "Kladde", "Sendt/Indsendt", "Modtaget", "Afventer svar", "Besvaret", "Afsluttet/Lukket", "Anket", "Bortfaldet"];
 const sel_style = { width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"9px 12px", color: T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", colorScheme:"dark", boxSizing:"border-box" };
 const lbl_style = { fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:6, marginTop:0 };
 return (
 <div style={{ marginBottom:16, background:"rgba(63,212,199,0.04)", border:`1px solid ${T.turkis}22`, borderRadius:10, padding:"14px 14px 10px" }}>
 <div style={{ fontSize:11, fontWeight:700, letterSpacing:"0.15em", textTransform:"uppercase", color:T.turkis, marginBottom:12, opacity:0.8 }}>Strukturerede dimensioner</div>
 <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
 <div>
 <div style={lbl_style}>Retning <span style={{ color:T.roed }}>*</span></div>
 <select style={{...sel_style, border: dim_retning ? `1px solid ${T.turkis}55` : "1px solid rgba(251,113,133,0.35)" }} value={dim_retning} onChange={e => setDimRetning(e.target.value)}>
 {RETNINGER.map(v => <option key={v} value={v}>{v || "— Vælg retning —"}</option>)}
 </select>
 </div>
 <div>
 <div style={lbl_style}>Part</div>
 <select style={sel_style} value={dim_part} onChange={e => setDimPart(e.target.value)}>
 {PARTER.map(v => <option key={v} value={v}>{v || "— Vælg part —"}</option>)}
 </select>
 </div>
 <div>
 <div style={lbl_style}>Hændelsestype</div>
 <select style={sel_style} value={dim_haendelse_type} onChange={e => setDimHaendelseType(e.target.value)}>
 {DIM_TYPER.map(v => <option key={v} value={v}>{v || "— Vælg type —"}</option>)}
 </select>
 </div>
 <div>
 <div style={lbl_style}>Emne</div>
 <select style={sel_style} value={dim_emne} onChange={e => setDimEmne(e.target.value)}>
 {EMNER.map(v => <option key={v} value={v}>{v || "— Vælg emne —"}</option>)}
 </select>
 </div>
 <div style={{ gridColumn:"span 2" }}>
 <div style={lbl_style}>Status</div>
 <select style={sel_style} value={dim_status} onChange={e => setDimStatus(e.target.value)}>
 {STATUSSER.map(v => <option key={v} value={v}>{v || "— Vælg status —"}</option>)}
 </select>
 </div>
 </div>
 </div>
 );
 })()}
 {/* Filer til OneDrive */}
 <div style={{ marginBottom:18 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:8 }}>Vedhæft filer → OneDrive</div> <input ref={upload_ref} type="file" multiple style={{ display:"none" }}
 accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.xlsx,.xls,.mp4,.mp3"
 onChange={e => {
 const nye = Array.from(e.target.files).map(f => ({
 id: Date.now() + Math.random(),
 fil: f,
 visningsnavn: f.name.replace(/\.[^.]+$/, ""), // visningsnavn uden extension (extension tilføjes ved upload)
 extension: f.name.match(/\.[^.]+$/)?.[0] || "",
 kategori: upload_kategori,
 status: "klar",
 }));
 setUploadFiler(p => [...p, ...nye]);
 e.target.value = "";
 }} />
 {/* Kategori vælger */}
 <div style={{ marginBottom:10 }}> <div style={{ fontSize:12, color:T.dæmpet, marginBottom:6 }}>Gem i kategori:</div> <select style={{colorScheme:"dark"}} value={upload_kategori} onChange={e => setUploadKategori(e.target.value)}
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"9px 12px", color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif" }}>
 {["Journal","Aktindsigt","Oplysninger","Dom","Klager","Indkaldelse","Sagsopstart","Retten","Bilag klient","Afgørelser","Børnesamtaler","Kommunikation","Mødenotater","Partshøring","Sagsakter","Underretninger","Video","Lyd","Nyttige bilag","Log og data"].map(k => (
 <option key={k} value={k}>{k}</option>
 ))}
 </select> </div>
 {/* Valgte filer */}
 {upload_filer.length > 0 && (
 <div style={{ marginBottom:8 }}>
 {upload_filer.map(uf => (
 <div key={uf.id} style={{ background:"rgba(0,0,0,0.2)", border:T.skillelinje, borderRadius:8, padding:"10px 12px", marginBottom:6, display:"flex", alignItems:"center", gap:8 }}> <span style={{ fontSize:18, flexShrink:0 }}>{uf.fil.name.endsWith(".pdf")?"":uf.fil.name.match(/\.(jpg|jpeg|png)$/i)?"":""}</span> <div style={{ flex:1, minWidth:0 }}> <input
 value={uf.visningsnavn || uf.fil.name.replace(/\.[^.]+$/, "")}
 onChange={e => setUploadFiler(p => p.map(x => x.id===uf.id ? {...x, visningsnavn: e.target.value} : x))}
 spellCheck="true" lang="da"
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:`1px solid ${T.turkis}55`, borderRadius:6, color:T.creme, fontSize:12, fontFamily:"'Inter',system-ui,sans-serif", padding:"6px 10px", outline:"none", boxSizing:"border-box" }}
 title="Rediger filnavn"
 placeholder="Filnavn..."
 /> <div style={{ fontSize:12, color:T.dæmpet }}>{(uf.fil.size/1024).toFixed(0)} KB → {upload_kategori}</div> </div> <button onClick={() => setUploadFiler(p => p.filter(x => x.id !== uf.id))} style={{ background:"none", border:"none", color:T.roed, fontSize:18, cursor:"pointer", flexShrink:0 }}>×</button> </div>
 ))}
 </div>
 )}
 <button onClick={() => upload_ref.current?.click()}
 onMouseOver={e => {
 e.currentTarget.style.borderColor=`${T.turkis}55`;
 e.currentTarget.style.color=T.turkis;
 e.currentTarget.style.background=`rgba(63,212,199,0.04)`;
 e.currentTarget.style.transform="translateY(-1px)";
 }}
 onMouseOut={e => {
 e.currentTarget.style.borderColor="rgba(255,255,255,0.07)";
 e.currentTarget.style.color="rgba(148,163,184,0.7)";
 e.currentTarget.style.background="none";
 e.currentTarget.style.transform="translateY(0)";
 }}
 style={{
 width:"100%", background:"none",
 border:"1px dashed rgba(255,255,255,0.07)",
 borderRadius:10, padding:"13px", color:"rgba(148,163,184,0.7)",
 fontSize:12, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif",
 transition:"all 0.25s cubic-bezier(0.4,0,0.2,1)",
 display:"flex", alignItems:"center", justifyContent:"center", gap:6,
 }}> <span style={{ fontSize:16 }}></span>
 Tilføj filer til <strong style={{ color:"rgba(148,163,184,0.9)" }}>{upload_kategori}</strong> — gemmes på OneDrive
 </button> </div>
 {/* Upload progress/status */}
 {upload_status === "uploader" && (
 <div style={{ marginBottom:12 }}> <div style={{ display:"flex", justifyContent:"space-between", fontSize:12, color:T.dæmpet, marginBottom:4 }}> <span>Uploader {upload_progress.aktuel ? `"${upload_progress.aktuel}"` : ""}...</span> <span>{upload_progress.done}/{upload_progress.total} filer</span> </div> <div style={{ height:4, background:"rgba(0,0,0,0.1)", borderRadius:2, overflow:"hidden" }}> <div style={{ height:"100%", width: (upload_progress.total ? (upload_progress.done/upload_progress.total)*100 : 0)+"%", background:T.turkis, borderRadius:2, transition:"width 0.3s" }} /> </div> </div>
 )}
 {upload_status === "success" && (
 <div style={{ background:"rgba(39,174,96,0.08)", border:"1px solid rgba(39,174,96,0.3)", borderRadius:8, padding:"10px 14px", marginBottom:12, fontSize:12, color:T.groen || "#27ae60" }}>
 {upload_progress.total} fil{upload_progress.total > 1 ? "er" : ""} uploadet til OneDrive
 </div>
 )}
 {upload_status === "fejl" && fejl && (
 <div style={{ background:"rgba(255,107,107,0.08)", border:"1px solid rgba(255,107,107,0.25)", borderRadius:8, padding:"10px 14px", marginBottom:12, fontSize:12, color:T.roed }}>
 {fejl}
 </div>
 )}
 <Knap onClick={gem} disabled={upload_status === "uploader" || !begivenhedsdato || begivenhedsdato === "vælg"} style={{ width:"100%", padding:"13px", opacity: (upload_status === "uploader" || !begivenhedsdato || begivenhedsdato === "vælg") ? 0.4 : 1 }}>
 {upload_status === "uploader" ? " Uploader filer..." : `Gem hændelse ${upload_filer.length > 0 ? `+ ${upload_filer.length} fil${upload_filer.length > 1 ? "er" : ""} → OneDrive` : ""}`}
 </Knap> </div>
 )}
 {/* Deadline rediger/slet/udfoert dialog — via portal for at undgå ancestor-filter */}
 {deadline_dialog && (() => {
 const er_rediger = deadline_dialog.mode === "rediger";
 const er_udfoert = deadline_dialog.mode === "udfoert";
 const kan_gem = er_rediger
 ? !!(deadline_dialog.titel?.trim() && deadline_dialog.deadline && deadline_dialog.årsag?.trim())
 : er_udfoert
 ? true
 : !!deadline_dialog.årsag?.trim();
 const header_farve = er_rediger ? T.turkis : er_udfoert ? T.groen : T.roed;
 return createPortal(
 <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.7)", backdropFilter:"blur(4px)", zIndex:10000, display:"flex", alignItems:"center", justifyContent:"center" }}
 onClick={()=>setDeadlineDialog(null)}> <div style={{ background:"#0f1328", border:"1px solid rgba(255,255,255,0.1)", borderRadius:20, padding:"28px 32px", width:400, maxWidth:"90vw", boxShadow:"0 24px 80px rgba(0,0,0,0.6)" }}
 onClick={e=>e.stopPropagation()}> <div style={{ fontSize:16, fontWeight:600, color:header_farve, marginBottom:20 }}>
 {er_rediger ? " Sæt deadline" : er_udfoert ? " Markér som udført" : " Fjern deadline"}
 </div>
 {er_rediger && (
 <> <div style={{ fontSize:12, color:"#b0bec5", marginBottom:6 }}>Hvad omhandler deadlinen? <span style={{ color:"#fb7185" }}>*</span></div> <input value={deadline_dialog.titel||""}
 onChange={e=>setDeadlineDialog(p=>({...p, titel:e.target.value}))}
 placeholder="fx: Partshøringsfrist, Svar til Familieretshuset..."
 spellCheck="true" lang="da" autoFocus
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.2)", borderRadius:8, padding:"10px 12px", color:"#e2e8f0", fontSize:14, fontFamily:"'Inter',system-ui,sans-serif", boxSizing:"border-box", marginBottom:12 }} /> <div style={{ fontSize:12, color:"#b0bec5", marginBottom:6 }}>Dato <span style={{ color:"#fb7185" }}>*</span></div> <input type="date" value={deadline_dialog.deadline}
 onChange={e=>setDeadlineDialog(p=>({...p, deadline:e.target.value}))}
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"10px 12px", color:"#e2e8f0", fontSize:14, fontFamily:"'Inter',system-ui,sans-serif", colorScheme:"dark", boxSizing:"border-box", marginBottom:12 }} /> </>
 )}
 {er_rediger && (
 <div style={{ display:"flex", gap:8, marginBottom:14, flexWrap:"wrap" }}> <button onClick={()=>setDeadlineDialog(p=>({...p, mode:"udfoert", årsag:""}))} style={{ flex:1, minWidth:140, background:"rgba(6,214,160,0.1)", border:"1px solid rgba(6,214,160,0.35)", borderRadius:8, padding:"9px 12px", color:T.groen, fontSize:12, fontWeight:600, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}> Markér som udført</button> <button onClick={()=>setDeadlineDialog(p=>({...p, mode:"slet", årsag:""}))} style={{ flex:1, minWidth:120, background:"rgba(251,113,133,0.1)", border:"1px solid rgba(251,113,133,0.35)", borderRadius:8, padding:"9px 12px", color:T.roed, fontSize:12, fontWeight:600, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}> Fjern deadline</button> </div>
 )}
 {er_udfoert && (
 <div style={{ padding:"10px 14px", background:"rgba(6,214,160,0.08)", border:"1px solid rgba(6,214,160,0.33)", borderRadius:8, marginBottom:12, fontSize:12, color:T.groen, lineHeight:1.6 }}>Deadlinen markeres som udført — hændelsens deadline nulstilles.</div>
 )}
 {!er_rediger && (
 <> <div style={{ fontSize:12, color:"#b0bec5", marginBottom:6 }}>{er_udfoert ? "Beskriv hvad der skete (valgfri)" : "Årsag til fjernelse"} {!er_udfoert && <span style={{ color:"#fb7185" }}>*</span>}</div> <textarea value={deadline_dialog.årsag||""}
 onChange={e=>setDeadlineDialog(p=>({...p, årsag:e.target.value}))}
 placeholder={er_udfoert ? "fx: Svar sendt til Familieretshuset, Aktindsigt modtaget..." : "fx: Handling udført, Frist udsat..."}
 rows={2} spellCheck="true" lang="da"
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"10px 12px", color:"#e2e8f0", fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", boxSizing:"border-box", marginBottom:16, resize:"vertical" }} />
 </>
 )}
 {er_rediger && (
 <> <div style={{ fontSize:12, color:"#b0bec5", marginBottom:6 }}>Begrundelse <span style={{ color:"#fb7185" }}>*</span></div> <input value={deadline_dialog.årsag||""}
 onChange={e=>setDeadlineDialog(p=>({...p, årsag:e.target.value}))}
 placeholder="fx: Aftalt med klient, Ny frist fra myndighed..." spellCheck="true" lang="da"
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"10px 12px", color:"#e2e8f0", fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", boxSizing:"border-box", marginBottom:16 }} />
 </>
 )}
 <div style={{ display:"flex", gap:10 }}> <button onClick={()=>{ if (er_udfoert || deadline_dialog.mode === "slet") { setDeadlineDialog(p=>({...p, mode:"rediger", årsag:""})); } else { setDeadlineDialog(null); } }} style={{ flex:1, background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.1)", borderRadius:8, padding:"10px", color:"#b0bec5", fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>{er_udfoert || deadline_dialog.mode === "slet" ? "Fortryd" : "Annuller"}</button> <button disabled={!kan_gem} onClick={async ()=>{
 if (!kan_gem) return;
 if (er_udfoert) {
 const r = await api("haendelser/" + deadline_dialog.id, "PATCH", { deadline: null, deadline_titel: null });
 if (!r || r.fejl) { toast("Kunne ikke markere som udført: " + (r?.fejl || "serverfejl"), "fejl"); return; }
 const note_tekst = deadline_dialog.årsag?.trim();
 if (note_tekst && deadline_dialog.sag_id) {
 await api("haendelser", "POST", { sag_id: deadline_dialog.sag_id, type: "deadline_udfoert", titel: "Udført: " + (deadline_dialog.titel || deadline_dialog.original_titel || "Deadline"), beskrivelse: note_tekst }).catch(err => console.warn("[DEADLINE] note fejlede:", err));
 }
 setHaendelser(p=>p.map(x=>x.id===deadline_dialog.id?{...x,deadline:null,deadline_titel:""}:x));
 synk_sag_deadline(null, "");
 setDeadlineDialog(null);
 hent_haendelser();
 toast(" Deadline markeret som udført", "success");
 } else {
 const ny = er_rediger ? deadline_dialog.deadline : null;
 const titel = er_rediger ? deadline_dialog.titel?.trim() : "";
 const r = await api("haendelser/" + deadline_dialog.id, "PATCH", { deadline: ny, deadline_titel: titel || null });
 if (!r || r.fejl) { toast("Kunne ikke gemme deadline: " + (r?.fejl || "serverfejl"), "fejl"); return; }
 setHaendelser(p=>p.map(x=>x.id===deadline_dialog.id?{...x,deadline:ny,deadline_titel:titel}:x));
 synk_sag_deadline(ny, titel);
 setDeadlineDialog(null);
 hent_haendelser();
 toast(er_rediger ? "Deadline gemt" : "Deadline fjernet", "success");
 }
 }} style={{ flex:1, background:kan_gem ? header_farve : "rgba(255,255,255,0.08)", border:"none", borderRadius:8, padding:"10px", color:kan_gem?"#fff":"#475569", fontSize:13, fontWeight:700, cursor:kan_gem?"pointer":"not-allowed", fontFamily:"'Inter',system-ui,sans-serif", transition:"all 0.2s" }}>{er_udfoert ? " Bekræft udført" : er_rediger ? "Gem deadline" : "Fjern deadline"}</button> </div> </div> </div>,
 document.body
 );
 })()}
 {/* Hændelseslog — SagsTidslinje erstatter den flade liste */}
 {haendelser.length === 0 ? (
 <div style={{ ...panel, padding:"32px", textAlign:"center" }}> <div style={{ fontSize:32, marginBottom:10 }}></div> <div style={{ color:T.lys, fontSize:14, marginBottom:6 }}>Ingen hændelser registreret endnu</div> <div style={{ color:T.dæmpet, fontSize:12, marginBottom:16 }}>Registrér mails, opkald, møder, aktindsigter og dokumenter samlet på sagen</div> <Knap onClick={() => setVisForm(true)} style={{ padding:"10px 20px" }}>+ Registrér første hændelse</Knap> </div>
 ) : (() => {
 const nu = Date.now();
 const periode_ms = filter_periode === "uge" ? 7*86400000
 : filter_periode === "maaned" ? 30*86400000
 : filter_periode === "kvartal" ? 90*86400000
 : null;
 const type_match = (h_type) => {
 if (filter_type === "alle") return true;
 if (filter_type === "mail") return h_type === "mail" || h_type === "mail_ind" || h_type === "mail_ud";
 return h_type === filter_type;
 };
 const søg_id_match = sag_søg.trim().match(/^#?(\d+)$/);
 const filtrerede = haendelser.filter(h => {
 if (!type_match(h.type)) return false;
 // René: hændelse-numre (#1234) vist i Filtjek-listen skal kunne søges
 // direkte -- en ren tal-/#-søgning matcher kun på hændelsens id.
 if (søg_id_match) { if (String(h.id) !== søg_id_match[1]) return false; }
 else if (sag_søg && !((h.titel+(h.beskrivelse||"")+(h.forfatter||"")).toLowerCase().includes(sag_søg.toLowerCase()))) return false;
 if (periode_ms) {
 const d = Date.parse(h.dato_raw || h.dato);
 if (!isNaN(d) && nu - d > periode_ms) return false;
 }
 // Dimension-filtre
 if (filter_retning && h.retning !== filter_retning) return false;
 if (filter_part && h.part !== filter_part) return false;
 if (filter_dim_type) {
      const fdl = filter_dim_type.toLowerCase();
      const dimMatch = h.haendelse_type?.toLowerCase() === fdl;
      const typeMatch = h.type?.toLowerCase() === fdl;
      if (!dimMatch && !typeMatch) return false;
    }
 if (filter_dim_status && h.haendelse_status !== filter_dim_status) return false;
 return true;
 });
 const har_aktive_dim_filtre = filter_retning || filter_part || filter_dim_type || filter_dim_status;
 const dim_filter_sel = { background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.09)", borderRadius:7, padding:"6px 10px", color:T.dæmpet, fontSize:12, fontFamily:"'Inter',system-ui,sans-serif", colorScheme:"dark", cursor:"pointer" };
 return (
 <>
 {/* ── Dimensionsfiltre over listen ── */}
 <div style={{ display:"flex", flexWrap:"wrap", gap:6, marginBottom:10, padding:"10px 12px", background:"rgba(63,212,199,0.04)", border:`1px solid ${T.turkis}18`, borderRadius:9 }}>
 <select style={{...dim_filter_sel, color: filter_retning ? T.turkis : T.dæmpet, border: filter_retning ? `1px solid ${T.turkis}55` : dim_filter_sel.border }} value={filter_retning} onChange={e => setFilterRetning(e.target.value)}>
 <option value="">Alle retninger</option>
 {["Indgående","Udgående","Intern"].map(v => <option key={v} value={v}>{v}</option>)}
 </select>
 <select style={{...dim_filter_sel, color: filter_part ? T.turkis : T.dæmpet, border: filter_part ? `1px solid ${T.turkis}55` : dim_filter_sel.border }} value={filter_part} onChange={e => setFilterPart(e.target.value)}>
 <option value="">Alle parter</option>
 {["Familieretshuset","Politiet","Klient","Modpart","Advokat (klientens)","Advokat (modpartens)","Retten","Kommunen","Børnehus","Andre myndigheder","SkilsmisseVejen (intern)","Skifteretten","Ankestyrelsen","Mægler/mediator"].map(v => <option key={v} value={v}>{v}</option>)}
 </select>
 <select style={{...dim_filter_sel, color: filter_dim_type ? T.turkis : T.dæmpet, border: filter_dim_type ? `1px solid ${T.turkis}55` : dim_filter_sel.border }} value={filter_dim_type} onChange={e => setFilterDimType(e.target.value)}>
 <option value="">Alle typer</option>
 {["Aktindsigt","Anmodning","Afgørelse","Dokument","Partshøring","Aftale","Brev/korrespondance","Møde","Telefonopkald","Mail","Notat","Klage","Indkaldelse","Erklæring","Samtykkeerklæring","Bilag fra klienten"].map(v => <option key={v} value={v}>{v}</option>)}
 </select>
 <select style={{...dim_filter_sel, color: filter_dim_status ? T.turkis : T.dæmpet, border: filter_dim_status ? `1px solid ${T.turkis}55` : dim_filter_sel.border }} value={filter_dim_status} onChange={e => setFilterDimStatus(e.target.value)}>
 <option value="">Alle statusser</option>
 {["Kladde","Sendt/Indsendt","Modtaget","Afventer svar","Besvaret","Afsluttet/Lukket","Anket","Bortfaldet"].map(v => <option key={v} value={v}>{v}</option>)}
 </select>
 {har_aktive_dim_filtre && (
 <button onClick={() => { setFilterRetning(""); setFilterPart(""); setFilterDimType(""); setFilterDimStatus(""); }} style={{ background:"rgba(251,113,133,0.1)", border:"1px solid rgba(251,113,133,0.3)", borderRadius:7, padding:"6px 10px", color:"#fb7185", fontSize:12, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Nulstil filtre
 </button>
 )}
 </div>
 <SagsTidslinje
 haendelser={filtrerede}
 alle_haendelser={haendelser}
 sag_søg={sag_søg}
 setSagSøg={setSagSøg}
 filter_type={filter_type}
 setFilterType={setFilterType}
 filter_periode={filter_periode}
 setFilterPeriode={setFilterPeriode}
 onRedigerHaendelse={setRedigerHaendelse}
 onMarkerSet={marker_haendelse_set}
 onNotatOpdateret={hent_haendelser}
 onDeadlineDialog={setDeadlineDialog}
 onFlytHaendelse={h => { setFlytDialog(h); setFlytSøg(''); setFlytBekræft(null); setFlytFejl(''); }}
 HAENDELSE_TYPER_KO={HAENDELSE_TYPER_KO}
 beregn_deadline_info={beregn_deadline_info}
 HændelseFilTæller={HændelseFilTæller}
 HændelseFiler={HændelseFiler}
 T={T}
 onGenererDokument={onGenererDokument}
 maal_id={maal_haendelse_id}
 onMaalVist={onMaalAabnet}
 />
 </>
 );
 })()}
 {/* ── REDIGER HÆNDELSE DIALOG — renderes via portal til document.body
 for at undgå at filter/transform på forældre-elementer bryder
 position:fixed og placerer dialogen ved siden af skærmen ── */}
 {rediger_haendelse && createPortal(
 <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.75)", zIndex:10000, display:"flex", alignItems:"center", justifyContent:"center", padding:16, overflowY:"auto" }}
 onClick={() => setRedigerHaendelse(null)}> <div style={{ background:"rgba(10,14,46,0.98)", border:T.kort_kant, borderRadius:18, padding:"24px 28px", width:"min(560px,100%)", boxShadow:"0 16px 48px rgba(0,0,0,0.6)", margin:"auto" }}
 onClick={e => e.stopPropagation()}> <div style={{ fontSize:15, fontWeight:600, color:T.turkis, marginBottom:20 }}> Rediger hændelse</div>
 {/* Dato */}
 <div style={{ marginBottom:16 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:8 }}>
 Dato for modtagelse/handling <span style={{ color:T.roed }}>*</span> </div> <div style={{ display:"flex", gap:8, marginBottom:8 }}> <button onClick={() => setRedigerHaendelse(p => ({...p, begivenhedsdato: new Date().toISOString().split("T")[0]}))}
 style={{ flex:1, padding:"10px", borderRadius:8, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", cursor:"pointer",
 background: rediger_haendelse.begivenhedsdato === new Date().toISOString().split("T")[0] ? `${T.turkis}22` : "rgba(255,255,255,0.04)",
 border: rediger_haendelse.begivenhedsdato === new Date().toISOString().split("T")[0] ? `2px solid ${T.turkis}` : T.skillelinje,
 color: rediger_haendelse.begivenhedsdato === new Date().toISOString().split("T")[0] ? T.turkis : T.dæmpet }}>
 I dag
 </button> <button onClick={() => setRedigerHaendelse(p => ({...p, vis_dato_vælger: true}))}
 style={{ flex:1, padding:"10px", borderRadius:8, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", cursor:"pointer",
 background: "rgba(255,255,255,0.04)", border: T.skillelinje, color: T.dæmpet }}>
 Vælg dato
 </button> </div> <input type="date" value={rediger_haendelse.begivenhedsdato || ""}
 onChange={e => setRedigerHaendelse(p => ({...p, begivenhedsdato:e.target.value}))}
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:`1px solid ${T.turkis}55`, borderRadius:8, padding:"10px 12px", color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", colorScheme:"dark", boxSizing:"border-box" }} />
 {rediger_haendelse.begivenhedsdato && <div style={{ fontSize:12, color:T.turkis, marginTop:4 }}> {new Date(rediger_haendelse.begivenhedsdato).toLocaleDateString("da-DK", {day:"numeric",month:"long",year:"numeric"})}</div>}
 </div>
 {/* Klokkeslæt — valgfrit, bruges til korrekt sortering samme dag */}
 {rediger_haendelse.begivenhedsdato && (
 <div style={{ marginBottom:16 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:8 }}>
 Klokkeslæt (valgfrit) </div>
 <input type="time" value={rediger_haendelse.begivenhedstid || ""}
 onChange={e => setRedigerHaendelse(p => ({...p, begivenhedstid:e.target.value}))}
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:`1px solid ${T.turkis}55`, borderRadius:8, padding:"10px 12px", color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", colorScheme:"dark", boxSizing:"border-box" }} />
 </div>
 )}
 {/* Type */}
 <div style={{ marginBottom:16 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:8 }}>Type</div> <div style={{ display:"flex", flexWrap:"wrap", gap:6 }}>
 {HAENDELSE_TYPER_KO.map(t => {
 const aktiv = rediger_haendelse.type === t.value;
 return (
 <button key={t.value} onClick={() => setRedigerHaendelse(p => ({...p, type:t.value}))}
 style={{ padding:"7px 12px", borderRadius:7, fontSize:12, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif",
 border:`1px solid ${aktiv ? t.farve+"88" : "rgba(255,255,255,0.08)"}`,
 background: aktiv ? `linear-gradient(135deg, ${t.farve}20, ${t.farve}0a)` : "rgba(255,255,255,0.04)",
 color: aktiv ? t.farve : T.dæmpet,
 display:"flex", alignItems:"center", gap:5,
 boxShadow: aktiv ? `0 0 14px ${t.farve}28` : "none",
 transform: aktiv ? "scale(1.04)" : "scale(1)",
 fontWeight: aktiv ? 600 : 400,
 transition:"all 0.2s cubic-bezier(0.34,1.56,0.64,1)",
 }}> <span>{t.ikon}</span> {t.label}
 </button>
 );
 })}
 </div> </div>
 {/* Titel */}
 <div style={{ marginBottom:14 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:7 }}>
 Titel <span style={{ color:T.turkis }}>*</span> </div> <input value={rediger_haendelse.titel} onChange={e => setRedigerHaendelse(p => ({...p, titel:e.target.value}))}
 spellCheck="true" lang="da"
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"12px 14px", color:T.creme, fontSize:14, fontFamily:"'Inter',system-ui,sans-serif", boxSizing:"border-box" }} /> </div>
 {/* Beskrivelse */}
 <div style={{ marginBottom:18 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:7 }}>Beskrivelse</div> <textarea value={rediger_haendelse.beskrivelse} onChange={e => setRedigerHaendelse(p => ({...p, beskrivelse:e.target.value}))}
 spellCheck="true" lang="da" rows={5}
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"10px 12px", color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", resize:"vertical", boxSizing:"border-box" }} /> </div>
 {/* Deadline */}
 <div style={{ marginBottom:18 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:7 }}>Deadline <span style={{ fontSize:11, fontWeight:400, textTransform:"none", letterSpacing:0 }}>(valgfri)</span></div>
 <div style={{ display:"flex", gap:8, alignItems:"center" }}>
 <input type="date" value={rediger_haendelse.deadline || ""} onChange={e => setRedigerHaendelse(p => ({...p, deadline: e.target.value || ''}))}
 style={{ flex:1, background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"10px 12px", color: rediger_haendelse.deadline ? T.creme : T.dæmpet, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", colorScheme:"dark", boxSizing:"border-box" }} />
 {rediger_haendelse.deadline && <button onClick={() => setRedigerHaendelse(p => ({...p, deadline:'', deadline_titel:''}))} title="Fjern deadline" style={{ background:"none", border:"none", color:T.roed, fontSize:16, cursor:"pointer", padding:"4px 6px", flexShrink:0 }}>×</button>}
 </div>
 {rediger_haendelse.deadline && <div style={{ fontSize:12, color:T.turkis, marginTop:4 }}>{new Date(rediger_haendelse.deadline).toLocaleDateString("da-DK",{day:"numeric",month:"long",year:"numeric"})}</div>}
 {rediger_haendelse.deadline && (
 <div style={{ marginTop:10 }}>
 <input value={rediger_haendelse.deadline_titel || ""} onChange={e => setRedigerHaendelse(p => ({...p, deadline_titel:e.target.value}))}
 placeholder='Hvad skal der følges op på? Fx "Følg op på om aktindsigten er modtaget"'
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border: !String(rediger_haendelse.deadline_titel||"").trim() ? `1px solid ${T.roed}66` : T.skillelinje, borderRadius:8, padding:"10px 12px", color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", boxSizing:"border-box" }} />
 {!String(rediger_haendelse.deadline_titel||"").trim() && <div style={{ fontSize:11, color:T.roed, marginTop:4 }}>Deadline-titel er påkrævet når der er sat en deadline</div>}
 </div>
 )}
 </div>
 {/* ── Strukturerede dimensioner i redigér ── */}
 <div style={{ marginBottom:16, background:"rgba(63,212,199,0.04)", border:`1px solid ${T.turkis}22`, borderRadius:10, padding:"14px 14px 10px" }}>
 <div style={{ fontSize:11, fontWeight:700, letterSpacing:"0.15em", textTransform:"uppercase", color:T.turkis, marginBottom:12, opacity:0.8 }}>Strukturerede dimensioner</div>
 <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
 {[
 ["retning", "Retning", ["Indgående","Udgående","Intern"]],
 ["part", "Part", ["Familieretshuset","Politiet","Klient","Modpart","Advokat (klientens)","Advokat (modpartens)","Retten","Kommunen","Børnehus","Andre myndigheder","SkilsmisseVejen (intern)","Skifteretten","Ankestyrelsen","Mægler/mediator"]],
 ["haendelse_type", "Hændelsestype", ["Aktindsigt","Anmodning","Afgørelse","Dokument","Partshøring","Aftale","Brev/korrespondance","Møde","Telefonopkald","Mail","Notat","Klage","Indkaldelse","Erklæring","Samtykkeerklæring","Bilag fra klienten"]],
 ["emne", "Emne", ["Forældremyndighed","Samvær","Bopæl","Bidrag","Bodeling","Separation","Skilsmisse","Tvangsfuldbyrding"]],
 ["haendelse_status", "Status", ["Kladde","Sendt/Indsendt","Modtaget","Afventer svar","Besvaret","Afsluttet/Lukket","Anket","Bortfaldet"]],
 ].map(([felt, label, valgmuligheder]) => (
 <div key={felt} style={{ gridColumn: felt === "haendelse_status" ? "span 2" : undefined }}>
 <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:6 }}>{label}</div>
 <select
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"9px 12px", color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", colorScheme:"dark", boxSizing:"border-box" }}
 value={rediger_haendelse[felt] || ""}
 onChange={e => setRedigerHaendelse(p => ({...p, [felt]: e.target.value || null}))}
 >
 <option value="">— Vælg {label.toLowerCase()} —</option>
 {valgmuligheder.map(v => <option key={v} value={v}>{v}</option>)}
 </select>
 </div>
 ))}
 </div>
 </div>
 {/* Vedhæft filer → OneDrive */}
 <div style={{ marginBottom:16 }}>
 <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:8 }}>Vedhæft filer → OneDrive</div>
 <input ref={edit_upload_ref} type="file" multiple style={{ display:"none" }}
 accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.xlsx,.xls,.mp4,.mp3"
 onChange={e => {
 const nye = Array.from(e.target.files).map(f => ({
 id: Date.now() + Math.random(),
 fil: f,
 visningsnavn: f.name.replace(/\.[^.]+$/, ""),
 extension: f.name.match(/\.[^.]+$/)?.[0] || "",
 kategori: edit_upload_kategori,
 status: "klar",
 }));
 setEditUploadFiler(p => [...p, ...nye]);
 e.target.value = "";
 }} />
 <div style={{ marginBottom:10 }}>
 <div style={{ fontSize:12, color:T.dæmpet, marginBottom:6 }}>Gem i kategori:</div>
 <select value={edit_upload_kategori} onChange={e => setEditUploadKategori(e.target.value)}
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"9px 12px", color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", colorScheme:"dark" }}>
 {["Journal","Aktindsigt","Oplysninger","Dom","Klager","Indkaldelse","Sagsopstart","Retten","Bilag klient","Afgørelser","Børnesamtaler","Kommunikation","Mødenotater","Partshøring","Sagsakter","Underretninger","Video","Lyd","Nyttige bilag","Log og data"].map(k => (
 <option key={k} value={k}>{k}</option>
 ))}
 </select>
 </div>
 {edit_upload_filer.length > 0 && (
 <div style={{ marginBottom:8 }}>
 {edit_upload_filer.map(uf => (
 <div key={uf.id} style={{ background:"rgba(0,0,0,0.2)", border:T.skillelinje, borderRadius:8, padding:"10px 12px", marginBottom:6, display:"flex", alignItems:"center", gap:8 }}>
 <div style={{ flex:1, minWidth:0 }}>
 <input value={uf.visningsnavn || uf.fil.name.replace(/\.[^.]+$/, "")}
 onChange={e => setEditUploadFiler(p => p.map(x => x.id===uf.id ? {...x, visningsnavn: e.target.value} : x))}
 spellCheck="true" lang="da"
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:`1px solid ${T.turkis}55`, borderRadius:6, color:T.creme, fontSize:12, fontFamily:"'Inter',system-ui,sans-serif", padding:"6px 10px", outline:"none", boxSizing:"border-box" }}
 title="Rediger filnavn" placeholder="Filnavn..." />
 <div style={{ fontSize:12, color:T.dæmpet }}>{(uf.fil.size/1024).toFixed(0)} KB → {edit_upload_kategori}</div>
 </div>
 <button onClick={() => setEditUploadFiler(p => p.filter(x => x.id !== uf.id))} style={{ background:"none", border:"none", color:T.roed, fontSize:18, cursor:"pointer", flexShrink:0 }}>×</button>
 </div>
 ))}
 </div>
 )}
 <button onClick={() => edit_upload_ref.current?.click()}
 onMouseOver={e => { e.currentTarget.style.borderColor=`${T.turkis}55`; e.currentTarget.style.color=T.turkis; e.currentTarget.style.background=`rgba(63,212,199,0.04)`; }}
 onMouseOut={e => { e.currentTarget.style.borderColor="rgba(255,255,255,0.07)"; e.currentTarget.style.color="rgba(148,163,184,0.7)"; e.currentTarget.style.background="none"; }}
 disabled={edit_uploading}
 style={{ width:"100%", background:"none", border:"1px dashed rgba(255,255,255,0.07)", borderRadius:10, padding:"13px", color:"rgba(148,163,184,0.7)", fontSize:12, cursor: edit_uploading ? "not-allowed" : "pointer", fontFamily:"'Inter',system-ui,sans-serif", transition:"all 0.25s cubic-bezier(0.4,0,0.2,1)", display:"flex", alignItems:"center", justifyContent:"center", gap:6, opacity: edit_uploading ? 0.4 : 1 }}>
 Tilføj filer til <strong style={{ color:"rgba(148,163,184,0.9)", marginLeft:4 }}>{edit_upload_kategori}</strong><span style={{ marginLeft:4 }}>— gemmes på OneDrive</span>
 </button>
 </div>
 {edit_uploading && (
 <div style={{ marginBottom:12 }}>
 <div style={{ display:"flex", justifyContent:"space-between", fontSize:12, color:T.dæmpet, marginBottom:4 }}>
 <span>Uploader {edit_upload_progress.aktuel ? `"${edit_upload_progress.aktuel}"` : ""}...</span>
 <span>{edit_upload_progress.done}/{edit_upload_progress.total} filer</span>
 </div>
 <div style={{ height:4, background:"rgba(0,0,0,0.1)", borderRadius:2, overflow:"hidden" }}>
 <div style={{ height:"100%", width: (edit_upload_progress.total ? (edit_upload_progress.done/edit_upload_progress.total)*100 : 0)+"%", background:T.turkis, borderRadius:2, transition:"width 0.3s" }} />
 </div>
 </div>
 )}
 {/* Knapper */}
 {rediger_haendelse.confirm_slet ? (
 <div> <div style={{ fontSize:13, color:"#ff6b6b", fontWeight:600, marginBottom:8 }}>Bekræft sletning — angiv begrundelse:</div> <textarea
 placeholder="Fx: Fejlagtigt importeret dokument..."
 value={rediger_haendelse.slet_begrundelse || ""}
 onChange={e => setRedigerHaendelse(p => ({...p, slet_begrundelse: e.target.value}))}
 style={{ width:"100%", minHeight:64, background:"rgba(255,255,255,0.06)", border:"1px solid rgba(255,107,107,0.5)", borderRadius:8, padding:"10px 12px", color:"#e2e8f0", fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", resize:"vertical", boxSizing:"border-box" }}
 /> <div style={{ display:"flex", gap:8, marginTop:8 }}> <button onClick={() => setRedigerHaendelse(p => ({...p, confirm_slet:false, slet_begrundelse:""}))}
 style={{ flex:1, background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"12px", color:T.dæmpet, fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Fortryd
 </button> <button onClick={async () => {
 if (!(rediger_haendelse.slet_begrundelse || "").trim()) { toast("Begrundelse er påkrævet", "fejl"); return; }
 const r = await api("haendelser/" + rediger_haendelse.id, "DELETE", { begrundelse: rediger_haendelse.slet_begrundelse });
 if (!r || r.fejl) { toast("Kunne ikke slette: " + (r?.fejl || "serverfejl"), "fejl"); return; }
 setHaendelser(p => p.filter(h => h.id !== rediger_haendelse.id));
 setRedigerHaendelse(null);
 toast("Hændelse slettet", "success");
 }} style={{ flex:2, background:"rgba(255,107,107,0.15)", border:"1px solid rgba(255,107,107,0.5)", borderRadius:8, padding:"12px", color:"#ff6b6b", fontWeight:700, fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Slet permanent
 </button> </div> </div>
 ) : (
 <div style={{ display:"flex", gap:8 }}> <button onClick={() => setRedigerHaendelse(p => ({...p, confirm_slet:true}))}
 style={{ background:"rgba(255,107,107,0.08)", border:"1px solid rgba(255,107,107,0.3)", borderRadius:8, padding:"12px 14px", color:"#ff6b6b", fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}
 title="Slet hændelse">Slet</button> <button onClick={() => setRedigerHaendelse(null)}
 style={{ flex:1, background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"12px", color:T.dæmpet, fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Annuller
 </button> <button disabled={edit_uploading} onClick={async () => {
 if (!rediger_haendelse.titel.trim()) return;
 if (rediger_haendelse.deadline && !String(rediger_haendelse.deadline_titel||"").trim()) {
 toast("Deadline-titel er påkrævet når der er sat en deadline", "fejl");
 return;
 }
 const r = await api("haendelser/" + rediger_haendelse.id, "PATCH", {
 titel: rediger_haendelse.titel,
 beskrivelse: rediger_haendelse.beskrivelse,
 begivenhedsdato: rediger_haendelse.begivenhedsdato || null,
 begivenhedstid: rediger_haendelse.begivenhedstid || null,
 deadline: rediger_haendelse.deadline || null,
 deadline_titel: rediger_haendelse.deadline ? String(rediger_haendelse.deadline_titel).trim() : null,
 type: rediger_haendelse.type,
 retning: rediger_haendelse.retning || null,
 part: rediger_haendelse.part || null,
 haendelse_type: rediger_haendelse.haendelse_type || null,
 emne: rediger_haendelse.emne || null,
 haendelse_status: rediger_haendelse.haendelse_status || null,
 });
 if (!r || r.fejl) {
 toast("Kunne ikke gemme hændelse: " + (r?.fejl || "serverfejl"), "fejl");
 return;
 }
 setHaendelser(p => p.map(h => h.id === rediger_haendelse.id
 ? {...h, titel:rediger_haendelse.titel, beskrivelse:rediger_haendelse.beskrivelse, begivenhedsdato:rediger_haendelse.begivenhedsdato, begivenhedstid:rediger_haendelse.begivenhedstid || null, deadline:rediger_haendelse.deadline || null, deadline_titel:rediger_haendelse.deadline ? rediger_haendelse.deadline_titel : null, type:rediger_haendelse.type,
 retning:rediger_haendelse.retning, part:rediger_haendelse.part, haendelse_type:rediger_haendelse.haendelse_type, emne:rediger_haendelse.emne, haendelse_status:rediger_haendelse.haendelse_status}
 : h));
 synk_sag_deadline(rediger_haendelse.deadline || null, rediger_haendelse.deadline ? rediger_haendelse.deadline_titel : "");
 if (edit_upload_filer.length > 0) {
 setEditUploading(true);
 setEditUploadProgress({ done: 0, total: edit_upload_filer.length });
 let ok_count = 0;
 let fejl_filer = [];
 for (let i = 0; i < edit_upload_filer.length; i++) {
 const uf = edit_upload_filer[i];
 setEditUploadProgress({ done: i, total: edit_upload_filer.length, aktuel: uf.visningsnavn || uf.fil.name });
 try {
 const session = await api("filer/upload-session", "POST", {
 sag_id: sagId,
 haendelse_id: rediger_haendelse.id,
 kategori: uf.kategori,
 filnavn: uf.fil.name,
 visningsnavn: uf.visningsnavn || uf.fil.name,
 });
 if (session?.upload_url) {
 await onedrive_upload(session.upload_url, uf.fil, () => {});
 await api("filer/registrer", "POST", {
 sag_id: sagId,
 haendelse_id: rediger_haendelse.id,
 kategori: uf.kategori,
 original_navn: uf.fil.name,
 visningsnavn: uf.visningsnavn || uf.fil.name,
 størrelse: uf.fil.size,
 mime_type: uf.fil.type,
 onedrive_sti: session.onedrive_sti,
 });
 ok_count++;
 } else {
 fejl_filer.push(uf.fil.name + ": " + (session?.fejl || "Kunne ikke starte upload"));
 }
 } catch(upload_err) {
 console.error('[Upload-edit] fejl for', uf.fil.name, ':', upload_err);
 fejl_filer.push(uf.fil.name + ": Upload fejlede");
 }
 }
 setEditUploadProgress({ done: edit_upload_filer.length, total: edit_upload_filer.length });
 setEditUploading(false);
 if (fejl_filer.length > 0) {
 toast(`Hændelse gemt. ${ok_count} af ${edit_upload_filer.length} filer uploadet. Fejl: ${fejl_filer.join(", ")}`, "fejl");
 } else {
 toast(`Hændelse gemt + ${ok_count} fil${ok_count > 1 ? "er" : ""} uploadet til OneDrive`, "success");
 }
 setRedigerHaendelse(null);
 } else {
 setRedigerHaendelse(null);
 toast("Hændelse gemt", "success");
 }
 }} style={{ flex:2, background: edit_uploading ? `${T.turkis}88` : T.turkis, border:"none", borderRadius:8, padding:"12px", color:"#ffffff", fontWeight:700, fontSize:13, cursor: edit_uploading ? "not-allowed" : "pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 {edit_uploading ? "Uploader filer..." : `Gem ændringer${edit_upload_filer.length > 0 ? ` + ${edit_upload_filer.length} fil${edit_upload_filer.length > 1 ? "er" : ""}` : ""}`}
 </button> </div>
 )}
 </div> </div>,
 document.body
 )}
 {flyt_dialog && createPortal(
 <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.75)", zIndex:10000, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}
 onClick={() => !flyt_loading && setFlytDialog(null)}>
 <div style={{ background:"rgba(10,14,46,0.98)", border:T.kort_kant, borderRadius:18, padding:"24px 28px", width:"min(480px,100%)", boxShadow:"0 16px 48px rgba(0,0,0,0.6)" }}
 onClick={e => e.stopPropagation()}>
 <div style={{ fontSize:18, fontWeight:700, color:T.creme, marginBottom:4 }}>Flyt hændelse</div>
 <div style={{ fontSize:13, color:T.dæmpet, marginBottom:20 }}>
 "{flyt_dialog.titel}"{flyt_dialog.filer_antal > 0 ? ` + ${flyt_dialog.filer_antal} fil${flyt_dialog.filer_antal > 1 ? 'er' : ''}` : ''} flyttes til en anden sag
 </div>
 {!flyt_bekræft ? (<>
 <input autoFocus type="text" placeholder="Søg på sagsnummer eller klientnavn..." value={flyt_søg}
 onChange={e => setFlytSøg(e.target.value)}
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"10px 12px", color:T.creme, fontSize:13, colorScheme:"dark", boxSizing:"border-box", marginBottom:12 }} />
 <div style={{ maxHeight:240, overflowY:"auto", display:"flex", flexDirection:"column", gap:4 }}>
 {sager.filter(s => String(s.id) !== String(sagId) && (!flyt_søg.trim() || (s.sagsnummer||'').toLowerCase().includes(flyt_søg.toLowerCase()) || (s.klient||'').toLowerCase().includes(flyt_søg.toLowerCase()))).slice(0,20).map(s => (
 <button key={s.id} onClick={() => setFlytBekræft(s)}
 style={{ background:"rgba(255,255,255,0.04)", border:T.skillelinje, borderRadius:8, padding:"10px 14px", color:T.creme, fontSize:13, cursor:"pointer", textAlign:"left", transition:"background 0.12s" }}
 onMouseOver={e => e.currentTarget.style.background="rgba(255,255,255,0.09)"}
 onMouseOut={e => e.currentTarget.style.background="rgba(255,255,255,0.04)"}>
 <span style={{ color:T.turkis, fontWeight:600 }}>{s.sagsnummer}</span>{' — '}<span>{s.klient}</span>
 </button>
 ))}
 </div>
 {flyt_fejl && <div style={{ fontSize:12, color:T.roed, marginTop:8 }}>{flyt_fejl}</div>}
 <div style={{ display:"flex", gap:8, marginTop:16, justifyContent:"flex-end" }}>
 <button onClick={() => setFlytDialog(null)}
 style={{ background:"none", border:T.skillelinje, borderRadius:8, padding:"10px 18px", color:T.dæmpet, fontSize:13, cursor:"pointer" }}>Annullér</button>
 </div>
 </>) : (<>
 <div style={{ background:"rgba(255,255,255,0.04)", border:T.skillelinje, borderRadius:10, padding:"14px 16px", marginBottom:16 }}>
 <div style={{ fontSize:12, color:T.dæmpet, marginBottom:4 }}>Flyttes til:</div>
 <div style={{ fontSize:15, fontWeight:700, color:T.turkis }}>{flyt_bekræft.sagsnummer}</div>
 <div style={{ fontSize:13, color:T.creme }}>{flyt_bekræft.klient}</div>
 </div>
 {flyt_fejl && <div style={{ fontSize:12, color:T.roed, marginBottom:12 }}>{flyt_fejl}</div>}
 <div style={{ display:"flex", gap:8, justifyContent:"flex-end" }}>
 <button onClick={() => setFlytBekræft(null)} disabled={flyt_loading}
 style={{ background:"none", border:T.skillelinje, borderRadius:8, padding:"10px 18px", color:T.dæmpet, fontSize:13, cursor:"pointer" }}>Tilbage</button>
 <button disabled={flyt_loading} onClick={async () => {
 setFlytLoading(true); setFlytFejl('');
 const r = await api('haendelser/' + flyt_dialog.id + '/flyt', 'POST', { ny_sag_id: Number(flyt_bekræft.id) });
 setFlytLoading(false);
 if (!r || r.fejl) { setFlytFejl(r?.fejl || 'Serverfejl'); return; }
 setHaendelser(p => p.filter(h => h.id !== flyt_dialog.id));
 setFlytDialog(null);
 toast('Hændelse flyttet til ' + flyt_bekræft.sagsnummer, 'success');
 }}
 style={{ background: flyt_loading ? `${T.turkis}88` : T.turkis, border:"none", borderRadius:8, padding:"10px 18px", color:"#fff", fontWeight:700, fontSize:13, cursor: flyt_loading ? "not-allowed" : "pointer" }}>
 {flyt_loading ? 'Flytter...' : 'Bekræft flytning'}
 </button>
 </div>
 </>)}
 </div></div>,
 document.body
 )}
 </div>
 );
}
// ─────────────────────────────────────────────────────────
// EKSTERNE KONTAKTER — socialrådgiver, familiekonsulent osv.
// ─────────────────────────────────────────────────────────
const KONTAKT_TYPER = [
 "Socialrådgiver", "Familiekonsulent", "Børnesagkyndig",
 "Familieretshuset", "Kommunal sagsbehandler", "Modparts advokat",
 "Psykolog", "Læge/speciallæge", "Statsforvaltning",
 "Skole/daginstitution", "Politi", "Andet",
];
function EksterneKontakter({ sagId, sager, setSager }) {
 const sag = sager.find(s => s.id === sagId) || {};
 const kontakter = sag.eksterne_kontakter || [];
 const [vis_form, setVisForm] = useState(false);
 const [form, setForm] = useState({ navn:"", type:"Socialrådgiver", organisation:"", email:"", telefon:"", noter:"" });
 const [fejl, setFejl] = useState("");
 const [redigerer, setRedigerer] = useState(null);
 const f = felt => e => setForm(p => ({ ...p, [felt]: e.target.value }));
 const gem = () => {
 if (!form.navn.trim()) { setFejl("Navn er påkrævet"); return; }
 setFejl("");
 if (redigerer !== null) {
 // Rediger eksisterende
 setSager(p => p.map(s => s.id === sagId ? {
 ...s, eksterne_kontakter: kontakter.map((k,i) => i === redigerer ? { ...form } : k)
 } : s));
 setRedigerer(null);
 } else {
 // Tilføj ny
 setSager(p => p.map(s => s.id === sagId ? {
 ...s, eksterne_kontakter: [...kontakter, { ...form, id: Date.now() }]
 } : s));
 }
 setForm({ navn:"", type:"Socialrådgiver", organisation:"", email:"", telefon:"", noter:"" });
 setVisForm(false);
 };
 const slet = (idx) => setSager(p => p.map(s => s.id === sagId ? {
 ...s, eksterne_kontakter: kontakter.filter((_,i) => i !== idx)
 } : s));
 const start_rediger = (k, idx) => {
 setForm({ navn:k.navn, type:k.type, organisation:k.organisation||"", email:k.email||"", telefon:k.telefon||"", noter:k.noter||"" });
 setRedigerer(idx);
 setVisForm(true);
 };
 const panel = { background:"rgba(255,255,255,0.06)", border:T.kort_kant, borderRadius:16, backdropFilter:"blur(20px)", WebkitBackdropFilter:"blur(20px)" };
 const TYPE_FARVER = {
 "Socialrådgiver":"#60a5fa", "Familiekonsulent":"#c084fc",
 "Børnesagkyndig":"#06d6a0", "Familieretshuset":"#f97316",
 "Kommunal sagsbehandler":"#60a5fa", "Modparts advokat":"#ff6b6b",
 "Psykolog":"#a78bfa", "Læge/speciallæge":"#06d6a0",
 "Statsforvaltning":"#f97316", "Skole/daginstitution":"#ffd166",
 "Politi":"#ff6b6b", "Andet":"#6b7280",
 };
 return (
 <div style={{ animation:"sv-panel-enter 0.4s cubic-bezier(0.34,1.56,0.64,1) both" }}>
 {/* Tilføj knap */}
 <button onClick={() => { setVisForm(!vis_form); setRedigerer(null); setForm({ navn:"", type:"Socialrådgiver", organisation:"", email:"", telefon:"", noter:"" }); }} style={{
 width:"100%", background: vis_form ? "rgba(255,255,255,0.06)" : T.turkis,
 border: vis_form ? T.skillelinje : "none",
 borderRadius:10, padding:"13px", color: vis_form ? T.dæmpet : "#ffffff",
 fontWeight:700, fontSize:14, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif",
 marginBottom:14, transition:"all 0.2s",
 }}>
 {vis_form ? "Annuller" : redigerer !== null ? "Rediger kontakt" : "+ Tilføj ekstern kontakt"}
 </button>
 {/* Formular */}
 {vis_form && (
 <div style={{ ...panel, padding:20, marginBottom:16, animation:"fadeUp 0.25s ease" }}> <div style={{ fontSize:12, color:T.turkis, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:16 }}>
 {redigerer !== null ? "Rediger kontakt" : "Ny ekstern kontakt"}
 </div>
 {/* Type */}
 <div style={{ marginBottom:14 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:7 }}>Rolle / funktion</div> <div style={{ display:"flex", flexWrap:"wrap", gap:6 }}>
 {KONTAKT_TYPER.map(t => (
 <button key={t} onClick={() => setForm(p=>({...p, type:t}))} style={{
 padding:"6px 12px", borderRadius:7, fontSize:12, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif",
 border:`1px solid ${form.type===t ? (TYPE_FARVER[t]||T.turkis) : "rgba(255,255,255,0.08)"}`,
 background: form.type===t ? `${TYPE_FARVER[t]||T.turkis}18` : "rgba(255,255,255,0.04)",
 color: form.type===t ? (TYPE_FARVER[t]||T.turkis) : T.dæmpet,
 transition:"all 0.15s",
 }}>{t}</button>
 ))}
 </div> </div>
 {/* Navn og organisation */}
 <div className="sv-form-grid" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 12px" }}> <div style={{ marginBottom:14 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:7 }}>
 Navn <span style={{ color:T.turkis }}>*</span> </div> <input value={form.navn} onChange={f("navn")} placeholder="Fornavn Efternavn"
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:`1px solid ${fejl?"rgba(255,107,107,0.5)":"rgba(255,255,255,0.06)"}`, borderRadius:9, padding:"11px 14px", color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", boxSizing:"border-box" }} />
 {fejl && <div style={{ color:T.roed, fontSize:12, marginTop:4 }}>{fejl}</div>}
 </div> <div style={{ marginBottom:14 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:7 }}>Organisation</div> <input value={form.organisation} onChange={f("organisation")} placeholder="fx Herning Kommune"
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:9, padding:"11px 14px", color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", boxSizing:"border-box" }} /> </div> </div>
 {/* Email og telefon */}
 <div className="sv-form-grid" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 12px" }}> <div style={{ marginBottom:14 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:7 }}>Email</div> <input value={form.email} onChange={f("email")} placeholder="email@kommune.dk" type="email"
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:9, padding:"11px 14px", color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", boxSizing:"border-box" }} /> </div> <div style={{ marginBottom:14 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:7 }}>Telefon</div> <input value={form.telefon} onChange={f("telefon")} placeholder="+45 XX XX XX XX" type="tel"
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:9, padding:"11px 14px", color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", boxSizing:"border-box" }} /> </div> </div>
 {/* Noter */}
 <div style={{ marginBottom:18 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:7 }}>Noter om kontakten</div> <textarea onInput={e=>{e.target.style.height="auto";e.target.style.height=e.target.scrollHeight+"px";}} value={form.noter} onChange={f("noter")}
 placeholder="fx journalnummer, hvornår de er tilgængelige, særlige aftaler..."
 rows={3} spellCheck="true" lang="da"
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:9, padding:"11px 14px", color:T.creme, fontSize:13, resize:"none", lineHeight:1.6, fontFamily:"'Inter',system-ui,sans-serif", boxSizing:"border-box" }} /> </div> <Knap onClick={gem} style={{ width:"100%", padding:"13px" }}>
 {redigerer !== null ? "Gem ændringer" : "Tilføj kontakt"}
 </Knap> </div>
 )}
 {/* Kontaktliste */}
 {kontakter.length === 0 ? (
 <div style={{ ...panel, padding:"32px", textAlign:"center" }}> <div style={{ fontSize:32, marginBottom:10 }}></div> <div style={{ color:T.lys, fontSize:14, marginBottom:6 }}>Ingen eksterne kontakter endnu</div> <div style={{ color:T.dæmpet, fontSize:12, lineHeight:1.7, marginBottom:16 }}>
 Tilføj socialrådgivere, familiekonsulenter, kommunale sagsbehandlere,<br />
 modparts advokat og andre relevante kontakter
 </div> <Knap onClick={() => setVisForm(true)} style={{ padding:"10px 20px" }}>+ Tilføj kontakt</Knap> </div>
 ) : (
 <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
 {kontakter.map((k, idx) => {
 const farve = TYPE_FARVER[k.type] || T.dæmpet;
 return (
 <div key={k.id||idx} style={{ ...panel, padding:"16px 18px" }}> <div style={{ display:"flex", alignItems:"flex-start", gap:12 }}>
 {/* Avatar */}
 <div style={{ width:40, height:40, borderRadius:"50%", background:`${farve}18`, border:`1px solid ${farve}44`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:14, fontWeight:600, color:farve, flexShrink:0 }}>
 {k.navn.split(" ").map(n=>n[0]).join("").slice(0,2).toUpperCase()}
 </div> <div style={{ flex:1 }}>
 {/* Navn og type */}
 <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:4, flexWrap:"wrap" }}> <span style={{ fontSize:14, fontWeight:500, color:T.creme }}>{k.navn}</span> <span style={{ fontSize:12, letterSpacing:"0.08em", textTransform:"uppercase", padding:"2px 8px", borderRadius:4, color:farve, background:`${farve}12`, border:`1px solid ${farve}25` }}>
 {k.type}
 </span> </div>
 {/* Organisation */}
 {k.organisation && (
 <div style={{ fontSize:12, color:T.dæmpet, marginBottom:8 }}> {k.organisation}</div>
 )}
 {/* Kontaktinfo */}
 <div style={{ display:"flex", gap:16, flexWrap:"wrap", marginBottom: k.noter ? 8 : 0 }}>
 {k.email && (
 <a href={`mailto:${k.email}`} style={{ fontSize:12, color:"#60a5fa", textDecoration:"none", display:"flex", alignItems:"center", gap:4 }}>
 {k.email}
 </a>
 )}
 {k.telefon && (
 <a href={`tel:${k.telefon}`} style={{ fontSize:12, color:T.groen, textDecoration:"none", display:"flex", alignItems:"center", gap:4 }}>
 {k.telefon}
 </a>
 )}
 </div>
 {/* Noter */}
 {k.noter && (
 <div style={{ fontSize:12, color:"#b0bec5", lineHeight:1.6, fontStyle:"italic", marginTop:4 }}>{k.noter}</div>
 )}
 </div>
 {/* Handlinger */}
 <div style={{ display:"flex", gap:6, flexShrink:0 }}> <button onClick={() => start_rediger(k, idx)} style={{ background:"none", border:T.skillelinje, borderRadius:6, padding:"5px 10px", color:T.dæmpet, fontSize:12, cursor:"pointer" }}>Rediger</button> <button onClick={() => slet(idx)} style={{ background:"none", border:"1px solid rgba(255,107,107,0.3)", borderRadius:6, padding:"5px 10px", color:T.roed, fontSize:12, cursor:"pointer" }}>Slet</button> </div> </div> </div>
 );
 })}
 </div>
 )}
 </div>
 );
}
// ─────────────────────────────────────────────────────────
// SAGSBEHANDLER PANEL — intern tildeling + eksterne kontakter
// ─────────────────────────────────────────────────────────
function SagsbehandlerPanel({ sag, sager, setSager, panel }) {
 const [ny_ekstern, setNyEkstern] = useState({ navn:"", rolle:"", organisation:"", email:"", telefon:"" });
 const [vis_ekstern_form, setVisEksternForm] = useState(false);
 const [gem_besked, setGemBesked] = useState("");
 const [bekræft_slet_id, setBekræftSletId] = useState(null);
 const [ALLE_BRUGERE, setAlleBrugere] = useState([]);
 React.useEffect(() => {
 api("brugere/sagsbehandlere").then(data => {
 if (data && data.brugere) {
 setAlleBrugere(data.brugere.map(b => ({ id: b.id, navn: b.navn })));
 }
 }).catch(err => { console.error(err); });
 }, []);
 const sag_live = sager.find(s => s.id === sag.id) || sag;
 const eksterne = sag_live.eksterne || [];
 const opdater = async (felt, val) => {
 if (felt === "primær") {
 const bruger_obj = typeof val === "object" ? val : ALLE_BRUGERE.find(b => b.navn === val);
 setSager(p => p.map(s => s.id===sag.id ? {...s, primær: bruger_obj?.navn || val, primær_id: bruger_obj?.id} : s));
 try { await api("sager/" + sag.id, "PATCH", { primær_sagsbehandler_id: bruger_obj?.id }); } catch(e) {}
 setGemBesked(" Primær sagsbehandler gemt");
 } else if (felt === "sekundær") {
 if (val === null) {
 setSager(p => p.map(s => s.id===sag.id ? {...s, sekundær: null, sekundær_id: null} : s));
 try { await api("sager/" + sag.id, "PATCH", { sekundær_sagsbehandler_id: null }); } catch(e) {}
 setGemBesked(" Sekundær fjernet");
 } else {
 const bruger_obj = typeof val === "object" ? val : ALLE_BRUGERE.find(b => b.navn === val);
 setSager(p => p.map(s => s.id===sag.id ? {...s, sekundær: bruger_obj?.navn || val, sekundær_id: bruger_obj?.id} : s));
 try { await api("sager/" + sag.id, "PATCH", { sekundær_sagsbehandler_id: bruger_obj?.id }); } catch(e) {}
 setGemBesked(" Sekundær sagsbehandler gemt");
 }
 } else {
 setSager(p => p.map(s => s.id===sag.id ? {...s, [felt]:val} : s));
 }
 setTimeout(() => setGemBesked(""), 2500);
 };
 const tilfoej_ekstern = () => {
 if (!ny_ekstern.navn.trim()) return;
 const ny = { id:Date.now(), ...ny_ekstern };
 setSager(p => p.map(s => s.id===sag.id ? {...s, eksterne:[...(s.eksterne||[]), ny]} : s));
 setNyEkstern({ navn:"", rolle:"", organisation:"", email:"", telefon:"" });
 setVisEksternForm(false);
 setGemBesked(" Kontakt tilføjet");
 setTimeout(() => setGemBesked(""), 2000);
 };
 const slet_ekstern_bekræft = (id) => setBekræftSletId(id);
 const slet_ekstern = (id) => {
 setSager(p => p.map(s => s.id===sag.id ? {...s, eksterne:(s.eksterne||[]).filter(k=>k.id!==id)} : s));
 setBekræftSletId(null);
 };
 const BRUGER_KORT = ({ navn, farve, rolle }) => (
 <div style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 14px", background:"rgba(255,255,255,0.05)", border:`1px solid ${farve}33`, borderRadius:9 }}> <div style={{ width:34, height:34, borderRadius:"50%", background:`${farve}18`, border:`1px solid ${farve}44`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:12, fontWeight:600, color:farve, flexShrink:0 }}>
 {navn?.split(" ").map(n=>n[0]).join("").slice(0,2)||"?"}
 </div> <div> <div style={{ fontSize:13, color:T.creme, fontWeight:500 }}>{navn}</div> <div style={{ fontSize:12, color:farve, textTransform:"uppercase", letterSpacing:"0.08em" }}>{rolle}</div> </div> </div>
 );
 const felt_style = { width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"10px 13px", color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", boxSizing:"border-box", marginBottom:10 };
 return (
 <> <div style={{ animation:"sv-panel-enter 0.4s cubic-bezier(0.34,1.56,0.64,1) both" }}>
 {/* ── INTERN TILDELING ── */}
 <div style={{ ...panel, padding:"20px", marginBottom:14 }}> <div style={{ fontSize:12, color:T.dæmpet, marginBottom:16, lineHeight:1.7 }}>
 Primær har fuld adgang og ansvar for sagen. Sekundær kan se, redigere og journalisere — men ikke godkende dokumenter.
 </div>
 {/* Primær */}
 <div style={{ marginBottom:18 }}> <div style={{ fontSize:12, color:T.turkis, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:10 }}>
 Primær sagsbehandler
 </div> <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
 {ALLE_BRUGERE.map(b => (
 <button key={b.id}
 onClick={() => opdater("primær", b)}
 style={{
 padding:"9px 16px", borderRadius:8, fontSize:13,
 border:`1px solid ${sag_live.primær===b.navn ? T.turkis : "rgba(255,255,255,0.08)"}`,
 background: sag_live.primær===b.navn ? `${T.turkis}18` : "rgba(255,255,255,0.04)",
 color: sag_live.primær===b.navn ? T.turkis : T.dæmpet,
 cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif", transition:"all 0.15s",
 fontWeight: sag_live.primær===b.navn ? 600 : 400,
 }}>
 {sag_live.primær===b.navn ? " " : ""}{b.navn}
 </button>
 ))}
 </div>
 {sag_live.primær && (
 <div style={{ marginTop:10 }}> <BRUGER_KORT navn={sag_live.primær} farve={T.turkis} rolle="Primær sagsbehandler" /> </div>
 )}
 </div>
 {/* Sekundær */}
 <div> <div style={{ fontSize:12, color:"#60a5fa", letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:10 }}>
 Sekundær sagsbehandler <span style={{ color:T.dæmpet, fontWeight:400, textTransform:"none", letterSpacing:"normal", fontSize:12 }}>— valgfri</span> </div> <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}> <button
 onClick={() => opdater("sekundær", null)}
 style={{
 padding:"9px 16px", borderRadius:8, fontSize:13,
 border:`1px solid ${!sag_live.sekundær ? "rgba(255,107,107,0.4)" : "rgba(255,255,255,0.08)"}`,
 background: !sag_live.sekundær ? "rgba(255,107,107,0.08)" : "rgba(255,255,255,0.04)",
 color: !sag_live.sekundær ? T.roed : T.dæmpet,
 cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif",
 fontWeight: !sag_live.sekundær ? 600 : 400,
 }}>
 {!sag_live.sekundær ? " " : ""}Ingen
 </button>
 {ALLE_BRUGERE.filter(b => b.navn !== sag_live.primær).map(b => (
 <button key={b.id}
 onClick={() => opdater("sekundær", b)}
 style={{
 padding:"9px 16px", borderRadius:8, fontSize:13,
 border:`1px solid ${sag_live.sekundær===b.navn ? "#60a5fa" : "rgba(255,255,255,0.08)"}`,
 background: sag_live.sekundær===b.navn ? "rgba(96,165,250,0.15)" : "rgba(255,255,255,0.04)",
 color: sag_live.sekundær===b.navn ? "#60a5fa" : T.dæmpet,
 cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif", transition:"all 0.15s",
 fontWeight: sag_live.sekundær===b.navn ? 600 : 400,
 }}>
 {sag_live.sekundær===b.navn ? " " : ""}{b.navn}
 </button>
 ))}
 </div>
 {sag_live.sekundær && (
 <div style={{ marginTop:10 }}> <BRUGER_KORT navn={sag_live.sekundær} farve="#60a5fa" rolle="Sekundær sagsbehandler" /> </div>
 )}
 </div> </div>
 {/* ── RETTIGHEDER ── */}
 <div style={{ ...panel, padding:"14px 18px", marginBottom:14 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:10 }}>Adgangsoverblik for denne sag</div>
 {[
 { rolle:"Primær", navn:sag_live.primær, farve:T.turkis, ret:["Se sagen","Redigere","Journalisere","Godkende dokumenter","Tildele opgaver"] },
 ...(sag_live.sekundær ? [{ rolle:"Sekundær", navn:sag_live.sekundær, farve:"#60a5fa", ret:["Se sagen","Redigere","Journalisere"] }] : []),
 ].map(item => (
 <div key={item.rolle} style={{ display:"flex", gap:10, padding:"8px 0", borderBottom:T.skillelinje }}> <div style={{ width:8, height:8, borderRadius:"50%", background:item.farve, flexShrink:0, marginTop:5 }} /> <div> <div style={{ fontSize:12, color:item.farve, fontWeight:500, marginBottom:5 }}>{item.rolle}: {item.navn||"Ikke tildelt"}</div> <div style={{ display:"flex", gap:5, flexWrap:"wrap" }}>
 {item.ret.map(r => (
 <span key={r} style={{ fontSize:12, padding:"2px 8px", borderRadius:4, color:item.farve, background:`${item.farve}12`, border:`1px solid ${item.farve}25` }}>{r}</span>
 ))}
 </div> </div> </div>
 ))}
 </div>
 {/* ── EKSTERNE KONTAKTER ── */}
 <div style={{ ...panel, padding:"20px" }}> <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}> <div> <div style={{ fontSize:13, fontWeight:500, color:T.creme, marginBottom:3 }}>Eksterne kontakter</div> <div style={{ fontSize:12, color:T.dæmpet }}>Socialrådgivere, familiekonsulenter, advokater, myndigheder osv.</div> </div> <div style={{ display:"flex", gap:8, alignItems:"center" }}>
 {gem_besked && <span style={{ fontSize:12, color:T.groen }}>{gem_besked}</span>}
 <Knap onClick={() => setVisEksternForm(!vis_ekstern_form)} style={{ padding:"8px 16px", fontSize:12 }}>
 {vis_ekstern_form ? "Annuller" : "+ Tilføj kontakt"}
 </Knap> </div> </div>
 {/* Formular ny ekstern */}
 {vis_ekstern_form && (
 <div style={{ background:"rgba(255,255,255,0.06)", border:`1px solid ${T.turkis}33`, borderRadius:10, padding:"16px", marginBottom:16, animation:"fadeUp 0.25s ease" }}> <div style={{ fontSize:12, color:T.turkis, letterSpacing:"0.15em", textTransform:"uppercase", marginBottom:14 }}>Ny ekstern kontakt</div> <div className="sv-form-grid" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 12px" }}> <div> <label style={{ fontSize:12, color:T.dæmpet, textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:6, display:"block" }}>Fulde navn *</label> <input value={ny_ekstern.navn} onChange={e=>setNyEkstern(p=>({...p,navn:e.target.value}))}
 placeholder="fx Mette Jensen" style={felt_style} /> </div> <div> <label style={{ fontSize:12, color:T.dæmpet, textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:6, display:"block" }}>Rolle/titel</label> <input value={ny_ekstern.rolle} onChange={e=>setNyEkstern(p=>({...p,rolle:e.target.value}))}
 placeholder="fx Socialrådgiver" style={felt_style} /> </div> </div> <div> <label style={{ fontSize:12, color:T.dæmpet, textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:6, display:"block" }}>Organisation</label> <input value={ny_ekstern.organisation} onChange={e=>setNyEkstern(p=>({...p,organisation:e.target.value}))}
 placeholder="fx Herning Kommune · Familieafdelingen" style={felt_style} /> </div> <div className="sv-form-grid" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 12px" }}> <div> <label style={{ fontSize:12, color:T.dæmpet, textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:6, display:"block" }}>Email</label> <input value={ny_ekstern.email} onChange={e=>setNyEkstern(p=>({...p,email:e.target.value}))}
 placeholder="navn@organisation.dk" type="email" style={felt_style} /> </div> <div> <label style={{ fontSize:12, color:T.dæmpet, textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:6, display:"block" }}>Telefon</label> <input value={ny_ekstern.telefon} onChange={e=>setNyEkstern(p=>({...p,telefon:e.target.value}))}
 placeholder="+45 XX XX XX XX" type="tel" style={felt_style} /> </div> </div> <Knap onClick={tilfoej_ekstern} style={{ width:"100%", padding:"11px" }}
 disabled={!ny_ekstern.navn.trim()}>
 Tilføj kontakt
 </Knap> </div>
 )}
 {/* Liste over eksterne */}
 {eksterne.length === 0 && !vis_ekstern_form ? (
 <div style={{ textAlign:"center", padding:"24px", color:T.dæmpet, fontSize:13 }}>
 Ingen eksterne kontakter tilknyttet endnu
 </div>
 ) : (
 <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
 {eksterne.map(k => (
 <div key={k.id} style={{ background:"rgba(255,255,255,0.06)", border:T.kort_kant, borderRadius:10, padding:"14px 16px" }}> <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}> <div style={{ flex:1 }}> <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:4 }}> <div style={{ width:30, height:30, borderRadius:"50%", background:"rgba(248,163,102,0.15)", border:"1px solid rgba(248,163,102,0.3)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:12, fontWeight:600, color:"#fb923c", flexShrink:0 }}>
 {k.navn.split(" ").map(n=>n[0]).join("").slice(0,2)}
 </div> <div> <div style={{ fontSize:13, fontWeight:500, color:T.creme }}>{k.navn}</div>
 {k.rolle && <div style={{ fontSize:12, color:"#fb923c" }}>{k.rolle}{k.organisation ? ` · ${k.organisation}` : ""}</div>}
 </div> </div> <div style={{ paddingLeft:38, display:"flex", gap:16, flexWrap:"wrap" }}>
 {k.email && (
 <a href={`mailto:${k.email}`} style={{ fontSize:12, color:"#60a5fa", textDecoration:"none", display:"flex", alignItems:"center", gap:5 }}>
 {k.email}
 </a>
 )}
 {k.telefon && (
 <a href={`tel:${k.telefon}`} style={{ fontSize:12, color:T.turkis, textDecoration:"none", display:"flex", alignItems:"center", gap:5 }}>
 {k.telefon}
 </a>
 )}
 </div> </div> <button onClick={() => slet_ekstern_bekræft(k.id)} style={{ background:"none", border:"none", color:T.roed, fontSize:18, cursor:"pointer", padding:"0 4px", flexShrink:0 }}>×</button> </div> </div>
 ))}
 </div>
 )}
 </div> </div>
 {bekræft_slet_id !== null && (
 <BekræftDialog
 besked="Slet ekstern kontakt? Handlingen kan ikke fortrydes."
 onJa={() => slet_ekstern(bekræft_slet_id)}
 onNej={() => setBekræftSletId(null)}
 />
 )}
 </>
 );
}
// ─────────────────────────────────────────────────────────
// KLIENTOVERSIGT — alle sager med noter, filer og tildeling
// ─────────────────────────────────────────────────────────
const MOCK_KLIENTER = [];
// ─────────────────────────────────────────────────────────
// DEADLINE HELPERS
// ─────────────────────────────────────────────────────────
function beregn_deadline_info(dato_str) {
 if (!dato_str) return { txt:"—", farve:"#94a3b8", dage:null };
 const dato = new Date(dato_str);
 if (isNaN(dato.getTime())) return { txt:"—", farve:"#94a3b8", dage:null };
 const nu = new Date();
 const idag_start = new Date(nu.getFullYear(), nu.getMonth(), nu.getDate(), 0, 0, 0, 0);
 const deadline_dato = new Date(dato.getFullYear(), dato.getMonth(), dato.getDate(), 0, 0, 0, 0);
 const dage = Math.round((deadline_dato - idag_start) / 86400000);
 const dato_tekst = dato.toLocaleDateString("da-DK", { day:"numeric", month:"long", year: dato.getFullYear()!==nu.getFullYear()?"numeric":undefined });
 let txt, farve;
 if (dage < 0) {
 // Rød — overskredet
 txt = `${Math.abs(dage)} dag${Math.abs(dage)===1?"":"e"} overskredet (${dato_tekst})`;
 farve = "#ff6b6b";
 } else if (dage === 0) {
 // Rød — udløber i dag
 txt = `Udløber i dag (${dato_tekst})`;
 farve = "#ff6b6b";
 } else if (dage <= 7) {
 // Gul — 1-7 dage
 txt = `om ${dage} dag${dage===1?"":"e"} (${dato_tekst})`;
 farve = "#ffd43b";
 } else {
 // Grøn — 7+ dage
 txt = `om ${dage} dage (${dato_tekst})`;
 farve = "#69db7c";
 }
 return { txt, farve, dage };
}
// ─────────────────────────────────────────────────────────
// GLOBAL TOAST — gem-bekræftelse midt på skærmen
// ─────────────────────────────────────────────────────────
let _toast_fn = null;
function Toast() {
 const [msg, setMsg] = useState("");
 const [vis, setVis] = useState(false);
 const timer = React.useRef(null);
 React.useEffect(() => {
 _toast_fn = (tekst) => {
 setMsg(tekst);
 setVis(true);
 clearTimeout(timer.current);
 timer.current = setTimeout(() => setVis(false), 2500);
 };
 return () => { _toast_fn = null; };
 }, []);
 if (!vis) return null;
 return (
 <div style={{
 position:"fixed", top:"50%", left:"50%",
 transform:"translate(-50%,-50%)",
 background:"rgba(10,20,50,0.97)", border:"1px solid #3fd4c7",
 borderRadius:18, padding:"18px 28px", zIndex:9999,
 display:"flex", alignItems:"center", gap:12,
 boxShadow:"0 8px 40px rgba(0,0,0,0.6)", animation:"toastIn 0.25s ease",
 backdropFilter:"blur(20px)", minWidth:260, maxWidth:420,
 }}> <div style={{ fontSize:22, color:"#3fd4c7" }}></div> <div style={{ fontSize:14, color:"#e6dddc", fontFamily:"'Inter',system-ui,sans-serif" }}>{msg}</div> </div>
 );
}
function vis_toast(tekst) { toast(tekst, 'success'); }
const STATUS_C = { kritisk:"#ff6b6b", aktiv:"#3fd4c7", lead:"#60a5fa", venter:"#f59e0b" };
function KlientOversigt({ onTilbage, åbn_sag_id, onÅbnet, maal_haendelse_id, onMaalAabnet, fjern_nye_haendelse }) {
 const [sager, setSager] = useState([]);
 const [api_loader, setApiLoader] = useState(true);
 const [ALLE_BRUGERE, setAlleBrugere] = useState([
 { id: 8, navn: "René Sørensen" },
 { id: 9, navn: "Daisy Sørensen" }
 ]);
 React.useEffect(()=>{
 // FEJL-002-fix: GET /api/brugere kræver admin-rolle (403 for sagsbehandlere), så
 // "Primær/sekundær sagsbehandler"-dropdownen i Overblik-fanen skal — ligesom
 // Sagsbehandlere-fanen (se SagsbehandlerPanel) — bruge det åbne /sagsbehandlere-
 // endpoint, der allerede filtrerer på aktiv=true og ekskluderer infoskærm-rollen.
 api("brugere/sagsbehandlere").then(data=>{
 if(data && data.brugere) {
 setAlleBrugere(data.brugere
 .filter(b => b.id !== 1)
 .filter((b, idx, arr) => arr.findIndex(x => x.navn === b.navn) === idx)
 .map(b => ({ id: b.id, navn: b.navn })));
 }
 }).catch(err => { console.error(err); toast("En handling fejlede — prøv igen", "fejl"); });
 },[]);
 const hent_sager = React.useCallback(() => {
 return api("sager").then(data => {
 if (data && data.sager) {
 setSager(data.sager.map(s => ({
 id: String(s.id),
 klient_id: s.klient_id,
 sagsnummer: s.sagsnummer || `SV-${String(s.id).padStart(4,"0")}`,
 klient: s.klient_navn || "Ukendt",
 klient_telefon: s.klient_telefon || "",
 klient_email: s.klient_email || "",
 klient_adresse: s.klient_adresse || "",
 klient_postnr: s.klient_postnr || "",
 klient_by: s.klient_by || "",
 modpart: s.modpart_navn || "—",
 modpart_email: s.modpart_email || "",
 modpart_telefon: s.modpart_telefon || "",
 type: s.type || "—",
 status: s.status || "aktiv",
 fase: s.fase || "—",
 risiko: s.risiko_score || 0,
 styrke_farve: (s.risiko_score||0) >= 70 ? "#69db7c" : (s.risiko_score||0) >= 40 ? "#ffd43b" : "#ff6b6b",
 deadline: s.næste_deadline || null,
 deadline_titel: s.næste_deadline_titel || "",
 deadline_txt: beregn_deadline_info(s.næste_deadline).txt,
 deadline_farve: beregn_deadline_info(s.næste_deadline).farve,
 primær: s.primær_navn || "—",
 primær_id: s.primær_sagsbehandler_id,
 sekundær: s.sekundær_navn || null,
 sekundær_id: s.sekundær_sagsbehandler_id,
 haendelser: s.haendelse_antal || 0,
 har_nye_haendelser: s.har_nye_haendelser === true,
 klient_maal: s.klient_maal || "",
 aftaler: s.aftaler || "",
 fuldmagt_status: s.fuldmagt_status || 'ingen',
 fuldmagt_dato: s.fuldmagt_dato || null,
 fuldmagt_udloeb: s.fuldmagt_udloeb || null,
 fuldmagt_myndigheder: Array.isArray(s.fuldmagt_myndigheder) ? s.fuldmagt_myndigheder : [],
 klient_recovery_check_completed_dato: s.klient_recovery_check_completed_dato || null,
 filer: [],
 eksterne_kontakter: [],
 haendelse_log: [],
 })));
 }
 setApiLoader(false);
 }).catch(() => setApiLoader(false));
 }, []);
 React.useEffect(() => { hent_sager(); }, [hent_sager]);
 // Recovery-check (Migration 081): markér eller fortryd klient som
 // gennemgået efter server-rebuild 2026-05-29. Opdaterer lokal state
 // så blink stopper/starter med det samme — flere sager med samme
 // klient_id opdateres samtidig.
 const toggle_recovery_check = React.useCallback(async (klient_id, til_tjekket) => {
 if (!klient_id) return;
 try {
 const data = til_tjekket
 ? await api("klienter/" + klient_id + "/recovery-check", "PATCH", {})
 : await api("klienter/" + klient_id + "/recovery-check", "DELETE");
 const ny_dato = data?.recovery_check_completed_dato || null;
 setSager(p => p.map(s => s.klient_id === klient_id
 ? { ...s, klient_recovery_check_completed_dato: ny_dato }
 : s));
 toast(til_tjekket ? " Klient markeret som tjekket" : "↺ Markering fortrudt", "success");
 } catch (err) {
 console.error("[RECOVERY-CHECK] toggle:", err);
 toast("En handling fejlede — prøv igen", "fejl");
 }
 }, []);
 // Åbn sag direkte hvis åbn_sag_id er sat
 const [valgt, setValgt] = useState(null);
 const [sag_deadline_dialog, setSagDeadlineDialog] = useState(null); // { sag_id, ny_deadline:"" }
 const [fuldmagt_dialog, setFuldmagtDialog] = useState(null); // { sag_id, klient_id, klient_navn, boern, trin:'vælg_børn'|'preview', valgte_boern:[], loading:false, pdf:null }
 const [mail_import_dialog, setMailImportDialog] = useState(null); // { sag_id, klient_id, klient_navn, emails:[], fra_dato, til_dato, loading, resultat }
 const [moede_dialog, setMoedeDialog] = useState(null); // { sag_id, sagsnummer, klient_navn, klient_email, titel, dato, start_tid, slut_tid, lokation, beskrivelse, kalender_bruger_ids:[], deltagere:[], loading, resultat }
 // U5: Escape lukker den aktuelt åbne modal
 useEscapeClose(!!fuldmagt_dialog && fuldmagt_dialog.trin !== 'preview', () => setFuldmagtDialog(null));
 useEscapeClose(!!mail_import_dialog && !mail_import_dialog?.loading, () => setMailImportDialog(null));
 useEscapeClose(!!moede_dialog && !moede_dialog?.loading, () => setMoedeDialog(null));
 useEscapeClose(!!sag_deadline_dialog, () => setSagDeadlineDialog(null));
 const [moede_travlhed, setMoedeTravlhed] = useState(null); // { [bruger_id]: [busy_slots] }
 const [moeder_refresh, setMoederRefresh] = useState(0); // trigger MoederListe genhentning
 // Browser tilbage/frem for sag-detalje OG fane-skift (René + Daisy, okt
 // 2026): hvert skridt -- åbn sag, skift fane (Overblik→Hændelser osv.) --
 // skal være ét historik-skridt, akkurat som en almindelig browser. "depth"
 // gemmes direkte i hver history-entry (ikke en separat tælle-variabel), så
 // luk_sag_lokalt altid kan læse den PRÆCIST aktuelle dybde fra
 // window.history.state, uanset om brugeren kom dertil via klik, browserens
 // egen tilbage/frem-knap, eller browserens historik-menu.
 const aabn_sag_lokalt = React.useCallback((sag) => {
 setValgt(sag);
 setAktivTab("overblik");
 window.history.pushState({ sag_detail: true, fane: "overblik", depth: 1 }, "", window.location.pathname);
 }, []);
 const skift_fane_lokalt = React.useCallback((ny_fane) => {
 const nuvaerende = window.history.state;
 setAktivTab(ny_fane);
 if (nuvaerende?.sag_detail && nuvaerende.fane === ny_fane) return; // allerede på denne fane
 const ny_depth = (nuvaerende?.sag_detail ? (nuvaerende.depth || 1) : 0) + 1;
 window.history.pushState({ sag_detail: true, fane: ny_fane, depth: ny_depth }, "", window.location.pathname);
 }, []);
 const luk_sag_lokalt = React.useCallback(() => {
 const nuvaerende = window.history.state;
 const depth = nuvaerende?.sag_detail ? (nuvaerende.depth || 1) : 0;
 if (depth > 0) { window.history.go(-depth); }
 else { setValgt(null); }
 }, []);
 React.useEffect(() => {
 const haandter_popstate = (e) => {
 if (e.state?.sag_detail) { setAktivTab(e.state.fane || "overblik"); }
 else { setValgt(null); }
 };
 window.addEventListener("popstate", haandter_popstate);
 return () => window.removeEventListener("popstate", haandter_popstate);
 }, []);
 React.useEffect(() => {
 if (åbn_sag_id && sager.length > 0) {
 const sag = sager.find(s => s.id === String(åbn_sag_id));
 if (sag) {
 aabn_sag_lokalt(sag);
 // René: klik på en konkret hændelse i "Nye hændelser"-widgeten skal gå
 // direkte til Hændelser-fanen -- ikke blot sagens overblik-fane.
 if (maal_haendelse_id) skift_fane_lokalt("haendelser");
 }
 if (onÅbnet) onÅbnet();
 }
 }, [åbn_sag_id, sager, onÅbnet, aabn_sag_lokalt, maal_haendelse_id, skift_fane_lokalt]);
 const ALLE_BRUGERE_FILTER = ALLE_BRUGERE;
 const eget_navn = React.useMemo(() => JSON.parse(sessionStorage.getItem("sv_bruger") || "{}").navn || "", []);
 const [søg, setSøg] = useState("");
 // Default = kun aktive sager, uanset enhed -- man skal aktivt vælge "Alle"/"Lukkede" for at se andet
 const [filter, setFilter] = useState("aktiv");
 const [sb_filter, setSbFilter] = useState("alle"); // alle / primær / sekundær
 // Default = egne sager (primær + sekundær) -- "Alle"-knappen i sagsbehandler-filteret nulstiller til "" og viser alles sager
 const [valgt_sb, setValgtSb] = useState(() => eget_navn);
 const [ko_sortering, setKoSortering] = useState("deadline");
 const [ko_visning, setKoVisning] = useState(() => localStorage.getItem("sv_ko_visning") || (window.innerWidth <= 768 ? "kort" : "liste"));
 const [ny_note, setNyNote] = useState("");
 const [aktiv_tab, setAktivTab] = useState("overblik");
 const [wizard_modal, setWizardModal] = useState(null);
 // Reset wizard when sag changes
 useEffect(() => { setWizardModal(null); }, [valgt?.id]);
 const [rediger_klient, setRedigerKlient] = useState(false);
 const [rediger_form, setRedigerForm] = useState({});
 const [vis_luk_dialog, setVisLukDialog] = useState(false);
 const [luk_årsag, setLukÅrsag] = useState("");
 const [slet_sag_dialog, setSletSagDialog] = useState(false);
 const [slet_sag_begrundelse, setSletSagBegrundelse] = useState("");
 const [luk_besked, setLukBesked] = useState("");
 const [sag_detaljer, setSagDetaljer] = useState({});
 const [sag_haendelser, setSagHaendelser] = useState([]);
 const [ai_resume, setAiResume] = useState(null);
 const [ai_resume_loader, setAiResumeLoader] = useState(false);
 const [ai_resume_forældet, setAiResumeForældet] = useState(false);
 const [ai_resume_nye, setAiResumeNye] = useState(0);
 const [ai_naeste_skridt, setAiNaesteSkridtData] = useState(null);
 const [ai_naeste_loader, setAiNaesteLoader] = useState(false);
 const [ai_soeg_svar, setAiSoegSvar] = useState(null);
 const [ai_soeg_spg, setAiSoegSpg] = useState("");
 const [ai_soeg_loader, setAiSoegLoader] = useState(false);
 // dok_type/instruktioner/resultat/loader/vis er erstattet af DokumentGeneratorWizard
 const [email_liste, setEmailListe] = useState([]);
 const [email_loader, setEmailLoader] = useState(false);
 const [vis_rediger_klient, setVisRedigerKlient] = useState(false);
 const fil_ref = React.useRef(null);
 // Hent hændelser og klient-detaljer når sag vælges
 React.useEffect(() => {
 if (!valgt?.id) return;
 setAiResume(null); setAiSoegSvar(null); setAiSoegSpg(""); setAiResumeForældet(false); setAiResumeNye(0);
 setAiNaesteSkridtData(null);
 // DokumentGeneratorWizard har sin egen state-reset ved sagId-skift
 // Hent gemt resumé automatisk
 api("ai-sag/resume/" + valgt.id).then(data => {
 if (data?.resume) {
 setAiResume(data.resume);
 setAiResumeForældet(data.forældet || false);
 setAiResumeNye(data.nye_haendelser || 0);
 }
 }).catch(err => { console.error(err); toast("En handling fejlede — prøv igen", "fejl"); });
 // Auto-hent næste skridt (Haiku, hurtig)
 if (valgt.status !== 'lukket') {
 setAiNaesteLoader(true);
 api("ai/naeste-skridt", "POST", { sag_id: valgt.id }).then(r => {
 if (r?.skridt) { setAiNaesteSkridtData(r); setAiNaesteLoader(false); }
 else if (r?.opgave_id) {
 pollAiOpgave(r.opgave_id, d => { setAiNaesteSkridtData(d); setAiNaesteLoader(false); }, () => setAiNaesteLoader(false));
 } else { setAiNaesteLoader(false); }
 }).catch(() => setAiNaesteLoader(false));
 }
 api("haendelser/" + valgt.id).then(data => {
 if (data?.haendelser) {
 setSagHaendelser(data.haendelser.map(h => ({
 id: h.id, type: h.type, titel: h.titel, beskrivelse: h.beskrivelse,
 dato: h.begivenhedsdato || h.oprettet_dato, forfatter: h.forfatter_navn,
 })));
 }
 }).catch(err => { console.error(err); toast("En handling fejlede — prøv igen", "fejl"); });
 }, [valgt?.id]);
 React.useEffect(() => {
 if (!valgt?.klient_id) return;
 api("klienter/" + valgt.klient_id).then(data => {
 if (data?.klient) {
 setSagDetaljer({
 modpart_navn: (data.klient.modpart_fornavn || "") + " " + (data.klient.modpart_efternavn || ""),
 cpr: data.klient.cpr_krypteret || "—",
 adresse: [data.klient.adresse, data.klient.postnr, data.klient.by].filter(Boolean).join(", ") || "—",
 telefon: data.klient.telefon || "—",
 email: data.klient.email || "—",
 });
 }
 }).catch(err => { console.error(err); toast("En handling fejlede — prøv igen", "fejl"); });
 }, [valgt?.id]);
 if (api_loader) return (
 <div style={{ minHeight:"100vh", background:BG, padding:"clamp(16px, 3vw, 28px) clamp(16px, 4vw, 40px)" }}>
 {[...Array(6)].map((_,i) => (
 <div key={i} style={{ background:"rgba(255,255,255,0.04)", borderRadius:12, padding:"16px 20px", marginBottom:12, display:"flex", gap:16, alignItems:"center" }}> <div className="sv-shimmer" style={{ width:44, height:44, borderRadius:"50%", flexShrink:0 }} /> <div style={{ flex:1 }}> <div className="sv-shimmer" style={{ height:14, width:"45%", borderRadius:6, marginBottom:8 }} /> <div className="sv-shimmer" style={{ height:11, width:"70%", borderRadius:6 }} /> </div> <div className="sv-shimmer" style={{ height:24, width:72, borderRadius:20 }} /> </div>
 ))}
 </div>
 );
 if (vis_rediger_klient && valgt) return (
 <NyKlient
 redigering={{ sag_id: valgt.id, klient_id: valgt.klient_id, sagsnummer: valgt.sagsnummer }}
 onFærdig={() => { setVisRedigerKlient(false); }}
 onAnnuller={() => setVisRedigerKlient(false)}
 />
 );
 const filtrerede = sager.filter(s => {
 if (filter !== "alle" && s.status !== filter) return false;
 if (søg && !s.klient.toLowerCase().includes(søg.toLowerCase()) && !s.sagsnummer.includes(søg) && !s.primær?.toLowerCase().includes(søg.toLowerCase()) && !s.sekundær?.toLowerCase().includes(søg.toLowerCase())) return false;
 // Sagsbehandler rolle-filter
 if (sb_filter === "primær" && (!s.primær || s.primær === "—")) return false;
 if (sb_filter === "sekundær" && !s.sekundær) return false;
 // Specifik sagsbehandler filter
 if (valgt_sb) {
 const sb_navn = valgt_sb.toLowerCase();
 if (sb_filter === "primær") return (s.primær||"").toLowerCase().includes(sb_navn);
 if (sb_filter === "sekundær") return (s.sekundær||"").toLowerCase().includes(sb_navn);
 return (s.primær||"").toLowerCase().includes(sb_navn) || (s.sekundær||"").toLowerCase().includes(sb_navn);
 }
 return true;
 });
 const opdater_sag = async (id, felt, val) => {
 setSager(p => p.map(s => s.id===id ? {...s, [felt]:val} : s));
 if (felt === "primær") vis_toast(" Primær sagsbehandler gemt");
 if (felt === "sekundær") vis_toast(val ? " Sekundær sagsbehandler gemt" : " Sekundær fjernet");
 try { await api("sager/" + id, "PATCH", { [felt]: val }); }
 catch(err) { console.error("Sag opdatering fejl:", err); }
 };
 const tilfoej_note = (id) => {
 if (!ny_note.trim()) return;
 const note = { id:Date.now(), tekst:ny_note, dato:new Date().toLocaleDateString("da-DK"), forfatter:"René Sørensen" };
 setSager(p => p.map(s => s.id===id ? {...s, noter:[...s.noter, note]} : s));
 setNyNote("");
 };
 const tilfoej_fil = (id, e) => {
 const nye = Array.from(e.target.files).map(f => ({ id:Date.now()+Math.random(), navn:f.name, størrelse:f.size, dato:new Date().toLocaleDateString("da-DK") }));
 setSager(p => p.map(s => s.id===id ? {...s, filer:[...s.filer, ...nye]} : s));
 e.target.value = "";
 };
 const panel = { background:"rgba(255,255,255,0.06)", border:T.kort_kant, borderRadius:16, backdropFilter:"blur(20px)", WebkitBackdropFilter:"blur(20px)" };
 return (
 <>
 {/* Sag deadline dialog — renderet via portal for at undgå at filter/transform
 på forældre-elementer bryder position:fixed */}
 {sag_deadline_dialog && createPortal(
 <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.75)", zIndex:10000, display:"flex", alignItems:"center", justifyContent:"center" }}
 onClick={()=>setSagDeadlineDialog(null)}> <div style={{ background:"rgba(10,14,46,0.98)", border:T.kort_kant, borderRadius:18, padding:"24px 28px", width:400, maxWidth:"95vw", boxShadow:"0 16px 48px rgba(0,0,0,0.6)" }}
 onClick={e=>e.stopPropagation()}>
 {/* Header */}
 <div style={{ fontSize:15, fontWeight:600, color:T.turkis, marginBottom:18 }}>
 {sag_deadline_dialog.eksisterende ? " Ændr deadline" : "+ Ny deadline"}
 </div>
 {/* Nuværende deadline info */}
 {sag_deadline_dialog.eksisterende && sag_deadline_dialog.original_titel && (
 <div style={{ padding:"8px 12px", background:"rgba(255,255,255,0.04)", borderRadius:8, marginBottom:14, fontSize:12 }}> <span style={{ color:"#94a3b8" }}>Nuværende: </span> <span style={{ color:"#f1f5f9", fontWeight:500 }}>{sag_deadline_dialog.original_titel}</span>
 {sag_deadline_dialog.original_deadline && <span style={{ color:"#94a3b8" }}> — {sag_deadline_dialog.original_deadline}</span>}
 </div>
 )}
 {/* Titel-felt */}
 <div style={{ fontSize:12, color:T.dæmpet, marginBottom:8 }}>Hvad omhandler deadlinen? <span style={{ color:T.roed }}>*</span></div>
 <input value={sag_deadline_dialog.ny_titel||""}
 onChange={e=>setSagDeadlineDialog(p=>({...p, ny_titel:e.target.value}))}
 placeholder="fx: Ryk for aktindsigt, Svar klient, Skriv partshøring, Svar til Familieretshuset..."
 spellCheck="true" lang="da"
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:!sag_deadline_dialog.ny_titel?.trim() ? "1px solid rgba(251,113,133,0.5)" : T.skillelinje, borderRadius:8, padding:"10px 12px", color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", boxSizing:"border-box", marginBottom:12 }} />
 {/* Dato-felt */}
 <div style={{ fontSize:12, color:T.dæmpet, marginBottom:8 }}>Dato <span style={{ color:T.roed }}>*</span></div>
 <input type="date" value={sag_deadline_dialog.ny_deadline}
 onChange={e=>setSagDeadlineDialog(p=>({...p, ny_deadline:e.target.value}))}
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border: sag_deadline_dialog.ny_deadline && new Date(sag_deadline_dialog.ny_deadline) < new Date(new Date().toDateString()) ? "1px solid #ffd43b" : T.skillelinje, borderRadius:8, padding:"10px 12px", color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", colorScheme:"dark", boxSizing:"border-box", marginBottom: sag_deadline_dialog.ny_deadline && new Date(sag_deadline_dialog.ny_deadline) < new Date(new Date().toDateString()) ? 4 : 12 }} />
 {sag_deadline_dialog.ny_deadline && new Date(sag_deadline_dialog.ny_deadline) < new Date(new Date().toDateString()) && (
 <div style={{ fontSize:12, color:"#ffd43b", marginBottom:10 }}> Datoen er i fortiden — er dette tilsigtet?</div>
 )}
 {/* Begrundelse-felt (kun påkrævet ved eksisterende) */}
 <div style={{ fontSize:12, color:T.dæmpet, marginBottom:8 }}>
 {sag_deadline_dialog.eksisterende ? "Begrundelse for ændring" : "Bemærkning (valgfri)"}
 {sag_deadline_dialog.eksisterende && <span style={{ color:T.roed }}> *</span>}
 </div>
 <input value={sag_deadline_dialog.begrundelse||""}
 onChange={e=>setSagDeadlineDialog(p=>({...p, begrundelse:e.target.value}))}
 placeholder="fx: Familieretshuset udsat fristen, aftalt med klient..."
 spellCheck="true" lang="da"
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"10px 12px", color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", boxSizing:"border-box", marginBottom:14 }} />
 {/* Gem ændring-knap */}
 <div style={{ display:"flex", gap:10, marginBottom: sag_deadline_dialog.eksisterende ? 0 : 0 }}>
 <button onClick={()=>setSagDeadlineDialog(null)} style={{ flex:1, background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"10px", color:T.dæmpet, fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Fortryd
 </button>
 <button onClick={async()=>{
 const kan_gem_rediger = sag_deadline_dialog.ny_titel?.trim() && sag_deadline_dialog.ny_deadline && (!sag_deadline_dialog.eksisterende || sag_deadline_dialog.begrundelse?.trim());
 if (!kan_gem_rediger) return;
 const ny = sag_deadline_dialog.ny_deadline;
 const ny_titel = sag_deadline_dialog.ny_titel?.trim() || "";
 try {
 await api("sager/" + sag_deadline_dialog.sag_id, "PATCH", { næste_deadline: ny, næste_deadline_titel: ny_titel });
 const ny_info = beregn_deadline_info(ny);
 setSager(p=>p.map(s=>s.id===sag_deadline_dialog.sag_id?{...s, deadline:ny, deadline_titel:ny_titel, deadline_txt:ny_info.txt, deadline_farve:ny_info.farve}:s));
 if (valgt?.id === sag_deadline_dialog.sag_id) setValgt(p=>({...p, deadline:ny, deadline_titel:ny_titel, deadline_txt:ny_info.txt, deadline_farve:ny_info.farve}));
 toast("Deadline gemt", "success");
 } catch (err) { console.error(err); toast("En handling fejlede — prøv igen", "fejl"); }
 setSagDeadlineDialog(null);
 }} style={{ flex:2, background: (sag_deadline_dialog.ny_titel?.trim() && sag_deadline_dialog.ny_deadline && (!sag_deadline_dialog.eksisterende || sag_deadline_dialog.begrundelse?.trim())) ? T.turkis : "rgba(63,212,199,0.25)", border:"none", borderRadius:8, padding:"10px", color:"#fff", fontSize:13, fontWeight:700, cursor:(sag_deadline_dialog.ny_titel?.trim() && sag_deadline_dialog.ny_deadline && (!sag_deadline_dialog.eksisterende || sag_deadline_dialog.begrundelse?.trim())) ? "pointer" : "not-allowed", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Gem ændring
 </button>
 </div>
 {/* Separator + Markér som udført-sektion — kun ved eksisterende deadline */}
 {sag_deadline_dialog.eksisterende && (<>
 <div style={{ borderTop:"1px solid rgba(255,255,255,0.1)", margin:"16px 0" }} />
 <div>
 <label style={{ fontSize:12, color:"rgba(255,255,255,0.6)", marginBottom:6, display:"block" }}>
 Beskriv hvad der skete (valgfri)
 </label>
 <textarea
 value={sag_deadline_dialog.udfoert_beskrivelse||""}
 onChange={e=>setSagDeadlineDialog(p=>({...p, udfoert_beskrivelse:e.target.value}))}
 placeholder="fx: Svar sendt til Familieretshuset, Aktindsigt modtaget og gennemgået..."
 rows={2}
 spellCheck="true" lang="da"
 style={{ width:"100%", background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.15)", borderRadius:6, color:"#fff", padding:"8px", fontSize:13, resize:"vertical", boxSizing:"border-box", fontFamily:"'Inter',system-ui,sans-serif" }}
 />
 <button onClick={async()=>{
 try {
 await api("sager/" + sag_deadline_dialog.sag_id, "PATCH", { næste_deadline: null, næste_deadline_titel: null });
 if ((sag_deadline_dialog.udfoert_beskrivelse||"").trim()) {
 await api("haendelser", "POST", {
 sag_id: sag_deadline_dialog.sag_id,
 type: "deadline_udfoert",
 titel: "Deadline udfort: " + (sag_deadline_dialog.original_titel || sag_deadline_dialog.ny_titel || "Deadline"),
 beskrivelse: sag_deadline_dialog.udfoert_beskrivelse.trim(),
 dato: new Date().toISOString(),
 }).catch(err => { console.warn("[DEADLINE] note fejlede:", err); });
 }
 setSager(p=>p.map(s=>s.id===sag_deadline_dialog.sag_id?{...s, deadline:null, deadline_titel:"", deadline_txt:"—", deadline_farve:"#94a3b8"}:s));
 if (valgt?.id === sag_deadline_dialog.sag_id) setValgt(p=>({...p, deadline:null, deadline_titel:"", deadline_txt:"—", deadline_farve:"#94a3b8"}));
 toast("Deadline markeret som udfort", "success");
 } catch (err) { console.error(err); toast("En handling fejlede — prøv igen", "fejl"); }
 setSagDeadlineDialog(null);
 }} style={{ marginTop:8, width:"100%", padding:"10px", background:"#16a34a", color:"#fff", border:"none", borderRadius:6, cursor:"pointer", fontWeight:600, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif" }}>
 Markér som udfort
 </button>
 </div>
 </>)}
 </div> </div>,
 document.body
 )}
 {/* Møde-dialog — opret Outlook-event i en eller flere brugeres kalendere */}
 {moede_dialog && createPortal(
 <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.78)", zIndex:10000, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}
 onClick={()=>!moede_dialog.loading && setMoedeDialog(null)}> <div className="sv-moede-dialog" onClick={e=>e.stopPropagation()}
 style={{ background:"rgba(10,14,46,0.98)", border:`1px solid ${T.turkis}44`, borderRadius:18, padding:"22px 26px",
 width:720, maxWidth:"95vw", maxHeight:"92vh", overflowY:"auto", boxShadow:"0 16px 48px rgba(0,0,0,0.6)" }}> <div style={{ fontSize:15, fontWeight:600, color:T.turkis, marginBottom:6 }}>
 {moede_dialog.mode === 'rediger' ? ' Rediger møde' : ' Opret møde'}
 </div> <div style={{ fontSize:13, color:T.dæmpet, marginBottom:16 }}>
 Sag: {moede_dialog.sagsnummer} · {moede_dialog.klient_navn}
 <br/><span style={{ fontSize:11 }}>Titel får automatisk '{moede_dialog.sagsnummer} - ' som prefix</span> </div>
 {!moede_dialog.resultat ? (
 <MoedeForm
 dialog={moede_dialog}
 setDialog={setMoedeDialog}
 alle_brugere={ALLE_BRUGERE}
 travlhed={moede_travlhed}
 setTravlhed={setMoedeTravlhed}
 onClose={() => setMoedeDialog(null)}
 onSucces={() => setMoederRefresh(n => n + 1)}
 />
 ) : (
 <> <div style={{ padding:"14px", background:"rgba(6,214,160,0.08)", border:`1px solid ${T.groen}44`, borderRadius:10, marginBottom:14 }}> <div style={{ fontSize:14, color:T.groen, fontWeight:600, marginBottom:6 }}> Møde oprettet</div> <div style={{ fontSize:13, color:"#e2e8f0", lineHeight:1.7 }}> <strong>{moede_dialog.resultat.oprettede?.length || 0}</strong> kalender(e) opdateret<br/>
 {moede_dialog.resultat.oprettede?.map((o,i) => (
 <span key={i} style={{ fontSize:12, color:T.dæmpet }}>• {o.bruger} ({o.email})<br/></span>
 ))}
 {moede_dialog.resultat.fejl?.length > 0 && (
 <div style={{ marginTop:8, color:T.roed }}>Fejl: {moede_dialog.resultat.fejl.map(f => f.bruger).join(', ')}</div>
 )}
 </div> </div> <button onClick={() => setMoedeDialog(null)}
 style={{ width:"100%", padding:"10px", borderRadius:8, border:"none", background:T.turkis, color:"#fff", fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Luk
 </button> </>
 )}
 </div> </div>,
 document.body
 )}
 {/* Mail-import dialog — importér historiske mails til en klient */}
 {mail_import_dialog && (
 <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.78)", zIndex:9999, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}
 onClick={()=>!mail_import_dialog.loading && setMailImportDialog(null)}> <div onClick={e=>e.stopPropagation()}
 style={{ background:"rgba(10,14,46,0.98)", border:`1px solid ${T.turkis}44`, borderRadius:18, padding:"22px 26px",
 width:520, maxWidth:"95vw", maxHeight:"92vh", overflowY:"auto", boxShadow:"0 16px 48px rgba(0,0,0,0.6)" }}> <div style={{ fontSize:15, fontWeight:600, color:T.turkis, marginBottom:6 }}>
 Importér mails fra Outlook
 </div> <div style={{ fontSize:13, color:T.dæmpet, marginBottom:16 }}>
 Sag: {mail_import_dialog.sagsnummer} · {mail_import_dialog.klient_navn}
 </div>
 {!mail_import_dialog.resultat && (
 <> <label style={{ fontSize:12, color:T.dæmpet, marginBottom:6, display:"block" }}>
 Email-adresser (én per linje) — mails TIL eller FRA disse adresser importeres
 </label> <textarea
 value={mail_import_dialog.emails_tekst || ""}
 onChange={e => setMailImportDialog(p => ({ ...p, emails_tekst: e.target.value }))}
 rows={4}
 placeholder={"klient@email.dk\nalt.email@eksempel.com"}
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"10px 12px", color:T.creme, fontSize:13, fontFamily:"'Courier New',monospace", marginBottom:14, boxSizing:"border-box", resize:"vertical" }}
 /> <div className="sv-form-grid" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:14 }}> <div> <label style={{ fontSize:11, color:T.dæmpet, marginBottom:4, display:"block" }}>Fra dato (valgfri)</label> <input
 type="date"
 value={mail_import_dialog.fra_dato || ""}
 onChange={e => setMailImportDialog(p => ({ ...p, fra_dato: e.target.value }))}
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"8px 10px", color:T.creme, fontSize:13, colorScheme:"dark", boxSizing:"border-box" }}
 /> </div> <div> <label style={{ fontSize:11, color:T.dæmpet, marginBottom:4, display:"block" }}>Til dato (valgfri)</label> <input
 type="date"
 value={mail_import_dialog.til_dato || ""}
 onChange={e => setMailImportDialog(p => ({ ...p, til_dato: e.target.value }))}
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"8px 10px", color:T.creme, fontSize:13, colorScheme:"dark", boxSizing:"border-box" }}
 /> </div> </div> <div style={{ padding:"10px 12px", background:"rgba(63,212,199,0.05)", border:`1px solid ${T.turkis}22`, borderRadius:8, marginBottom:14, fontSize:12, color:T.dæmpet, lineHeight:1.6 }}>
 Duplikater springes automatisk over. Importerede mails oprettes som hændelser (indgående/udgående) med fuld tekst.
 </div> <div style={{ display:"flex", gap:10 }}> <button onClick={()=>setMailImportDialog(null)}
 style={{ flex:1, padding:"10px", borderRadius:8, border:T.skillelinje, background:"transparent", color:T.dæmpet, fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Annuller
 </button> <button
 disabled={mail_import_dialog.loading || !(mail_import_dialog.emails_tekst?.trim())}
 onClick={async () => {
 const emails = (mail_import_dialog.emails_tekst || "")
 .split(/[\n,;]+/).map(e => e.trim()).filter(e => e && e.includes('@'));
 if (emails.length === 0) { toast("Mindst én gyldig email skal angives", "fejl"); return; }
 setMailImportDialog(p => ({ ...p, loading:true }));
 try {
 const r = await api("email/import-klient", "POST", {
 sag_id: mail_import_dialog.sag_id,
 klient_id: mail_import_dialog.klient_id,
 emails,
 fra_dato: mail_import_dialog.fra_dato || undefined,
 til_dato: mail_import_dialog.til_dato || undefined,
 });
 if (r?.succes) {
 setMailImportDialog(p => ({ ...p, loading:false, resultat:r }));
 toast(` ${r.importeret} mails importeret`, "success");
 } else {
 toast(r?.fejl || "Import fejlede", "fejl");
 setMailImportDialog(p => ({ ...p, loading:false }));
 }
 } catch (e) {
 console.error('[MailImport] fejl:', e);
 toast("Import fejlede — prøv igen", "fejl");
 setMailImportDialog(p => ({ ...p, loading:false }));
 }
 }}
 style={{
 flex:2, padding:"10px", borderRadius:8, border:"none",
 background: mail_import_dialog.loading ? "rgba(63,212,199,0.4)" : T.turkis,
 color:"#fff", fontSize:13, fontWeight:700,
 cursor: mail_import_dialog.loading ? "not-allowed" : "pointer",
 fontFamily:"'Inter',system-ui,sans-serif"
 }}>
 {mail_import_dialog.loading ? " Søger & importerer..." : " Start import"}
 </button> </div> </>
 )}
 {mail_import_dialog.resultat && (
 <> <div style={{ padding:"14px", background:"rgba(6,214,160,0.08)", border:`1px solid ${T.groen}44`, borderRadius:10, marginBottom:14 }}> <div style={{ fontSize:14, color:T.groen, fontWeight:600, marginBottom:6 }}> Import færdig</div> <div style={{ fontSize:13, color:"#e2e8f0", lineHeight:1.7 }}> <strong>{mail_import_dialog.resultat.importeret}</strong> mails importeret som hændelser<br/>
 {mail_import_dialog.resultat.duplikater > 0 && <><strong>{mail_import_dialog.resultat.duplikater}</strong> duplikater sprunget over<br/></>}
 {mail_import_dialog.resultat.fejl > 0 && <><span style={{color:"#fbbf24"}}>{mail_import_dialog.resultat.fejl} fejl under søgning</span><br/></>}
 <span style={{ fontSize:12, color:T.dæmpet }}>Søgt i {mail_import_dialog.resultat.konti_søgt} overvågede konti{mail_import_dialog.resultat.konti_skippet > 0 ? ` (${mail_import_dialog.resultat.konti_skippet} uden Azure AD-konto sprunget over)` : ""}</span> </div> </div>
 {mail_import_dialog.resultat.per_konto?.length > 0 && (
 <div style={{ marginBottom:14 }}> <div style={{ fontSize:11, color:T.dæmpet, marginBottom:4, letterSpacing:"0.05em" }}>Fordeling:</div>
 {mail_import_dialog.resultat.per_konto.map((k,i) => (
 <div key={i} style={{ fontSize:12, color: k.findes_ikke?"#64748b":"#cbd5e1", padding:"4px 8px", background: k.findes_ikke?"rgba(100,116,139,0.06)":"rgba(255,255,255,0.03)", borderRadius:4, marginBottom:3, opacity: k.findes_ikke?0.6:1 }}>
 {k.findes_ikke ? "⊘ " : ""}{k.konto}: {k.findes_ikke ? "(ingen Azure AD-konto)" : <><strong>{k.importeret}</strong> importeret, {k.duplikater} dup{k.fejl > 0 ? `, ${k.fejl} fejl` : ""}{typeof k.fundne === 'number' ? ` · ${k.fundne} scannet` : ""}</>}
 </div>
 ))}
 </div>
 )}
 {/* V1.2.9: Top afsendere der IKKE matchede — hjælper brugeren finde klientens andre email-adresser */}
 {mail_import_dialog.resultat.top_andre_afsendere?.length > 0 && (
 <div style={{ marginBottom:14, padding:"10px 12px", background:"rgba(255,209,102,0.06)", border:`1px solid rgba(255,209,102,0.25)`, borderRadius:8 }}> <div style={{ fontSize:12, color:"#ffd166", marginBottom:6, fontWeight:600 }}>
 Mangler klienten mails? Top afsendere i dine indbakker der IKKE matchede:
 </div>
 {mail_import_dialog.resultat.top_andre_afsendere.slice(0, 8).map((a, i) => (
 <div key={i} style={{ fontSize:12, color:"#cbd5e1", padding:"3px 0", display:"flex", justifyContent:"space-between", gap:8 }}> <button onClick={() => setMailImportDialog(p => ({
 ...p,
 resultat: null,
 emails_tekst: (p.emails_tekst || '').trim() + (p.emails_tekst?.trim() ? ', ' : '') + a.email
 }))}
 title="Klik for at tilføje til email-liste"
 style={{ flex:1, background:"none", border:"none", color:"#cbd5e1", textAlign:"left", cursor:"pointer", fontSize:12, padding:0, fontFamily:"'Inter',system-ui,sans-serif" }}> <strong>{a.navn || a.email}</strong> <span style={{ color:T.dæmpet, fontSize:11 }}>{a.email}</span> </button> <span style={{ color:T.dæmpet, flexShrink:0 }}>{a.antal} mails</span> </div>
 ))}
 <div style={{ fontSize:11, color:T.dæmpet, marginTop:6, fontStyle:"italic" }}>
 Klik på en række for at tilføje adressen og køre import igen.
 </div> </div>
 )}
 <button onClick={() => setMailImportDialog(null)}
 style={{ width:"100%", padding:"10px", borderRadius:8, border:"none", background:T.turkis, color:"#fff", fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Luk
 </button> </>
 )}
 </div> </div>
 )}
 {/* Fuldmagt-genereringsdialog (bruges på eksisterende sag) */}
 {fuldmagt_dialog && (
 <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.78)", zIndex:9999, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}
 onClick={()=>setFuldmagtDialog(null)}> <div onClick={e=>e.stopPropagation()}
 style={{ background:"rgba(10,14,46,0.98)", border:`1px solid ${T.turkis}44`, borderRadius:18, padding:"22px 26px",
 width: fuldmagt_dialog.trin === 'preview' ? "95vw" : 460,
 maxWidth: fuldmagt_dialog.trin === 'preview' ? 1200 : "95vw",
 maxHeight:"92vh", overflowY:"auto", boxShadow:"0 16px 48px rgba(0,0,0,0.6)" }}> <div style={{ fontSize:15, fontWeight:600, color:T.turkis, marginBottom:12 }}>
 {fuldmagt_dialog.trin === 'preview' ? " Fuldmagt genereret" : " Opret fuldmagt"}
 </div> <div style={{ fontSize:13, color:T.dæmpet, marginBottom:16 }}>
 Sag: {fuldmagt_dialog.sagsnummer} · {fuldmagt_dialog.klient_navn}
 </div>
 {fuldmagt_dialog.trin === 'vælg_børn' && fuldmagt_dialog.indlæser_boern && (
 <div style={{ padding:"30px 20px", textAlign:"center", color:T.dæmpet, fontSize:13 }}>
 Henter børn fra sagen...
 </div>
 )}
 {fuldmagt_dialog.trin === 'vælg_børn' && !fuldmagt_dialog.indlæser_boern && (() => {
 const har_boern = fuldmagt_dialog.boern.length > 0;
 const antal_valgt = fuldmagt_dialog.valgte_boern.length;
 const uden_boern = har_boern && antal_valgt === 0;
 return (
 <>
 {/* Klient-CPR mangler — vis inputfelt */}
 {!fuldmagt_dialog.klient_cpr && (
 <div style={{ padding:"12px 14px", background:"rgba(255,209,102,0.08)", border:"1px solid #ffd16644", borderRadius:10, marginBottom:12 }}>
 <div style={{ fontSize:12, color:"#ffd166", fontWeight:600, marginBottom:6 }}>CPR mangler på {fuldmagt_dialog.klient_navn} — påkrævet for gyldig fuldmagt</div>
 <input
 type="text"
 value={fuldmagt_dialog.klient_cpr_indtastet||""}
 onChange={e => setFuldmagtDialog(p => ({...p, klient_cpr_indtastet: e.target.value}))}
 placeholder="CPR-nummer (DDMMÅÅ-XXXX)"
 autoComplete="off"
 style={{ width:"100%", padding:"8px 12px", fontSize:13, borderRadius:8, border:"1px solid rgba(255,209,102,0.4)", background:"rgba(255,209,102,0.06)", color:"#e2e8f0", fontFamily:"monospace", boxSizing:"border-box" }}
 />
 <div style={{ fontSize:10, color:"rgba(255,209,102,0.7)", marginTop:4 }}>Gemmes på klienten ved generering</div>
 </div>
 )}
 {har_boern ? (
 <> <div style={{ fontSize:13, color:T.creme, marginBottom:6 }}>Vælg børn der omfattes af fuldmagten:</div> <div style={{ fontSize:11, color:T.dæmpet, marginBottom:10 }}>Fravælg alle hvis fuldmagten kun skal dække klienten selv (voksen). CPR kræves for at fuldmagten er gyldig hos myndigheder.</div>
 {fuldmagt_dialog.boern.map(b => {
 const bid = b.id;
 const valgt_barn = fuldmagt_dialog.valgte_boern.includes(bid);
 const cpr_indtastet = fuldmagt_dialog.boern_cpr_indtastet?.[bid];
 const har_cpr = !!b.cpr;
 const vis_cpr = har_cpr ? b.cpr : (cpr_indtastet || "");
 return (
 <div key={bid}
 style={{ padding:"10px 12px", borderRadius:8, marginBottom:6,
 background: valgt_barn ? "rgba(63,212,199,0.12)" : "rgba(255,255,255,0.04)",
 border:`1px solid ${valgt_barn ? T.turkis+"44" : "rgba(255,255,255,0.08)"}` }}> <div onClick={() => setFuldmagtDialog(p => ({
 ...p,
 valgte_boern: valgt_barn ? p.valgte_boern.filter(x=>x!==bid) : [...p.valgte_boern, bid]
 }))}
 style={{ display:"flex", alignItems:"center", gap:10, cursor:"pointer" }}> <div style={{ width:20, height:20, borderRadius:5,
 border:`2px solid ${valgt_barn ? T.turkis : "rgba(255,255,255,0.25)"}`,
 background: valgt_barn ? T.turkis : "transparent",
 display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
 {valgt_barn && <span style={{ color:"#fff", fontSize:12, fontWeight:700 }}></span>}
 </div> <div style={{ fontSize:13, color:T.creme, flex:1 }}>{b.fornavn} {b.efternavn}</div>
 {har_cpr && (
 <div style={{ fontSize:11, color:T.dæmpet, fontFamily:"monospace" }}>{b.cpr}</div>
 )}
 </div>
 {valgt_barn && !har_cpr && (
 <div style={{ marginTop:8, paddingLeft:30 }}> <input
 type="text"
 value={vis_cpr}
 onChange={e => setFuldmagtDialog(p => ({ ...p, boern_cpr_indtastet: { ...(p.boern_cpr_indtastet||{}), [bid]: e.target.value } }))}
 placeholder="CPR (DDMMÅÅ-XXXX)"
 autoComplete="off"
 style={{ width:"100%", padding:"6px 10px", fontSize:12, borderRadius:6,
 border:"1px solid rgba(255,209,102,0.4)",
 background:"rgba(255,209,102,0.06)", color:T.creme,
 fontFamily:"monospace" }}
 /> <div style={{ fontSize:10, color:"#ffd166", marginTop:3 }}> CPR mangler — indtast for gyldig fuldmagt</div> </div>
 )}
 </div>
 );
 })}
 </>
 ) : (
 <div style={{ padding:"14px 16px", background:"rgba(255,209,102,0.08)", border:`1px solid #ffd16644`, borderRadius:10, color:"#ffd166", fontSize:13, marginBottom:12 }}>
 Ingen børn registreret på sagen — fuldmagten oprettes kun for klienten selv (voksen).
 </div>
 )}
 {uden_boern && (
 <div style={{ padding:"10px 12px", background:"rgba(255,209,102,0.08)", border:`1px solid #ffd16633`, borderRadius:8, color:"#ffd166", fontSize:12, marginBottom:10 }}>
 Ingen børn valgt — fuldmagt genereres uden børn.
 </div>
 )}
 <div style={{ display:"flex", gap:10, marginTop:14 }}> <button
 disabled={fuldmagt_dialog.loading}
 onClick={async ()=>{
 setFuldmagtDialog(p=>({...p, loading:true}));
 try {
 // KLIENT-CPR: PATCH klientens CPR hvis det manglede og er blevet indtastet
 const klient_cpr_ny = (fuldmagt_dialog.klient_cpr_indtastet || "").trim();
 if (klient_cpr_ny && !fuldmagt_dialog.klient_cpr) {
 const r = await api(`klienter/${fuldmagt_dialog.klient_id}`, "PATCH", { cpr_krypteret: klient_cpr_ny });
 if (r?.fejl) {
 toast("CPR for klienten blev ikke gemt: " + r.fejl, "fejl");
 setFuldmagtDialog(p=>({...p, loading:false}));
 return;
 }
 // Opdater sag_detaljer og dialogen med det nye CPR
 setSagDetaljer(p => ({...p, cpr: klient_cpr_ny}));
 setFuldmagtDialog(p => ({...p, klient_cpr: klient_cpr_ny}));
 }
 // BOERN-CPR: PATCH indtastede CPR på valgte børn før generering.
 // Bruger barnets EGNE sag_id (ikke dialogens) fordi barnet kan
 // være knyttet til en anden sag for samme klient.
 const cpr_indtastet = fuldmagt_dialog.boern_cpr_indtastet || {};
 for (const bid of fuldmagt_dialog.valgte_boern) {
 const ny_cpr = (cpr_indtastet[bid] || "").trim();
 const barn = fuldmagt_dialog.boern.find(x => x.id === bid);
 if (ny_cpr && !barn?.cpr) {
 const sag_id_for_barn = barn?.sag_id || fuldmagt_dialog.sag_id;
 const r = await api(`sager/${sag_id_for_barn}/boern/${bid}`, "PATCH", { cpr: ny_cpr });
 if (!r?.succes) {
 toast(`CPR for ${barn?.fornavn || 'barn'} blev ikke gemt: ${r?.fejl || 'ukendt fejl'}`, "fejl");
 setFuldmagtDialog(p=>({...p, loading:false}));
 return;
 }
 }
 }
 const data = await api("fuldmagt/generer", "POST", {
 sag_id: fuldmagt_dialog.sag_id,
 klient_id: fuldmagt_dialog.klient_id,
 boern_ids: fuldmagt_dialog.valgte_boern,
 });
 if (!data?.succes) {
 if (data?.mangler_skabelon) {
 toast(" " + data.fejl, "fejl");
 } else {
 toast("Fejl: " + (data?.fejl || "Kunne ikke generere fuldmagt"), "fejl");
 }
 setFuldmagtDialog(p=>({...p, loading:false}));
 return;
 }
 setFuldmagtDialog(p=>({...p, loading:false, pdf:data, trin:'preview'}));
 // Opdater sager-listen så fuldmagt-sektionen viser ny status
 hent_sager();
 } catch (err) {
 toast("Fuldmagt kunne ikke genereres — prøv igen", "fejl"); console.error("[FULDMAGT] fejl:", err);
 setFuldmagtDialog(p=>({...p, loading:false}));
 }
 }}
 style={{ flex:1, padding:"12px", borderRadius:8, border:"none",
 background: fuldmagt_dialog.loading ? "rgba(63,212,199,0.4)" : T.turkis,
 color:"#fff", fontSize:14, fontWeight:700,
 cursor: fuldmagt_dialog.loading ? "not-allowed" : "pointer",
 fontFamily:"'Inter',system-ui,sans-serif" }}>
 {fuldmagt_dialog.loading ? " Genererer..."
 : antal_valgt === 0
 ? " Generér fuldmagt (uden børn)"
 : ` Generér fuldmagt (${antal_valgt} ${antal_valgt===1?"barn":"børn"})`}
 </button> <button onClick={()=>setFuldmagtDialog(null)}
 style={{ padding:"12px 16px", borderRadius:8, border:T.skillelinje, background:"transparent", color:T.dæmpet, fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Annuller
 </button> </div> </>
 );
 })()}
 {fuldmagt_dialog.trin === 'preview' && fuldmagt_dialog.pdf && (
 <> <div style={{ fontSize:12, color:T.dæmpet, marginBottom:12 }}>
 Gemt i hændelser og OneDrive · Status: Afventer underskrift
 </div> <div style={{ borderRadius:8, overflow:"hidden", marginBottom:12, background:"#fff", border:"1px solid rgba(0,0,0,0.1)" }}> <iframe
 src={`data:application/pdf;base64,${fuldmagt_dialog.pdf.pdf_base64}`}
 style={{ width:"100%", height:"72vh", minHeight:500, border:"none" }}
 title="Fuldmagt preview"
 /> </div> <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8 }}> <button
 onClick={()=>{
 const pdf = fuldmagt_dialog.pdf;
 const bytes = atob(pdf.pdf_base64);
 const arr = new Uint8Array(bytes.length);
 for (let i=0; i<bytes.length; i++) arr[i] = bytes.charCodeAt(i);
 const blob = new Blob([arr], { type: pdf.mime_type });
 const url = window.URL.createObjectURL(blob);
 const a = document.createElement("a");
 a.href = url; a.download = pdf.filnavn || "Fuldmagt.pdf";
 document.body.appendChild(a); a.click(); a.remove();
 window.URL.revokeObjectURL(url);
 }}
 style={{ padding:"12px", borderRadius:8, border:`1px solid ${T.turkis}44`, background:T.turkis+"12", color:T.turkis, fontSize:13, fontWeight:600, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Download
 </button> <button
 onClick={()=>{
 const pdf = fuldmagt_dialog.pdf;
 const bytes = atob(pdf.pdf_base64);
 const arr = new Uint8Array(bytes.length);
 for (let i=0; i<bytes.length; i++) arr[i] = bytes.charCodeAt(i);
 const blob = new Blob([arr], { type:'application/pdf' });
 const url = window.URL.createObjectURL(blob);
 const win = window.open(url);
 if (win) win.onload = () => { win.print(); };
 }}
 style={{ padding:"12px", borderRadius:8, border:`1px solid ${T.turkis}44`, background:T.turkis+"12", color:T.turkis, fontSize:13, fontWeight:600, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Udskriv
 </button> <button onClick={()=>setFuldmagtDialog(null)}
 style={{ padding:"12px", borderRadius:8, border:T.skillelinje, background:"transparent", color:T.dæmpet, fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Luk
 </button> </div> </>
 )}
 </div> </div>
 )}
 <div style={{ display:"flex", flexDirection:"column" }}>
 {/* ── SAG HERO HEADER (glassmorphism) ── */}
 {valgt && (() => {
 const hAkc = (() => {
 if (!valgt.deadline) return "#475569";
 const d = Math.ceil((new Date(valgt.deadline) - new Date()) / 86400000);
 return d <= 0 ? "#ff6b6b" : d <= 7 ? "#ffd43b" : "#69db7c";
 })();
 const hInit = (valgt.klient||"?").split(" ").map(n=>n[0]).join("").slice(0,2).toUpperCase();
 return (
 <div style={{
 position:"relative", overflow:"hidden",
 background:"rgba(255,255,255,0.035)",
 borderBottom:"1px solid rgba(255,255,255,0.07)",
 backdropFilter:"blur(20px)", WebkitBackdropFilter:"blur(20px)",
 padding:"14px 24px",
 }}>
 {/* Accent strip */}
 <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:`linear-gradient(90deg, ${hAkc}, ${hAkc}44, transparent)`, pointerEvents:"none" }} />
 {/* Ambient glow */}
 <div style={{ position:"absolute", top:-30, right:60, width:160, height:160, borderRadius:"50%", background:`${hAkc}08`, filter:"blur(40px)", pointerEvents:"none" }} /> <div className="sv-sag-header" style={{ display:"flex", alignItems:"center", gap:14, position:"relative" }}>
 {/* Breadcrumb nav */}
 <nav aria-label="Brødkrumme" style={{ display:"flex", alignItems:"center", gap:6, flexShrink:0 }}> <button onClick={luk_sag_lokalt} style={{
 background:"none", border:"none", padding:"4px 2px", color:T.turkis, fontSize:12, fontWeight:500,
 cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif",
 transition:"color 0.15s",
 }}
 onMouseOver={e=>e.currentTarget.style.color="#fff"}
 onMouseOut={e=>e.currentTarget.style.color=T.turkis}
 aria-label="Tilbage til sagsliste">
 Sager
 </button> <span style={{ color:"rgba(255,255,255,0.2)", fontSize:12, userSelect:"none" }}>›</span> <span style={{ fontSize:12, color:"rgba(255,255,255,0.6)", fontWeight:500, maxWidth:160, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }} aria-current="page">{valgt.klient}</span> <span style={{ color:"rgba(255,255,255,0.2)", fontSize:11, userSelect:"none" }}>·</span> <span style={{ fontSize:11, color:"rgba(255,255,255,0.3)" }}>#{valgt.sagsnummer}</span> </nav> <div className="sv-sag-header-sep" style={{ width:1, height:28, background:"rgba(255,255,255,0.08)", flexShrink:0 }} />
 {/* Initials avatar */}
 <div style={{
 width:40, height:40, borderRadius:"50%", flexShrink:0,
 background:`linear-gradient(135deg, ${hAkc}22, ${hAkc}44)`,
 border:`2px solid ${hAkc}55`,
 display:"flex", alignItems:"center", justifyContent:"center",
 fontSize:14, fontWeight:700, color:hAkc, letterSpacing:"0.05em",
 boxShadow:`0 0 12px ${hAkc}22`,
 }}>{hInit}</div>
 {/* Name + meta */}
 <div style={{ flex:1, minWidth:0 }}> <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" }}> <span style={{ fontSize:16, fontWeight:700, color:"#f1f5f9", letterSpacing:"-0.01em", lineHeight:1.2 }}>{valgt.klient}</span> <span style={{ fontSize:11, color:"#64748b", fontWeight:500 }}>#{valgt.sagsnummer}</span>
 {valgt.status && (
 <span style={{
 fontSize:10, textTransform:"uppercase", letterSpacing:"0.08em",
 padding:"2px 8px", borderRadius:20,
 color:STATUS_C[valgt.status]||"#94a3b8",
 background:`${STATUS_C[valgt.status]||"#94a3b8"}15`,
 border:`1px solid ${STATUS_C[valgt.status]||"#94a3b8"}30`,
 }}>{valgt.status}</span>
 )}
 </div>
 {valgt.type && (
 <div style={{ fontSize:11, color:"#64748b", marginTop:2 }}>{sagstype_label(valgt.type)}{valgt.primær ? " · "+valgt.primær : ""}</div>
 )}
 {valgt.fase && (() => {
 const FASER = ["Indgang","Afklaring","Aktiv håndtering","Stabilisering","Afslutning"];
 const cur = FASER.findIndex(f => (valgt.fase||"").toLowerCase().includes(f.toLowerCase().split(" ")[0]));
 const idx = cur >= 0 ? cur : 0;
 return (
 <div style={{ display:"flex", gap:3, marginTop:5, alignItems:"center" }}>
 {FASER.map((f, i) => (
 <div key={f} title={f} style={{
 height:3, flex:1, borderRadius:2,
 background: i <= idx ? hAkc : "rgba(255,255,255,0.08)",
 transition:"background 0.3s",
 }} />
 ))}
 <span style={{ fontSize:10, color:"#94a3b8", marginLeft:5, whiteSpace:"nowrap" }}>{valgt.fase}</span> </div>
 );
 })()}
 </div>
 {/* Deadline pill — klikbar, åbner sag_deadline_dialog */}
 {valgt.deadline && (
 <div style={{
 flexShrink:0,
 background:`${hAkc}10`, border:`1px solid ${hAkc}30`,
 borderRadius:10, padding:"6px 12px",
 display:"flex", flexDirection:"column", alignItems:"flex-end",
 cursor:"pointer",
 }} onClick={()=>{ const aktiv_sag = sager.find(s=>s.id===valgt.id)||valgt; setSagDeadlineDialog({ sag_id:valgt.id, ny_deadline:aktiv_sag.deadline?.split("T")[0]||"", ny_titel:aktiv_sag.deadline_titel||"", original_titel:aktiv_sag.deadline_titel||"", original_deadline:aktiv_sag.deadline_txt||"", begrundelse:"", eksisterende:true }); }}>
 <div style={{ fontSize:13, fontWeight:700, color:hAkc, lineHeight:1.2 }}> {valgt.deadline_txt}</div>
 {valgt.deadline_titel && <div style={{ fontSize:10, color:"#94a3b8", marginTop:1 }}>{valgt.deadline_titel}</div>}
 <div style={{ fontSize:9, color:"rgba(255,255,255,0.4)", marginTop:2 }}>Klik for at ændre</div>
 </div>
 )}
 </div> </div>
 );
 })()}
 {!valgt ? (
 /* ── LISTE ── */
 <div style={{ padding:"clamp(16px, 3vw, 28px) clamp(16px, 4vw, 40px)", maxWidth:1200, margin:"0 auto", width:"100%" }}>
 {/* Søg + filter (#6: visuel adskillelse med klasse) */}
 <div className="sv-ko-filter-sektion-1" style={{ display:"flex", gap:10, marginBottom:0, flexWrap:"wrap", alignItems:"center" }}>
 {/* Søgefelt med ikon og glow */}
 <div style={{ flex:1, minWidth:220, position:"relative" }}> <span style={{
 position:"absolute", left:14, top:"50%", transform:"translateY(-50%)",
 fontSize:15, pointerEvents:"none", opacity:0.45, zIndex:2,
 }}></span> <input value={søg} onChange={e=>setSøg(e.target.value)}
 placeholder="Søg på klient eller sagsnummer..."
 className="sv-input"
 style={{
 width:"100%", boxSizing:"border-box",
 background:"rgba(8,12,30,0.65)", border:"1px solid rgba(255,255,255,0.07)",
 borderRadius:11, padding:"11px 14px 11px 40px",
 color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif",
 transition:"all 0.25s cubic-bezier(0.4,0,0.2,1)",
 }} />
 {søg && (
 <button onClick={()=>setSøg("")} style={{
 position:"absolute", right:10, top:"50%", transform:"translateY(-50%)",
 background:"none", border:"none", color:"rgba(148,163,184,0.5)", fontSize:16,
 cursor:"pointer", padding:"2px 6px", zIndex:2, lineHeight:1,
 }}>×</button>
 )}
 </div>
 {/* Status-filtre */}
 {["alle","aktiv","kritisk","lead","lukket"].map(f=>{
 const aktiv = filter===f;
 const farve_map = { alle:T.turkis, aktiv:"#60a5fa", kritisk:"#f87171", lead:"#a78bfa", lukket:"#94a3b8" };
 const c = farve_map[f] || T.turkis;
 return (
 <button key={f} onClick={()=>setFilter(f)}
 onMouseOver={e=>{ if(!aktiv){ e.currentTarget.style.borderColor=`${c}55`; e.currentTarget.style.color=c; }}}
 onMouseOut={e=>{ if(!aktiv){ e.currentTarget.style.borderColor="rgba(255,255,255,0.08)"; e.currentTarget.style.color=T.dæmpet; }}}
 style={{
 padding:"9px 18px", borderRadius:9,
 border:`1px solid ${aktiv ? c+"55" : "rgba(255,255,255,0.08)"}`,
 background: aktiv ? `linear-gradient(135deg, ${c}18, ${c}08)` : "rgba(255,255,255,0.03)",
 color: aktiv ? c : T.dæmpet,
 fontSize:12, fontWeight: aktiv ? 700 : 400,
 fontFamily:"'Inter',system-ui,sans-serif", cursor:"pointer",
 transition:"all 0.2s cubic-bezier(0.4,0,0.2,1)",
 boxShadow: aktiv ? `0 0 16px ${c}22, inset 0 1px 0 rgba(255,255,255,0.06)` : "none",
 }}>
 {{alle:"Alle",aktiv:"Aktive",kritisk:"Kritiske",lead:"Leads",lukket:"Lukkede"}[f]}
 </button>
 );
 })}
 </div>
 {/* Sager liste — med sortering + cards/liste toggle */}
 {(() => {
 // Sortering — når en sagsbehandler er valgt (default: en selv), vises deres
 // primær-sager før sekundær-sager, derefter den valgte sekundære sortering.
 const primaer_foerst = (sag) => {
 if (!valgt_sb) return 0;
 return sag.primær === valgt_sb ? 0 : 1;
 };
 const sorterede = [...filtrerede].sort((a,b) => {
 const pa = primaer_foerst(a), pb = primaer_foerst(b);
 if (pa !== pb) return pa - pb;
 if (ko_sortering === "alfa_az") return (a.klient||"").localeCompare(b.klient||"", "da");
 if (ko_sortering === "alfa_za") return (b.klient||"").localeCompare(a.klient||"", "da");
 if (ko_sortering === "risiko") return (b.risiko||0) - (a.risiko||0);
 if (ko_sortering === "aktivitet") return (b.haendelser||0) - (a.haendelser||0);
 if (!a.deadline && !b.deadline) return 0;
 if (!a.deadline) return 1;
 if (!b.deadline) return -1;
 return new Date(a.deadline) - new Date(b.deadline);
 });
 const dl_kant = (sag) => {
 if (!sag.deadline) return "#475569";
 const dage = Math.ceil((new Date(sag.deadline) - new Date()) / 86400000);
 if (dage <= 0) return "#ff6b6b";
 if (dage <= 7) return "#ffd43b";
 return "#69db7c";
 };
 const dl_kritisk = (sag) => sag.deadline && Math.ceil((new Date(sag.deadline) - new Date()) / 86400000) <= 0;
 return (
 <div style={{ ...panel, overflow:"hidden" }}>
 {/* Header: Titel + Primær/Sekundær + Sagsbehandlere | Sortering + Toggle til højre */}
 <div style={{ padding:"14px 20px", borderBottom:T.skillelinje }}> <div style={{ display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" }}> <span style={{ fontSize:13, color:"#cbd5e1", fontWeight:600, flexShrink:0 }}>Sager ({sorterede.length})</span> <div style={{ width:1, height:20, background:"rgba(255,255,255,0.08)" }} />
 {/* Primær/Sekundær/Alle roller */}
 {["alle","primær","sekundær"].map(r=>(
 /* K3-fix: aktiv rolle-filter tilføjer sv-dk-rolle-filter-aktiv → CSS-override hæver kontrast til ≥4.5:1 */
 <button key={r} onClick={e=>{e.stopPropagation();setSbFilter(r);}} className={sb_filter===r?"sv-dk-rolle-filter-aktiv":undefined} style={{ fontSize:13, padding:"5px 14px", borderRadius:6, border:`1px solid ${sb_filter===r?"rgba(96,165,250,0.4)":"rgba(255,255,255,0.08)"}`, background:sb_filter===r?"rgba(96,165,250,0.12)":"transparent", color:sb_filter===r?"#60a5fa":"#cbd5e1", cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif", fontWeight:sb_filter===r?600:400 }}>
 {{"alle":"Alle roller","primær":"Primær","sekundær":"Sekundær"}[r]}
 </button>
 ))}
 <div style={{ width:1, height:20, background:"rgba(255,255,255,0.08)" }} />
 {/* Sagsbehandler-filtre */}
 {[{navn:"Alle",id:"alle"}, ...ALLE_BRUGERE_FILTER].map(sb=>(
 /* K4-fix: aktiv sb-filter tilføjer sv-dk-sb-filter-aktiv → CSS-override hæver kontrast til ≥4.5:1 */
 <button key={sb.id||sb.navn} onClick={e=>{e.stopPropagation();setValgtSb(sb.navn==="Alle"?"":sb.navn);}} className={valgt_sb===(sb.navn==="Alle"?"":sb.navn)?"sv-dk-sb-filter-aktiv":undefined} style={{ fontSize:13, padding:"5px 14px", borderRadius:6, border:`1px solid ${valgt_sb===(sb.navn==="Alle"?"":sb.navn)?"rgba(63,212,199,0.4)":"rgba(255,255,255,0.08)"}`, background:valgt_sb===(sb.navn==="Alle"?"":sb.navn)?"rgba(63,212,199,0.12)":"transparent", color:valgt_sb===(sb.navn==="Alle"?"":sb.navn)?T.turkis:"#cbd5e1", cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif", fontWeight:valgt_sb===(sb.navn==="Alle"?"":sb.navn)?600:400 }}>
 {sb.navn==="Alle"?"Alle":sb.navn.split(" ")[0]}
 </button>
 ))}
 {/* Spacer — skubber sortering og toggle til højre */}
 <div style={{ flex:1 }} />
 {/* Sortering */}
 <select style={{colorScheme:"dark"}} value={ko_sortering} onChange={e=>setKoSortering(e.target.value)}
 style={{ fontSize:13, background:"rgba(255,255,255,0.04)", border:T.skillelinje, borderRadius:6, padding:"5px 12px", color:"#cbd5e1", cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}> <option value="deadline">Deadline</option> <option value="alfa_az">A–Å</option> <option value="alfa_za">Å–A</option> <option value="aktivitet">Aktivitet</option> <option value="risiko">Sagsstyrke</option> </select>
 {/* Liste/kort toggle */}
 <div style={{ display:"flex", background:"rgba(255,255,255,0.04)", borderRadius:6, border:T.skillelinje, overflow:"hidden" }}> <button onClick={()=>{setKoVisning("liste");localStorage.setItem("sv_ko_visning","liste")}}
 style={{ padding:"4px 10px", background:ko_visning==="liste"?"rgba(63,212,199,0.15)":"transparent", border:"none", color:ko_visning==="liste"?T.turkis:"#94a3b8", fontSize:14, cursor:"pointer", lineHeight:1 }}
 title="Listevisning"></button> <button onClick={()=>{setKoVisning("kort");localStorage.setItem("sv_ko_visning","kort")}}
 style={{ padding:"4px 10px", background:ko_visning==="kort"?"rgba(63,212,199,0.15)":"transparent", border:"none", color:ko_visning==="kort"?T.turkis:"#94a3b8", fontSize:14, cursor:"pointer", lineHeight:1 }}
 title="Kortvisning">▦</button> </div> </div> </div>
 {/* Arkiv-stats banner — vises når filter er "lukket" */}
 {filter === "lukket" && sorterede.length > 0 && (() => {
 const typer = sorterede.reduce((acc, s) => { acc[s.type] = (acc[s.type]||0)+1; return acc; }, {});
 const top_typer = Object.entries(typer).sort((a,b)=>b[1]-a[1]).slice(0,3);
 return (
 <div style={{ margin:"0 16px 12px", padding:"12px 16px", background:"rgba(148,163,184,0.06)", border:"1px solid rgba(148,163,184,0.15)", borderRadius:12, display:"flex", gap:20, flexWrap:"wrap", alignItems:"center" }}> <div style={{ display:"flex", flexDirection:"column" }}> <span style={{ fontSize:22, fontWeight:700, color:"#94a3b8", lineHeight:1 }}>{sorterede.length}</span> <span style={{ fontSize:10, color:"#64748b", textTransform:"uppercase", letterSpacing:"0.1em" }}>Arkiverede sager</span> </div> <div style={{ width:1, height:32, background:"rgba(255,255,255,0.07)", flexShrink:0 }} />
 {top_typer.map(([type, antal]) => (
 <div key={type} style={{ display:"flex", flexDirection:"column" }}> <span style={{ fontSize:16, fontWeight:600, color:"#94a3b8", lineHeight:1 }}>{antal}</span> <span style={{ fontSize:10, color:"#64748b" }}>{sagstype_label(type) || type}</span> </div>
 ))}
 <div style={{ flex:1 }} /> <div style={{ fontSize:11, color:"#475569", fontStyle:"italic" }}>Lukkede sager er skrivebeskyttet — genåbn sag for at redigere</div> </div>
 );
 })()}
 {sorterede.length === 0 ? (
 <div style={{ padding:"40px", textAlign:"center" }}> <div style={{ fontSize:28, marginBottom:10 }}></div> <div style={{ fontSize:14, color:"#cbd5e1", marginBottom:6 }}>Ingen sager matcher</div> <div style={{ fontSize:12, color:"#b0bec5" }}>Prøv et andet filter eller søgeord</div> </div>
 ) : ko_visning === "kort" ? (
 <div style={{ padding:16 }}> <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(320px, 1fr))", gap:14 }}>
 {sorterede.map((sag, idx) => {
 const akc = dl_kant(sag);
 const initials = (sag.klient||"?").split(" ").map(n=>n[0]).join("").slice(0,2).toUpperCase();
 const styrkeW = Math.max(sag.risiko||0, 3);
 const recovery_ikke_tjekket = !sag.klient_recovery_check_completed_dato;
 return (
 <div key={sag.id} onClick={()=>aabn_sag_lokalt(sag)}
 className={"sv-sag-kort sv-3d-tilt sv-holo-card sv-card-pop" + (recovery_ikke_tjekket ? " sv-recovery-blink" : "")}
 style={{
 position:"relative", overflow:"hidden",
 background: "rgba(8,12,30,0.65)",
 border: `1px solid rgba(255,255,255,0.07)`,
 borderRadius:16, padding:"20px 20px 16px",
 cursor:"pointer",
 backdropFilter:"blur(20px)", WebkitBackdropFilter:"blur(20px)",
 transition:"transform 0.25s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.25s, background 0.2s",
 animation: dl_kritisk(sag) ? "deadline-pulse 2.5s ease-in-out infinite" : undefined,
 animationDelay: dl_kritisk(sag) ? undefined : `${idx * 0.05}s`,
 }}
 onMouseOver={e=>{
 e.currentTarget.style.boxShadow=`0 20px 60px rgba(0,0,0,0.5), 0 0 0 1px ${akc}55, 0 0 40px ${akc}18`;
 e.currentTarget.style.background="rgba(255,255,255,0.07)";
 e.currentTarget.style.borderColor=`${akc}33`;
 }}
 onMouseOut={e=>{
 e.currentTarget.style.boxShadow="none";
 e.currentTarget.style.background="rgba(255,255,255,0.04)";
 e.currentTarget.style.borderColor="rgba(255,255,255,0.08)";
 }}>
 {/* Accent strip top */}
 <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:`linear-gradient(90deg, ${akc}, ${akc}44, transparent)`, borderRadius:"16px 16px 0 0" }} />
 {/* Glow orb */}
 <div style={{ position:"absolute", top:-20, right:-20, width:80, height:80, borderRadius:"50%", background:`${akc}10`, filter:"blur(20px)", pointerEvents:"none" }} />
 {/* Top row: avatar + name + status */}
 <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:10 }}> <div style={{ position:"relative", width:40, height:40, borderRadius:"50%", flexShrink:0,
 background:`linear-gradient(135deg, ${akc}22, ${akc}44)`,
 border:`1.5px solid ${akc}55`,
 display:"flex", alignItems:"center", justifyContent:"center",
 fontSize:14, fontWeight:700, color:akc, letterSpacing:"0.05em" }}>
 {initials}
 {sag.har_nye_haendelser && (
 <span title="Nye hændelser siden sidste besøg" style={{
 position:"absolute", top:-3, right:-3, width:14, height:14, borderRadius:"50%",
 background:"#38bdf8", border:"2px solid rgba(8,12,30,0.9)",
 animation:"nyt-pulse 2s ease-in-out infinite",
 }} />
 )}
 </div> <div style={{ flex:1, minWidth:0 }}> <div style={{ display:"flex", alignItems:"center", gap:8, minWidth:0 }}> <div style={{ fontSize:15, fontWeight:700, color:"#f1f5f9", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", lineHeight:1.3, minWidth:0 }}>{sag.klient}</div>
 {sag.har_nye_haendelser && (
 <span title="Nye hændelser siden sidste besøg" style={{
 fontSize:9, fontWeight:800, textTransform:"uppercase", letterSpacing:"0.06em",
 padding:"2px 8px", borderRadius:20, flexShrink:0,
 color:"#38bdf8", background:"#0a1420",
 border:"1px solid #38bdf8aa", boxShadow:"0 0 8px rgba(56,189,248,0.4)" }}>
 Ny
 </span>
 )} </div> <div style={{ fontSize:11, color:"#64748b", marginTop:1 }}>{sag.sagsnummer}</div> </div>
 <span style={{ fontSize:11, textTransform:"uppercase", letterSpacing:"0.08em", padding:"3px 9px", borderRadius:20, flexShrink:0,
 color:STATUS_C[sag.status]||"#94a3b8",
 background:`${STATUS_C[sag.status]||"#94a3b8"}15`,
 border:`1px solid ${STATUS_C[sag.status]||"#94a3b8"}30` }}>
 {sag.status}
 </span> </div>
 {/* Metadata */}
 <div style={{ fontSize:12, color:"#64748b", marginBottom:12, paddingLeft:52 }}>
 {sagstype_label(sag.type)} · {sag.primær}
 </div>
 {/* Deadline */}
 <div style={{
 background: sag.deadline ? `${akc}08` : "rgba(255,255,255,0.02)",
 border: sag.deadline ? `1px solid ${akc}25` : "1px solid rgba(255,255,255,0.05)",
 borderRadius:10, padding:"8px 12px", marginBottom:12,
 boxShadow: sag.deadline && dl_kritisk(sag) ? `0 0 14px ${akc}20` : "none",
 transition:"all 0.3s ease",
 }}>
 {sag.deadline ? (
 <div style={{ display:"flex", alignItems:"center", gap:6 }}> <span style={{ fontSize:13, color:akc }}></span> <div> <div style={{ fontSize:13, fontWeight:700, color:akc, lineHeight:1.2 }}>{sag.deadline_txt}</div>
 <div style={{ fontSize:11, color: sag.deadline_titel ? "#94a3b8" : "#fb7185" }}>{sag.deadline_titel || "⚠️ Mangler beskrivelse"}</div>
 </div> </div>
 ) : (
 <div style={{ fontSize:12, color:"#475569", fontStyle:"italic" }}>Ingen deadline sat</div>
 )}
 </div>
 {/* Recovery-check (Migration 081) — gennemgang efter server-rebuild */}
 <div style={{ marginBottom:10 }}>
 {recovery_ikke_tjekket ? (
 <button
 onClick={e => { e.stopPropagation(); toggle_recovery_check(sag.klient_id, true); }}
 title="Markér denne klient som gennemgået efter server-rebuild"
 style={{ width:"100%", padding:"8px 12px", borderRadius:8,
 background:"rgba(255,209,102,0.12)", border:"1px solid rgba(255,209,102,0.45)",
 color:"#ffd166", fontSize:12, fontWeight:600, cursor:"pointer",
 fontFamily:"'Inter',system-ui,sans-serif" }}>
 Markér som tjekket
 </button>
 ) : (
 <div style={{ display:"flex", alignItems:"center", gap:8 }}> <span style={{ flex:1, fontSize:11, color:"#69db7c" }}>
 Tjekket {new Date(sag.klient_recovery_check_completed_dato).toLocaleString("da-DK", { day:"2-digit", month:"2-digit", hour:"2-digit", minute:"2-digit" })}
 </span> <button
 onClick={e => { e.stopPropagation(); toggle_recovery_check(sag.klient_id, false); }}
 title="Fortryd markering"
 style={{ padding:"4px 10px", borderRadius:6,
 background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.1)",
 color:"#94a3b8", fontSize:11, cursor:"pointer",
 fontFamily:"'Inter',system-ui,sans-serif" }}>
 ↺ Fortryd
 </button> </div>
 )}
 </div>
 {/* Risk bar */}
 <div style={{ display:"flex", alignItems:"center", gap:8 }}> <div style={{ fontSize:11, color:"#475569", width:48, flexShrink:0 }}>Styrke</div> <div style={{ flex:1, height:5, borderRadius:3, background:"rgba(255,255,255,0.05)", overflow:"hidden" }}> <div style={{ height:"100%", width:`${styrkeW}%`, background:`linear-gradient(90deg, ${sag.styrke_farve||"#ff6b6b"}, ${sag.styrke_farve||"#ff6b6b"}88)`, borderRadius:3, transition:"width 0.6s ease" }} /> </div> <span style={{ fontSize:11, color:sag.styrke_farve||"#ff6b6b", fontWeight:700, width:28, textAlign:"right", flexShrink:0 }}>{sag.risiko}</span> </div> </div>
 );
 })}
 </div> </div>
 ) : (
 sorterede.map((sag,i)=>{
 const akc = dl_kant(sag);
 const initials = (sag.klient||"?").split(" ").map(n=>n[0]).join("").slice(0,2).toUpperCase();
 const recovery_ikke_tjekket = !sag.klient_recovery_check_completed_dato;
 return (
 <div key={sag.id} onClick={()=>aabn_sag_lokalt(sag)}
 className={recovery_ikke_tjekket ? "sv-recovery-blink" : ""}
 style={{ padding:"14px 20px", borderBottom:i<sorterede.length-1?"1px solid rgba(255,255,255,0.05)":"none",
 display:"flex", alignItems:"center", gap:0, cursor:"pointer",
 transition:"background 0.15s",
 minHeight:56,
 position:"relative" }}
 onMouseOver={e=>{ if(!recovery_ikke_tjekket) e.currentTarget.style.background="rgba(255,255,255,0.035)"; }}
 onMouseOut={e=>{ if(!recovery_ikke_tjekket) e.currentTarget.style.background="transparent"; }}>
 {/* Accent bar */}
 <div style={{ width:3, minWidth:3, alignSelf:"stretch", borderRadius:2,
 background:`linear-gradient(180deg, ${akc}, ${akc}44)`,
 marginRight:16, flexShrink:0,
 animation: dl_kritisk(sag) ? "deadline-pulse 2.5s ease-in-out infinite" : "none" }} />
 {/* Avatar */}
 <div style={{ position:"relative", width:36, height:36, borderRadius:"50%", flexShrink:0, marginRight:14,
 background:`${akc}15`, border:`1.5px solid ${akc}33`,
 display:"flex", alignItems:"center", justifyContent:"center",
 fontSize:12, fontWeight:700, color:akc, letterSpacing:"0.05em" }}>
 {initials}
 {sag.har_nye_haendelser && (
 <span title="Nye hændelser siden sidste besøg" style={{
 position:"absolute", top:-2, right:-2, width:12, height:12, borderRadius:"50%",
 background:"#38bdf8", border:"2px solid rgba(8,12,30,0.9)",
 animation:"nyt-pulse 2s ease-in-out infinite",
 }} />
 )}
 </div>
 {/* Main content */}
 <div style={{ flex:1, minWidth:0 }}> <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:16 }}> <div style={{ minWidth:0 }}> <div style={{ display:"flex", alignItems:"center", gap:8 }}> <div style={{ fontSize:15, fontWeight:600, color:"#f1f5f9", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{sag.klient}</div>
 {sag.har_nye_haendelser && (
 <span title="Nye hændelser siden sidste besøg" style={{
 fontSize:9, fontWeight:800, textTransform:"uppercase", letterSpacing:"0.06em",
 padding:"2px 8px", borderRadius:20, flexShrink:0,
 color:"#38bdf8", background:"#0a1420",
 border:"1px solid #38bdf8aa", boxShadow:"0 0 8px rgba(56,189,248,0.4)" }}>
 Ny
 </span>
 )}
 </div> <div style={{ fontSize:11, color:"#64748b", marginTop:2 }}>{sag.sagsnummer} · {sagstype_label(sag.type)} · {sag.primær}{sag.sekundær ? " · "+sag.sekundær : ""}</div> </div> <div style={{ textAlign:"right", flexShrink:0, display:"flex", flexDirection:"column", alignItems:"flex-end", gap:4 }}>
 {sag.deadline ? (
 <div onClickCapture={e=>{ e.stopPropagation(); e.preventDefault(); setSagDeadlineDialog({ sag_id:sag.id, ny_deadline:sag.deadline?.split("T")[0]||"", ny_titel:sag.deadline_titel||"", original_titel:sag.deadline_titel||"", original_deadline:sag.deadline_txt||"", begrundelse:"", eksisterende:true }); }}
 style={{ cursor:"pointer", padding:"5px 10px", borderRadius:8,
 background:`${akc}10`, border:`1px solid ${akc}25`,
 transition:"all 0.15s", position:"relative", zIndex:2 }}
 onMouseOver={e=>{e.stopPropagation();e.currentTarget.style.background=`${akc}20`}}
 onMouseOut={e=>e.currentTarget.style.background=`${akc}10`}> <div style={{ fontSize:13, fontWeight:700, color:akc }}>{sag.deadline_txt}</div>
 {sag.deadline_titel && <div style={{ fontSize:11, color:"#94a3b8" }}>{sag.deadline_titel}</div>}
 </div>
 ) : (
 <div onClickCapture={e=>{ e.stopPropagation(); e.preventDefault(); setSagDeadlineDialog({ sag_id:sag.id, ny_deadline:"", ny_titel:"", begrundelse:"" }); }}
 style={{ fontSize:12, color:"#475569", cursor:"pointer", padding:"5px 10px", borderRadius:8, border:"1px dashed rgba(255,255,255,0.08)" }}>+ Sæt deadline</div>
 )}
 <span className="sv-liste-status-badge" style={{ fontSize:10, textTransform:"uppercase", letterSpacing:"0.08em", padding:"2px 8px", borderRadius:20,
 color:STATUS_C[sag.status]||"#94a3b8",
 background:`${STATUS_C[sag.status]||"#94a3b8"}12`,
 border:`1px solid ${STATUS_C[sag.status]||"#94a3b8"}25` }}>{sag.status}</span>
 {sag.fuldmagt_udloeb && (() => {
 const dage = Math.ceil((new Date(sag.fuldmagt_udloeb) - new Date()) / 86400000);
 if (dage < 0) return <span title="Fuldmagt udløbet" style={{ fontSize:10, padding:"2px 8px", borderRadius:20, color:"#ff6b6b", background:"rgba(255,107,107,0.12)", border:"1px solid rgba(255,107,107,0.3)" }}> Fuldmagt</span>;
 if (dage <= 30) return <span title={`Fuldmagt udløber om ${dage} dage`} style={{ fontSize:10, padding:"2px 8px", borderRadius:20, color:"#ffd166", background:"rgba(255,209,102,0.12)", border:"1px solid rgba(255,209,102,0.3)" }}> {dage}d</span>;
 return null;
 })()}
 </div> </div>
 {/* Risk bar — slimmer in list view */}
 <div style={{ display:"flex", alignItems:"center", gap:6, marginTop:8 }}> <div style={{ flex:1, height:2, borderRadius:1, background:"rgba(255,255,255,0.05)", overflow:"hidden" }}> <div style={{ height:"100%", width:`${Math.max(sag.risiko||0, 3)}%`, background:sag.styrke_farve||"#ff6b6b", borderRadius:1, transition:"width 0.6s ease" }} /> </div> <span style={{ fontSize:11, color:sag.styrke_farve||"#ff6b6b", fontWeight:600, width:60, textAlign:"right", flexShrink:0 }}>
 {sag.risiko >= 70 ? "Stærk" : sag.risiko >= 40 ? "Mod" : "Svag"} {sag.risiko}
 </span>
 {/* Recovery-check (Migration 081) */}
 {recovery_ikke_tjekket ? (
 <button
 onClick={e => { e.stopPropagation(); toggle_recovery_check(sag.klient_id, true); }}
 title="Markér klienten som gennemgået efter server-rebuild"
 style={{ padding:"4px 10px", borderRadius:6,
 background:"rgba(255,209,102,0.14)", border:"1px solid rgba(255,209,102,0.5)",
 color:"#ffd166", fontSize:11, fontWeight:600, cursor:"pointer",
 fontFamily:"'Inter',system-ui,sans-serif", flexShrink:0, whiteSpace:"nowrap" }}>
 Markeret som tjekket
 </button>
 ) : (
 <button
 onClick={e => { e.stopPropagation(); toggle_recovery_check(sag.klient_id, false); }}
 title={`Tjekket ${new Date(sag.klient_recovery_check_completed_dato).toLocaleString("da-DK")}`}
 style={{ padding:"4px 10px", borderRadius:6,
 background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.1)",
 color:"#94a3b8", fontSize:11, cursor:"pointer",
 fontFamily:"'Inter',system-ui,sans-serif", flexShrink:0, whiteSpace:"nowrap" }}>
 ↺ Fortryd
 </button>
 )}
 </div> </div> </div>
 );
 })
 )}
 </div>
 );
 })()}
 </div>
 ) : (
 /* ── SAG DETALJE ── */
 <div style={{ padding:"clamp(16px, 3vw, 28px) clamp(16px, 4vw, 40px)", maxWidth:1200, margin:"0 auto", width:"100%" }}>
 {/* Tabs */}
 <div className="sv-tabs-sticky" style={{ display:"flex", gap:4, marginBottom:20, padding:"4px", background:"rgba(255,255,255,0.03)", borderRadius:12, border:"1px solid rgba(255,255,255,0.06)", width:"fit-content", flexWrap:"wrap" }}>
 {[["overblik","","Overblik"],["haendelser","","Hændelser"],["email","","E-mails"],["filer","","Sagsakter"],["upload","📥","Upload-links"],["sagsbehandler","","Sagsbehandlere"],["eksterne","","Eksterne"]].map(([id,ikon,l])=>(
 <button key={id} onClick={()=>skift_fane_lokalt(id)} style={{
 background: aktiv_tab===id ? "linear-gradient(135deg, rgba(63,212,199,0.18), rgba(79,70,229,0.12))" : "transparent",
 border: aktiv_tab===id ? "1px solid rgba(63,212,199,0.28)" : "1px solid transparent",
 borderRadius:9, padding:"7px 14px",
 color: aktiv_tab===id ? T.turkis : "#94a3b8",
 fontSize:12, fontWeight: aktiv_tab===id ? 700 : 500,
 cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif",
 transition:"all 0.2s",
 display:"flex", alignItems:"center", gap:5,
 boxShadow: aktiv_tab===id ? "0 2px 16px rgba(63,212,199,0.18), 0 0 8px rgba(63,212,199,0.12), inset 0 1px 0 rgba(255,255,255,0.08)" : "none",
 filter: aktiv_tab===id ? "drop-shadow(0 0 4px rgba(63,212,199,0.3))" : "none",
 }}
 onMouseOver={e=>{ if(aktiv_tab!==id) e.currentTarget.style.background="rgba(255,255,255,0.06)"; }}
 onMouseOut={e=>{ if(aktiv_tab!==id) e.currentTarget.style.background="transparent"; }}> <span style={{ fontSize:13 }}>{ikon}</span> <span>{l}</span> </button>
 ))}
 </div>
 {/* ── TAB: OVERBLIK ── */}
 {aktiv_tab==="overblik" && (
 <div className="sv-panel-animated" style={{ animationDelay:"0.05s" }}>
 {/* X8: GuidePanel — perfektionsmåler + AI-anbefalinger */}
 <GuidePanel sag_id={valgt.id} />
 {/* Rediger klient modal */}
 {rediger_klient && (
 <div className="sv-rediger-form" style={{ ...panel, padding:"20px", marginBottom:12, border:`1px solid ${T.turkis}44` }}> <div style={{ fontSize:13, fontWeight:500, color:T.turkis, marginBottom:16 }}> Rediger klientoplysninger</div>
 {[
 ["Fornavn","fornavn","text"],
 ["Efternavn","efternavn","text"],
 ["Telefon","telefon","tel"],
 ["Email","email","email"],
 ["Adresse","adresse","text"],
 ["Postnr","postnr","text"],
 ["By","by","text"],
 ].map(([label, felt, type])=>(
 <div key={felt} style={{ marginBottom:10 }}> <div style={{ fontSize:12, color:T.dæmpet, textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:4 }}>{label}</div> <input
 type={type}
 autoComplete="off"
 value={rediger_form[felt] !== undefined ? rediger_form[felt] : ""}
 onChange={e => setRedigerForm(p=>({...p, [felt]: e.target.value}))}
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:`1px solid rgba(255,255,255,0.08)`, borderRadius:8, padding:"10px 12px", color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", boxSizing:"border-box" }}
 /> </div>
 ))}
  <div style={{ marginBottom:10 }}>
 <div style={{ fontSize:12, color:T.dæmpet, textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:4 }}>CPR-nummer</div>
 <input
 type="text"
 autoComplete="off"
 value={rediger_form.cpr_krypteret !== undefined ? rediger_form.cpr_krypteret : ""}
 onChange={e => setRedigerForm(p=>({...p, cpr_krypteret: e.target.value}))}
 placeholder="DDMMÅÅ-XXXX"
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.08)", borderRadius:8, padding:"10px 12px", color:T.creme, fontSize:13, fontFamily:"monospace", boxSizing:"border-box" }}
 />
 </div>
 {/* Fuldmagt */}
 <div style={{ height:2, background:"rgba(13,148,136,0.38)", margin:"14px 0" }} /> <div style={{ fontSize:12, color:"#ffd166", textTransform:"uppercase", letterSpacing:"0.12em", marginBottom:10 }}>Fuldmagt</div> <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:10 }}> <label style={{ display:"flex", alignItems:"center", gap:8, cursor:"pointer" }}> <input type="checkbox" checked={rediger_form.fuldmagt_modtaget||false} onChange={e=>setRedigerForm(p=>({...p, fuldmagt_modtaget:e.target.checked}))} style={{ accentColor:T.turkis }} /> <span style={{ fontSize:13, color:T.creme }}>Fuldmagt modtaget</span> </label> </div>
 {rediger_form.fuldmagt_modtaget && (
 <div className="sv-form-grid" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}> <div> <div style={{ fontSize:12, color:T.dæmpet, textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:4 }}>Fuldmagt dato</div> <input type="date" value={rediger_form.fuldmagt_dato||""} onChange={e=>setRedigerForm(p=>({...p, fuldmagt_dato:e.target.value}))}
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"10px 12px", color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", boxSizing:"border-box" }} /> </div> <div> <div style={{ fontSize:12, color:T.dæmpet, textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:4 }}>Fuldmagt udløb</div> <input type="date" value={rediger_form.fuldmagt_udloeb||""} onChange={e=>setRedigerForm(p=>({...p, fuldmagt_udloeb:e.target.value}))}
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"10px 12px", color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", boxSizing:"border-box" }} />
 {rediger_form.fuldmagt_udloeb && (() => {
 const dage = Math.ceil((new Date(rediger_form.fuldmagt_udloeb) - new Date()) / 86400000);
 if (dage < 0) return <div style={{ fontSize:12, color:T.roed, marginTop:4 }}>Fuldmagt er udløbet</div>;
 if (dage <= 30) return <div style={{ fontSize:12, color:"#ffd166", marginTop:4 }}>Udløber om {dage} dage</div>;
 return null;
 })()}
 </div> </div>
 )}
 {/* V1.3.1: Alternative emails/telefoner inline i hurtig-rediger */}
 {valgt.klient_id && (
 <div style={{ marginTop:14 }}> <KlientKontakterPanel
 klient_id={valgt.klient_id}
 klient_primaer_email={rediger_form.email}
 klient_primaer_telefon={rediger_form.telefon}
 compact={true}
 /> </div>
 )}
 <div style={{ display:"flex", gap:10, marginTop:16 }}> <button onClick={async()=>{
 // BUG-FIX 1.1.1/1.1.3: Brug klient_id for PATCH + mappe klient-felter
 // tilbage til sag-objektet (klient_telefon/klient_email) + await genhentning
 // så visningen synker med serverens sandhed.
 const klient_id = valgt.klient_id;
 if (!klient_id) { toast("Intern fejl: klient_id mangler", "fejl"); return; }
 const r = await api("klienter/"+klient_id, "PATCH", rediger_form);
 if (!r || r.fejl) {
 toast("Kunne ikke gemme: " + (r?.fejl || "serverfejl"), "fejl");
 return;
 }
 // Map klient-felter → sag-objektets klient_*-aliasser for øjeblikkelig visning
 const navn_sammenflettet = [rediger_form.fornavn, rediger_form.efternavn]
 .filter(Boolean).join(" ").trim();
 const sag_opdatering = {
 ...valgt,
 ...rediger_form, // behold evt. andre felter direkte
 klient: navn_sammenflettet || valgt.klient,
 klient_telefon: rediger_form.telefon !== undefined ? rediger_form.telefon : valgt.klient_telefon,
 klient_email: rediger_form.email !== undefined ? rediger_form.email : valgt.klient_email,
 };
 setValgt(sag_opdatering);
 setSager(p => p.map(s => s.id === valgt.id ? sag_opdatering : s));
 setRedigerKlient(false);
 setRedigerForm({});
 if (window.__sv_toast) window.__sv_toast("Klientoplysninger gemt", "success");
 // Genhent sager-listen i baggrunden så vi får ALLE server-beregnede felter
 // (fx klient_navn trimmed, audit-log osv.)
 hent_sager();
 }} style={{ flex:1, background:T.turkis, border:"none", borderRadius:8, padding:"10px", color:"#ffffff", fontWeight:700, fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Gem ændringer
 </button> <button onClick={()=>{setRedigerKlient(false);setRedigerForm({});}} style={{ flex:1, background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"10px", color:T.dæmpet, fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Annuller
 </button> </div> </div>
 )}
 {/* ── AI NÆSTE SKRIDT BOKS ── */}
 {(ai_naeste_loader || ai_naeste_skridt?.skridt?.length > 0) && valgt?.status !== 'lukket' && (
 <div style={{ background:"rgba(35,34,190,0.07)", border:"1px solid rgba(35,34,190,0.25)", borderRadius:14, padding:"14px 18px", marginBottom:12, position:"relative", overflow:"hidden" }}> <div style={{ position:"absolute", top:0, left:0, right:0, height:2, background:"linear-gradient(90deg,#2322be,#a78bfa,transparent)", borderRadius:"14px 14px 0 0", pointerEvents:"none" }} /> <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom: ai_naeste_loader ? 0 : 10 }}> <span style={{ fontSize:14 }} aria-hidden="true"></span> <div style={{ fontSize:11, color:"#a5b4fc", letterSpacing:"0.15em", textTransform:"uppercase", fontWeight:600 }}>AI anbefaler</div>
 {ai_naeste_loader && <span style={{ fontSize:11, color:"#64748b" }}>— henter...</span>}
 </div>
 {!ai_naeste_loader && ai_naeste_skridt?.skridt?.map((s, i) => (
 <div key={i} style={{ display:"flex", alignItems:"flex-start", gap:10, padding:"5px 0", borderTop: i>0 ? "1px solid rgba(255,255,255,0.04)" : "none" }}> <span style={{ fontSize:11, color:"#a5b4fc", fontWeight:700, minWidth:18, paddingTop:1 }}>{i+1}.</span> <span style={{ fontSize:13, color:"#e2e8f0", lineHeight:1.55 }}>{s}</span> </div>
 ))}
 </div>
 )}
 {/* ── AI RESUMÉ PANEL ── */}
 <div style={{ position:"relative", overflow:"hidden", background:"rgba(63,212,199,0.05)", border:`1px solid ${T.turkis}33`, borderRadius:18, padding:"18px 20px", marginBottom:12, boxShadow:`0 0 60px rgba(63,212,199,0.06), inset 0 1px 0 rgba(63,212,199,0.08)` }}>
 {/* Accent strip */}
 <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:`linear-gradient(90deg, ${T.turkis}, #a78bfa, transparent)`, borderRadius:"18px 18px 0 0", pointerEvents:"none" }} />
 {/* Dual glow orbs */}
 <div style={{ position:"absolute", top:-30, right:-10, width:140, height:140, borderRadius:"50%", background:`${T.turkis}07`, filter:"blur(35px)", pointerEvents:"none" }} /> <div style={{ position:"absolute", bottom:-20, left:20, width:100, height:100, borderRadius:"50%", background:"rgba(167,139,250,0.06)", filter:"blur(25px)", pointerEvents:"none" }} />
 {/* Rød advarsel ved forældede resuméer */}
 {ai_resume && ai_resume_forældet && (
 <div style={{ background:"rgba(255,107,107,0.1)", border:"1px solid rgba(255,107,107,0.3)", borderRadius:8, padding:"8px 14px", marginBottom:12, display:"flex", alignItems:"center", gap:8 }}> <span style={{ fontSize:14 }}></span> <span style={{ fontSize:12, color:"#ff6b6b", flex:1 }}>
 Der er kommet {ai_resume_nye} ny{ai_resume_nye !== 1 ? "e" : ""} hændelse{ai_resume_nye !== 1 ? "r" : ""} siden dette resumé — det anbefales at opdatere
 </span> <button onClick={async () => {
 setAiResumeLoader(true);
 const r = await api("ai-sag/resume", "POST", { sag_id: valgt.id });
 if (r?.resumé || r?.resume) { setAiResume(r); setAiResumeForældet(false); setAiResumeNye(0); setAiResumeLoader(false); }
 else if (r?.opgave_id) { pollAiOpgave(r.opgave_id, d => { setAiResume(d); setAiResumeForældet(false); setAiResumeNye(0); setAiResumeLoader(false); }, () => setAiResumeLoader(false)); }
 else { setAiResumeLoader(false); }
 }} style={{ background:"rgba(255,107,107,0.15)", border:"1px solid rgba(255,107,107,0.3)", borderRadius:6, padding:"4px 12px", color:"#ff6b6b", fontSize:12, fontFamily:"'Inter',system-ui,sans-serif", cursor:"pointer", whiteSpace:"nowrap" }}>
 Opdatér nu
 </button> </div>
 )}
 <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom: ai_resume || ai_resume_loader ? 14 : 0 }}> <div style={{ display:"flex", alignItems:"center", gap:8 }}> <span style={{ fontSize:16 }} aria-hidden="true"></span> <div style={{ fontSize:12, color:T.turkis, letterSpacing:"0.15em", textTransform:"uppercase" }}>AI-resumé</div> <HjaelpIkon tekst="AI gennemlæser alle hændelser, noter og dokumenter på sagen og genererer et kort resumé + anbefalede næste skridt + sagsstyrke (0-100). Klientnavne pseudonymiseres automatisk inden data sendes til Claude. Resuméet opdateres manuelt — tryk ↻ Opdatér hvis der er kommet nye hændelser." />
 {ai_resume && <span style={{ fontSize:12, color:T.dæmpet }}>— {new Date(ai_resume.genereret).toLocaleDateString("da-DK")} kl. {new Date(ai_resume.genereret).toLocaleTimeString("da-DK",{hour:"2-digit",minute:"2-digit"})}</span>}
 </div> <button
 onClick={async () => {
 setAiResumeLoader(true);
 const r = await api("ai-sag/resume", "POST", { sag_id: valgt.id });
 if (r?.resumé || r?.resume) { setAiResume(r); setAiResumeForældet(false); setAiResumeNye(0); setAiResumeLoader(false); }
 else if (r?.opgave_id) { pollAiOpgave(r.opgave_id, d => { setAiResume(d); setAiResumeForældet(false); setAiResumeNye(0); setAiResumeLoader(false); }, () => setAiResumeLoader(false)); }
 else { setAiResumeLoader(false); }
 }}
 disabled={ai_resume_loader}
 style={{ background: ai_resume_loader ? "rgba(63,212,199,0.2)" : `${T.turkis}22`, border:`1px solid ${T.turkis}55`, borderRadius:8, padding:"7px 16px", color:T.turkis, fontSize:12, fontFamily:"'Inter',system-ui,sans-serif", cursor:ai_resume_loader?"wait":"pointer", fontWeight:600 }}>
 {ai_resume_loader ? " Analyserer..." : ai_resume ? "↻ Opdatér" : "Generér resumé"}
 </button> </div>
 {ai_resume && (
 <div style={{ animation:"sv-panel-enter 0.4s cubic-bezier(0.34,1.56,0.64,1) both" }}> <div style={{ fontSize:13, color:"#e2e8f0", lineHeight:1.75, marginBottom:14, whiteSpace:"pre-wrap" }}>{ai_resume.resumé || ai_resume.resume || ai_resume.tekst || "Resumé mangler indhold — prøv at generere på ny."}</div>
 {ai_resume.næste_skridt && (
 <div style={{ marginBottom:14 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.12em", textTransform:"uppercase", marginBottom:8, display:"inline-flex", alignItems:"center", gap:6 }}>Næste skridt <HjaelpIkon tekst="AI-genereret forslag til hvad der bør gøres næste på sagen baseret på nuværende fase, kommende deadlines og tidligere handlinger. Ikke juridisk rådgivning — altid vurder selv inden handling." /></div> <div style={{ fontSize:13, color:"#cbd5e1", lineHeight:1.8, whiteSpace:"pre-wrap", paddingLeft:4 }}>{ai_resume.næste_skridt}</div> </div>
 )}
 {ai_resume.risiko && (
 <div style={{ display:"flex", alignItems:"center", gap:10, padding:"8px 12px", background:"rgba(8,12,30,0.5)", borderRadius:8 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase" }}>
 Sagsstyrke
 <HjaelpIkon tekst="Sagsstyrke er AI's vurdering af sagens position (0-100). Lav værdi = svag sag, høj = stærk. Beregnes ud fra dokumenter, tidslinje, modparts-handlinger og lovkrav. Bruges til at prioritere arbejdstid — ikke som juridisk dom." /> </div> <span style={{ fontSize:12, fontWeight:600, padding:"2px 10px", borderRadius:4,
 color: ai_resume.risiko==="Hoej"||ai_resume.risiko==="Høj"?T.groen:ai_resume.risiko==="Middel"?"#f59e0b":T.roed,
 background: ai_resume.risiko==="Hoej"||ai_resume.risiko==="Høj"?"rgba(6,214,160,0.12)":ai_resume.risiko==="Middel"?"rgba(245,158,11,0.12)":"rgba(255,107,107,0.12)",
 border:`1px solid ${ai_resume.risiko==="Hoej"||ai_resume.risiko==="Høj"?"rgba(6,214,160,0.3)":ai_resume.risiko==="Middel"?"rgba(245,158,11,0.3)":"rgba(255,107,107,0.3)"}`,
 }}>{{Hoej:"Stærk",Høj:"Stærk",Middel:"Moderat",Lav:"Svag"}[ai_resume.risiko]||ai_resume.risiko}</span> <span style={{ fontSize:12, color:"#b0bec5" }}>{(ai_resume.risiko_tekst||"").replace(/^(Lav|Middel|Hoej|Høj)\s*-?\s*/i,"")}</span> </div>
 )}
 </div>
 )}
 </div>
 {/* Sagsinfo */}
 <div style={{ ...panel, padding:"20px", marginBottom:12, position:"relative", overflow:"hidden" }}>
 {/* Accent strip + glow */}
 <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:`linear-gradient(90deg, ${T.turkis}, ${T.turkis}44, transparent)`, borderRadius:"16px 16px 0 0", pointerEvents:"none" }} /> <div style={{ position:"absolute", top:-20, right:-20, width:100, height:100, borderRadius:"50%", background:`${T.turkis}08`, filter:"blur(25px)", pointerEvents:"none" }} /> <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase" }}>Sagsoverblik</div> <div style={{ display:"flex", gap:8 }}>
 {valgt?.status === "lukket" ? (
 <button onClick={async()=>{
 try {
 await api("sager/"+valgt.id, "PATCH", { status: "aktiv" });
 setSager(p=>p.map(s=>s.id===valgt.id?{...s,status:"aktiv"}:s));
 setValgt(p=>({...p, status:"aktiv"}));
 setLukBesked(" Sag genåbnet");
 setTimeout(()=>setLukBesked(""), 2500);
 } catch(e) {}
 }} style={{ background:"rgba(6,214,160,0.1)", border:"1px solid rgba(6,214,160,0.3)", borderRadius:6, padding:"4px 12px", color:T.groen, fontSize:12, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Genåbn sag
 </button>
 ) : (
 <button onClick={()=>setVisLukDialog(true)} style={{ background:"rgba(255,107,107,0.08)", border:"1px solid rgba(255,107,107,0.25)", borderRadius:6, padding:"4px 12px", color:T.roed, fontSize:12, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Luk sag
 </button>
 )}
 <button onClick={async()=>{
 try {
 const data = await api("klienter/" + valgt.klient_id);
 const k = data?.klient || {};
 setRedigerForm({ fornavn: k.fornavn||"", efternavn: k.efternavn||"", telefon: k.telefon||"", email: k.email||"", adresse: k.adresse||"", postnr: k.postnr||"", by: k.by||"", cpr_krypteret: k.cpr_krypteret||"", fuldmagt_modtaget: k.fuldmagt_modtaget||false, fuldmagt_dato: k.fuldmagt_dato ? k.fuldmagt_dato.split("T")[0] : "", fuldmagt_udloeb: k.fuldmagt_udloeb ? k.fuldmagt_udloeb.split("T")[0] : "" });
 } catch(e) {
 setRedigerForm({ fornavn: valgt.klient?.split(",")[0]||"", efternavn: "", telefon: "", email: "", adresse: "", postnr: "", by: "", fuldmagt_modtaget: false, fuldmagt_dato: "", fuldmagt_udloeb: "" });
 }
 setRedigerKlient(true);
 setTimeout(()=>document.querySelector('.sv-rediger-form')?.scrollIntoView({behavior:"smooth",block:"nearest"}),50);
 }} style={{ background:"none", border:`1px solid ${T.turkis}44`, borderRadius:6, padding:"4px 12px", color:T.turkis, fontSize:12, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}> Hurtig rediger</button> <button onClick={()=>setVisRedigerKlient(true)} style={{ background:`${T.turkis}18`, border:`1px solid ${T.turkis}55`, borderRadius:6, padding:"4px 12px", color:T.turkis, fontSize:12, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif", fontWeight:600 }}> Rediger alt</button>
 {JSON.parse(sessionStorage.getItem("sv_bruger")||"{}").rolle === "direktoer" && (
 <button onClick={() => setSletSagDialog(true)} style={{ background:"rgba(255,59,59,0.08)", border:"1px solid rgba(255,59,59,0.25)", borderRadius:6, padding:"4px 12px", color:T.roed, fontSize:12, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}> Slet sag</button>
 )}
 </div> </div>
 {luk_besked && <div style={{ marginBottom:10, padding:"8px 14px", background:"rgba(6,214,160,0.1)", border:"1px solid rgba(6,214,160,0.3)", borderRadius:8, fontSize:12, color:T.groen }}>{luk_besked}</div>}
 {/* Luk sag dialog */}
 {vis_luk_dialog && (
 <div style={{ marginBottom:14, padding:"16px", background:"rgba(255,107,107,0.08)", border:"1px solid rgba(255,107,107,0.25)", borderRadius:10 }}> <div style={{ fontSize:13, fontWeight:500, color:T.roed, marginBottom:10 }}>Luk sag — angiv årsag</div> <select style={{colorScheme:"dark"}} value={luk_årsag} onChange={e=>setLukÅrsag(e.target.value)} style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"10px 12px", color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", marginBottom:10, appearance:"none", WebkitAppearance:"none" }}> <option value="">Vælg årsag...</option> <option value="forlig">Forlig indgået</option> <option value="afsluttet">Sag afsluttet</option> <option value="frafaldt">Klient frafaldt</option> <option value="overfoert">Overført til anden</option> <option value="andet">Andet</option> </select> <div style={{ display:"flex", gap:8 }}> <button disabled={!luk_årsag} onClick={async()=>{
 try {
 await api("sager/"+valgt.id, "PATCH", { status: "lukket" });
 // Arkivér OneDrive mappe
 api("onedrive/arkiver", "POST", { sag_id: valgt.id }).catch(err => { console.error(err); toast("En handling fejlede — prøv igen", "fejl"); });
 setSager(p=>p.map(s=>s.id===valgt.id?{...s,status:"lukket",deadline:null,deadline_txt:"—"}:s));
 setValgt(p=>({...p, status:"lukket",deadline:null,deadline_txt:"—"}));
 setVisLukDialog(false); setLukÅrsag("");
 setLukBesked(" Sag lukket — filer arkiveret på OneDrive");
 setTimeout(()=>setLukBesked(""), 2500);
 } catch(e) {}
 }} style={{ flex:1, background:luk_årsag?"rgba(255,107,107,0.2)":"rgba(255,255,255,0.04)", border:`1px solid ${luk_årsag?"rgba(255,107,107,0.4)":"rgba(255,255,255,0.08)"}`, borderRadius:8, padding:"9px", color:luk_årsag?T.roed:T.dæmpet, fontSize:13, cursor:luk_årsag?"pointer":"default", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Bekræft lukning
 </button> <button onClick={()=>{setVisLukDialog(false);setLukÅrsag("");}} style={{ flex:1, background:"rgba(255,255,255,0.04)", border:T.skillelinje, borderRadius:8, padding:"9px", color:T.dæmpet, fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Annuller
 </button> </div> </div>
 )}
 {/* Slet sag dialog — kun direktør */}
 {slet_sag_dialog && (
 <div style={{ marginBottom:14, padding:"16px", background:"rgba(255,59,59,0.08)", border:"1px solid rgba(255,59,59,0.3)", borderRadius:10 }}> <div style={{ fontSize:13, fontWeight:600, color:T.roed, marginBottom:4 }}> Slet sag permanent</div> <div style={{ fontSize:12, color:T.dæmpet, marginBottom:12 }}>Alle hændelser og filer på OneDrive slettes permanent. Denne handling kan ikke fortrydes.</div> <textarea value={slet_sag_begrundelse} onChange={e => setSletSagBegrundelse(e.target.value)}
 placeholder="Angiv begrundelse for sletning (påkrævet)..."
 rows={3} spellCheck="true" lang="da"
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:8, padding:"10px 12px", color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", resize:"none", marginBottom:10, boxSizing:"border-box" }} /> <div style={{ display:"flex", gap:8 }}> <button disabled={!slet_sag_begrundelse.trim()} onClick={async () => {
 if (!slet_sag_begrundelse.trim()) return;
 try {
 await api("onedrive/slet/" + valgt.id, "DELETE");
 await api("sager/" + valgt.id, "DELETE", { begrundelse: slet_sag_begrundelse });
 setSager(p => p.filter(s => s.id !== valgt.id));
 setValgt(null);
 setSletSagDialog(false);
 setSletSagBegrundelse("");
 } catch(e) { toast("Fejl ved sletning", "fejl"); }
 }} style={{ flex:1, background:"rgba(255,59,59,0.2)", border:"1px solid rgba(255,59,59,0.5)", borderRadius:8, padding:"9px", color:T.roed, fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif", fontWeight:600, opacity: slet_sag_begrundelse.trim() ? 1 : 0.4 }}>
 Slet sag permanent
 </button> <button onClick={() => { setSletSagDialog(false); setSletSagBegrundelse(""); }}
 style={{ flex:1, background:"rgba(255,255,255,0.04)", border:T.skillelinje, borderRadius:8, padding:"9px", color:T.dæmpet, fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Annuller
 </button> </div> </div>
 )}
<div className="sv-form-grid" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 }}>
 {[
 ["Klient",valgt.klient, null],
 ["Sagsnummer",valgt.sagsnummer, null],
 ["Sagstype",sagstype_label(valgt.type), "Konfigureres i Admin → Sagstyper. Hver type har en farvemarkering der genses konsekvent i dashboards, klient-liste og kort."],
 ["Fase",valgt.fase || "—", "Hvor i sagens livscyklus klienten er (fx Opstart, Afventer svar, Ved afslutning). Skift fase via højre-knap så fase-historik bevares."],
 ["Status",valgt.status, "aktiv = igang · lead = potentielt klient · venter = pausen sat · lukket = afsluttet (flyttes til arkiv)"],
 ["Sagsstyrke", valgt.risiko > 0 ? `${valgt.risiko}/100` : "Ikke beregnet", "AI's vurdering af sagens position (0-100). Lav = svag sag. Beregnes ud fra dokumenter, deadlines, modparts-handlinger og lovkrav. Bruges som prioritering — ikke juridisk dom."],
 ["Næste deadline", valgt.deadline_titel ? `${valgt.deadline_titel} — ${valgt.deadline_txt||"—"}` : valgt.deadline_txt||"—", "Den nærmeste tidsfrist. Farve: rød = overskredet/i dag · gul = inden for 7 dage · grøn = længere ude. Opdateres automatisk ved nye hændelser."],
 ].map(([l,v,hjaelp])=>(
 <div key={l} style={{ background:"rgba(8,12,30,0.4)", border:"1px solid rgba(255,255,255,0.06)", borderRadius:10, padding:"10px 12px" }}> <div style={{ fontSize:10, color:T.dæmpet, textTransform:"uppercase", letterSpacing:"0.12em", marginBottom:5, display:"inline-flex", alignItems:"center", gap:4, fontWeight:600 }}>
 {l}{hjaelp && <HjaelpIkon tekst={hjaelp} />}
 </div> <div style={{ fontSize:14, color:T.creme, fontWeight:500 }}>{v||"—"}</div> </div>
 ))}
 </div>
 {/* Fase-skift — inline dropdown */}
 <div style={{ marginTop:10, display:"flex", alignItems:"center", gap:10 }}> <span style={{ fontSize:11, color:T.dæmpet, textTransform:"uppercase", letterSpacing:"0.12em", fontWeight:600, flexShrink:0 }}>Skift fase</span> <select
 value={valgt.fase || "ukendt"}
 onChange={async e => {
 const ny_fase = e.target.value;
 setSager(p => p.map(s => s.id===valgt.id ? {...s, fase:ny_fase} : s));
 setValgt(p => ({...p, fase:ny_fase}));
 try { await api("sager/"+valgt.id, "PATCH", { fase: ny_fase }); }
 catch(err) { console.error("Fase fejl:", err); }
 }}
 style={{ colorScheme:"dark", background:"rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.12)", borderRadius:8, padding:"5px 10px", color:T.creme, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", cursor:"pointer" }}
 > <option value="ukendt">— Ikke sat —</option> <option value="0">Fase 0 — Indgang &amp; Triage</option> <option value="1">Fase 1 — Afklaring</option> <option value="2">Fase 2 — Aktiv Håndtering</option> <option value="3">Fase 3 — Stabilisering</option> <option value="4">Fase 4 — Afslutning</option> </select> </div>
 {/* V1.0 Telavox: Ring-op + email-knapper til klient */}
 {(valgt.klient_telefon || valgt.klient_email) && (
 <div style={{ display:"flex", gap:10, marginTop:14, flexWrap:"wrap" }}>
 {valgt.klient_telefon && (
 <RingOpKnap nummer={valgt.klient_telefon} sag_id={valgt.id} klient_id={valgt.klient_id} label={`Ring op (${valgt.klient_telefon})`} />
 )}
 {valgt.klient_email && (
 <a href={`mailto:${valgt.klient_email}`} style={{ display:'inline-flex', alignItems:'center', gap:6, padding:'6px 12px', background:'rgba(96,165,250,0.12)', border:'1px solid rgba(96,165,250,0.35)', borderRadius:8, color:'#60a5fa', fontSize:13, fontWeight:600, cursor:'pointer', textDecoration:'none', fontFamily:"'Inter',system-ui,sans-serif" }}>
 {valgt.klient_email}
 </a>
 )}
 </div>
 )}
 {/* V1.3.2: Adresse + alternative kontakter (kompakt info-linje) */}
 {valgt.klient_id && (
 <KlientKontaktLinje
 klient_id={valgt.klient_id}
 adresse={valgt.klient_adresse}
 postnr={valgt.klient_postnr}
 by={valgt.klient_by}
 />
 )}
 {/* CPR-nummer — vises for alle roller der har adgang */}
 {sag_detaljer.cpr && sag_detaljer.cpr !== '—' && (
 <div style={{ marginTop:8, display:"flex", alignItems:"center", gap:10 }}>
 <span style={{ fontSize:11, color:T.dæmpet, textTransform:"uppercase", letterSpacing:"0.12em", fontWeight:600 }}>CPR</span>
 <span style={{ fontSize:13, color:T.creme, fontFamily:"monospace" }}>{sag_detaljer.cpr}</span>
 </div>
 )}
 {sag_detaljer.cpr === '—' && (
 <div style={{ marginTop:8, display:"flex", alignItems:"center", gap:10 }}>
 <span style={{ fontSize:11, color:T.dæmpet, textTransform:"uppercase", letterSpacing:"0.12em", fontWeight:600 }}>CPR</span>
 <span style={{ fontSize:12, color:"#ffd166" }}>Ikke registreret — rediger klientoplysninger for at tilføje</span>
 </div>
 )}
 {/* Modpart og børn fra hændelser */}
 {(() => {
 const modpart_h = sag_haendelser?.find(h => h.titel === "Modpartoplysninger");
 const boern_h = sag_haendelser?.find(h => h.titel === "Børneoplysninger (GDPR niveau 2)");
 if (!modpart_h && !boern_h) return null;
 return (
 <> <div style={{ height:2, background:"rgba(13,148,136,0.38)", margin:"14px 0" }} />
 {modpart_h && (
 <div style={{ marginBottom:12 }}> <div style={{ fontSize:12, color:"#ffd166", textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:6 }}> Modpart</div> <div style={{ fontSize:13, color:T.creme, lineHeight:1.8, whiteSpace:"pre-line" }}>{modpart_h.beskrivelse}</div> </div>
 )}
 {boern_h && (
 <div style={{ marginBottom:4 }}> <div style={{ fontSize:12, color:"#c084fc", textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:6 }}> Børn · GDPR niveau 2</div> <div style={{ fontSize:13, color:T.creme, lineHeight:1.8, whiteSpace:"pre-line" }}>{boern_h.beskrivelse}</div> </div>
 )}
 </>
 );
 })()}
 {/* Klientens mål og aftaler */}
 {(valgt.klient_maal || valgt.aftaler) && (
 <> <div style={{ height:2, background:"rgba(13,148,136,0.38)", margin:"14px 0" }} />
 {valgt.klient_maal && (
 <div style={{ marginBottom:12 }}> <div style={{ fontSize:12, color:T.dæmpet, textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:4 }}>Klientens mål</div> <div style={{ fontSize:13, color:T.creme, lineHeight:1.6 }}>{valgt.klient_maal}</div> </div>
 )}
 {valgt.aftaler && (
 <div style={{ marginBottom:4 }}> <div style={{ fontSize:12, color:T.dæmpet, textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:4 }}>Aftaler</div> <div style={{ fontSize:13, color:T.creme, lineHeight:1.6 }}>{valgt.aftaler}</div> </div>
 )}
 </>
 )}
 {/* Primær og sekundær sagsbehandler — interaktive dropdowns */}
 <div style={{ height:2, background:"rgba(13,148,136,0.38)", margin:"14px 0" }} /> <div className="sv-form-grid" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}> <div> <div style={{ fontSize:12, color:T.dæmpet, textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:6 }}>Primær sagsbehandler</div> <select
 value={valgt.primær_id || ""}
 onChange={async e => {
 const ny_id = e.target.value ? Number(e.target.value) : null;
 const b = ALLE_BRUGERE.find(x => x.id === ny_id);
 const ny_navn = b?.navn || "";
 setSager(p => p.map(s => s.id===valgt.id ? {...s, primær:ny_navn, primær_id:ny_id} : s));
 setValgt(p => ({...p, primær:ny_navn, primær_id:ny_id}));
 await api("sager/"+valgt.id, "PATCH", { primær_sagsbehandler_id: ny_id }).catch(err => { console.error(err); toast("Kunne ikke gemme", "fejl"); });
 toast(" Primær sagsbehandler gemt", "success");
 }}
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.08)", borderRadius:8, padding:"8px 12px", color:T.creme, fontSize:13, cursor:"pointer", colorScheme:"dark", appearance:"none", fontFamily:"'Inter',system-ui,sans-serif",
 backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3e%3cpath fill='%2394a3b8' d='M0 0l5 6 5-6z'/%3e%3c/svg%3e")`,
 backgroundRepeat:"no-repeat", backgroundPosition:"right 12px center", paddingRight:"32px" }}> <option value="" style={{background:"#0f1328", color:"#94a3b8"}}>Ikke tildelt</option>
 {ALLE_BRUGERE.map(b => <option key={b.id} value={b.id} style={{background:"#0f1328", color:"#e2e8f0"}}>{b.navn}</option>)}
 </select> </div> <div> <div style={{ fontSize:12, color:T.dæmpet, textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:6 }}>Sekundær sagsbehandler</div> <select
 value={valgt.sekundær_id || ""}
 onChange={async e => {
 const ny_id = e.target.value ? Number(e.target.value) : null;
 const b = ALLE_BRUGERE.find(x => x.id === ny_id);
 const ny_navn = b?.navn || null;
 setSager(p => p.map(s => s.id===valgt.id ? {...s, sekundær:ny_navn, sekundær_id:ny_id} : s));
 setValgt(p => ({...p, sekundær:ny_navn, sekundær_id:ny_id}));
 await api("sager/"+valgt.id, "PATCH", { sekundær_sagsbehandler_id: ny_id }).catch(err => { console.error(err); toast("Kunne ikke gemme", "fejl"); });
 toast(ny_id ? " Sekundær sagsbehandler gemt" : " Sekundær fjernet", "success");
 }}
 style={{ width:"100%", background:"rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.08)", borderRadius:8, padding:"8px 12px", color:T.creme, fontSize:13, cursor:"pointer", colorScheme:"dark", appearance:"none", fontFamily:"'Inter',system-ui,sans-serif",
 backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3e%3cpath fill='%2394a3b8' d='M0 0l5 6 5-6z'/%3e%3c/svg%3e")`,
 backgroundRepeat:"no-repeat", backgroundPosition:"right 12px center", paddingRight:"32px" }}> <option value="" style={{background:"#0f1328", color:"#94a3b8"}}>Ingen (valgfri)</option>
 {ALLE_BRUGERE.filter(b => b.id !== valgt.primær_id).map(b => <option key={b.id} value={b.id} style={{background:"#0f1328", color:"#e2e8f0"}}>{b.navn}</option>)}
 </select> </div> </div>
 {/* Eksterne kontakter overblik */}
 {(valgt.eksterne||[]).length > 0 && (
 <> <div style={{ height:2, background:"rgba(13,148,136,0.38)", margin:"14px 0" }} /> <div style={{ fontSize:12, color:T.dæmpet, textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:8 }}>Eksterne kontakter</div> <div className="sv-form-grid" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:6 }}>
 {valgt.eksterne.map(k=>(
 <div key={k.id} style={{ background:"rgba(8,12,30,0.6)", borderRadius:8, padding:"9px 12px", border:"1px solid rgba(255,255,255,0.07)", backdropFilter:"blur(12px)" }}> <div style={{ fontSize:12, color:T.lys, fontWeight:600 }}>{k.navn}</div> <div style={{ fontSize:11, color:T.dæmpet, marginTop:2 }}>{k.rolle}</div> </div>
 ))}
 </div> </>
 )}
 <div style={{ display:"flex", gap:20, flexWrap:"wrap" }}> </div> <div style={{ height:1, background:"linear-gradient(90deg, transparent, rgba(63,212,199,0.2), transparent)", margin:"14px 0" }} /> <div style={{ display:"flex", gap:10, flexWrap:"wrap" }}>
 {[["Hændelser",valgt.haendelser,"#60a5fa"],["Åbne opgaver",valgt.opgaver,"#f59e0b"]].map(([l,v,farve])=>(
 <div key={l} className="sv-card-pop" style={{
 flex:1, minWidth:90, textAlign:"center",
 background:`${farve}08`,
 border:`1px solid ${farve}22`,
 borderRadius:12, padding:"12px 10px",
 position:"relative", overflow:"hidden",
 boxShadow:`0 2px 12px ${farve}12`,
 }}> <div style={{ position:"absolute", inset:0, background:`radial-gradient(circle at 50% 0%, ${farve}12, transparent 70%)`, pointerEvents:"none" }} /> <div style={{ fontSize:24, fontWeight:700, color:farve, letterSpacing:"-0.03em", lineHeight:1.1 }}>{v}</div> <div style={{ fontSize:10, color:T.dæmpet, marginTop:4, letterSpacing:"0.1em", textTransform:"uppercase" }}>{l}</div> </div>
 ))}
 {/* Deadline-kort — klikbart hvis deadline sat, åbner sag_deadline_dialog */}
 <div className="sv-card-pop" style={{
 flex:1, minWidth:90, textAlign:"center",
 background:`${valgt.deadline_farve||"#94a3b8"}08`,
 border:`1px solid ${valgt.deadline_farve||"#94a3b8"}22`,
 borderRadius:12, padding:"12px 10px",
 position:"relative", overflow:"hidden",
 boxShadow:`0 2px 12px ${valgt.deadline_farve||"#94a3b8"}12`,
 cursor: valgt.deadline ? "pointer" : "default",
 }} onClick={valgt.deadline ? ()=>{ const aktiv_sag = sager.find(s=>s.id===valgt.id)||valgt; setSagDeadlineDialog({ sag_id:valgt.id, ny_deadline:aktiv_sag.deadline?.split("T")[0]||"", ny_titel:aktiv_sag.deadline_titel||"", original_titel:aktiv_sag.deadline_titel||"", original_deadline:aktiv_sag.deadline_txt||"", begrundelse:"", eksisterende:true }); } : undefined}>
 <div style={{ position:"absolute", inset:0, background:`radial-gradient(circle at 50% 0%, ${valgt.deadline_farve||"#94a3b8"}12, transparent 70%)`, pointerEvents:"none" }} />
 <div style={{ fontSize:24, fontWeight:700, color:valgt.deadline_farve||"#94a3b8", letterSpacing:"-0.03em", lineHeight:1.1 }}>{valgt.deadline_txt||"—"}</div>
 <div style={{ fontSize:10, color:T.dæmpet, marginTop:4, letterSpacing:"0.1em", textTransform:"uppercase" }}>Deadline</div>
 {valgt.deadline && <div style={{ fontSize:9, color:"rgba(255,255,255,0.35)", marginTop:2 }}>Klik for at ændre</div>}
 </div>
 </div> </div>
 {/* ── DEADLINES FOR DENNE SAG ── */}
 <div style={{ ...panel, padding:"16px 20px", marginTop:12, position:"relative", overflow:"hidden" }}> <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:"linear-gradient(90deg, #ffd43b, #ffd43b44, transparent)", borderRadius:"16px 16px 0 0", pointerEvents:"none" }} /> <div style={{ position:"absolute", top:-15, right:-15, width:80, height:80, borderRadius:"50%", background:"rgba(255,212,59,0.07)", filter:"blur(20px)", pointerEvents:"none" }} /> <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", display:"flex", alignItems:"center", gap:6 }}> Deadlines <HjaelpIkon tekst="Tidsfrister på sagen. Tilføj deadline med klar titel (fx 'Svar fra kommune') — systemet minder dig 30/14/7 dage før via notifikationer. Deadlines vises også på forsiden og dashboard." /></div> <button onClick={()=>{
 const aktiv_sag = sager.find(s=>s.id===valgt.id)||valgt;
 setSagDeadlineDialog({ sag_id:valgt.id, ny_deadline:"", ny_titel:"", begrundelse:"", eksisterende: !!aktiv_sag.deadline });
 }} style={{ background:T.turkis+"18", border:`1px solid ${T.turkis}44`, borderRadius:6, padding:"4px 10px", color:T.turkis, fontSize:12, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 + Ny deadline
 </button> </div>
 {(() => {
 const aktiv_sag = sager.find(s=>s.id===valgt.id)||valgt;
 const dl_haendelser = sag_haendelser.filter(h =>
 h.type === 'deadline' ||
 (h.titel && h.titel.toLowerCase().includes('deadline')) ||
 h.deadline
 ).sort((a,b) => {
 const da = a.deadline || a.dato; const db_ = b.deadline || b.dato;
 return new Date(da) - new Date(db_);
 });
 const har_sag_dl = aktiv_sag.deadline;
 if (!har_sag_dl && dl_haendelser.length === 0) {
 return <div style={{ fontSize:13, color:T.dæmpet, fontStyle:"italic" }}>Ingen deadlines sat — tryk + for at oprette</div>;
 }
 return (
 <div>
 {har_sag_dl && (
 <div style={{ display:"flex", alignItems:"center", gap:12, padding:"10px 12px", background:"rgba(255,255,255,0.03)", borderRadius:8, border:T.kort_kant, marginBottom:8, cursor:"pointer" }}
 onClick={()=>setSagDeadlineDialog({ sag_id:valgt.id, ny_deadline:aktiv_sag.deadline?.split("T")[0]||"", ny_titel:aktiv_sag.deadline_titel||"", original_titel:aktiv_sag.deadline_titel||"", original_deadline:aktiv_sag.deadline_txt||"", begrundelse:"", eksisterende:true })}> <div style={{ width:4, height:32, borderRadius:2, background:aktiv_sag.deadline_farve, flexShrink:0 }} /> <div style={{ flex:1 }}> <div style={{ fontSize:13, fontWeight:600, color:T.creme }}>{aktiv_sag.deadline_titel || "Deadline"}</div> <div style={{ fontSize:12, color:aktiv_sag.deadline_farve }}>{aktiv_sag.deadline_txt}</div> </div> <div style={{ fontSize:12, color:T.dæmpet }}>{aktiv_sag.deadline ? new Date(aktiv_sag.deadline).toLocaleDateString("da-DK") : ""}</div> </div>
 )}
 {dl_haendelser.slice(0,5).map((h,i) => {
 const dl_dato = h.deadline || h.dato;
 const dl_info = h.deadline ? beregn_deadline_info(h.deadline) : null;
 const dl_farve = dl_info?.farve || T.dæmpet;
 return (
 <div key={h.id} style={{ display:"flex", alignItems:"center", gap:10, padding:"8px 0", borderBottom: i < Math.min(dl_haendelser.length,5)-1 ? T.skillelinje : "none" }}>
 <span style={{ fontSize:14 }}></span>
 <div style={{ flex:1 }}>
 <div style={{ fontSize:13, color:T.creme }}>{h.titel}</div>
 {dl_info ? (
 <div style={{ fontSize:12, color:dl_farve }}>{dl_info.txt}</div>
 ) : (
 <div style={{ fontSize:12, color:T.dæmpet }}>{new Date(dl_dato).toLocaleDateString("da-DK")}</div>
 )}
 </div>
 {h.deadline && <div style={{ fontSize:12, color:T.dæmpet }}>{new Date(h.deadline).toLocaleDateString("da-DK")}</div>}
 </div>
 );
 })}
 </div>
 );
 })()}
 </div>
 {/* ── MØDER ── */}
 <div style={{ ...panel, padding:"16px 20px", marginTop:12, position:"relative", overflow:"hidden" }}> <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:"linear-gradient(90deg, #60a5fa, #60a5fa44, transparent)", borderRadius:"16px 16px 0 0", pointerEvents:"none" }} /> <div style={{ position:"absolute", top:-15, right:-15, width:80, height:80, borderRadius:"50%", background:"rgba(96,165,250,0.07)", filter:"blur(20px)", pointerEvents:"none" }} /> <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase" }}>
 Møder
 <HjaelpIkon tekst="Opret møder i Outlook-kalender direkte fra appen. Titel får automatisk sagsnummer-prefix (SV-XXXX). Events oprettet i Outlook med samme prefix importeres automatisk til denne sag." /> </div> <button onClick={() => {
 const aktiv_sag = sager.find(s=>s.id===valgt.id)||valgt;
 api(`klienter/${aktiv_sag.klient_id}`).then(kd => {
 const klient_email = kd?.klient?.email || "";
 const primaer_id = aktiv_sag.primær_id;
 const sekundaer_id = aktiv_sag.sekundær_id;
 const default_kalendere = [primaer_id, sekundaer_id].filter(Boolean);
 setMoedeDialog({
 sag_id: aktiv_sag.id, sagsnummer: aktiv_sag.sagsnummer, klient_navn: aktiv_sag.klient, klient_email,
 titel: "", dato: new Date().toISOString().split('T')[0],
 start_tid: "10:00", slut_tid: "11:00", lokation: "", beskrivelse: "",
 deltagere_tekst: klient_email, kalender_bruger_ids: default_kalendere,
 loading: false, resultat: null,
 });
 }).catch(() => {});
 }}
 style={{ background:T.turkis+"18", border:`1px solid ${T.turkis}44`, borderRadius:6, padding:"4px 10px", color:T.turkis, fontSize:12, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 + Nyt møde
 </button> </div> <MoederListe
 sag_id={valgt.id}
 refresh_key={moeder_refresh}
 onOpen={(m) => {
 const aktiv_sag = sager.find(s=>s.id===valgt.id)||valgt;
 const start = m.metadata?.start_tid ? new Date(m.metadata.start_tid) : new Date(m.begivenhedsdato || Date.now());
 const slut = m.metadata?.slut_tid ? new Date(m.metadata.slut_tid) : new Date(start.getTime() + 60*60*1000);
 const kb = Array.isArray(m.metadata?.kalender_brugere) ? m.metadata.kalender_brugere : [];
 const til_ToTime = (d) => d.toTimeString().slice(0,5);
 setMoedeDialog({
 mode: 'rediger', haendelse_id: m.id,
 sag_id: aktiv_sag.id, sagsnummer: aktiv_sag.sagsnummer, klient_navn: aktiv_sag.klient,
 titel: (m.titel || "").replace(/^SV-\d+(?:-\d+)?\s*-\s*/i, ""),
 dato: start.toISOString().split('T')[0],
 start_tid: til_ToTime(start), slut_tid: til_ToTime(slut),
 lokation: m.metadata?.lokation || "",
 beskrivelse: (m.beskrivelse || "").split('\n\nLokation:')[0],
 deltagere_tekst: (m.metadata?.deltagere || []).join(', '),
 kalender_bruger_ids: kb.map(b => b.id),
 loading: false, resultat: null, kan_ikke_skifte_kalender: true,
 });
 }}
 /> </div>
 {/* ── FULDMAGT ── */}
 <div style={{ ...panel, padding:"16px 20px", marginTop:12, position:"relative", overflow:"hidden" }}>
 {/* Accent strip */}
 <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:"linear-gradient(90deg, #c084fc, #c084fc44, transparent)", borderRadius:"16px 16px 0 0", pointerEvents:"none" }} />
 {/* Glow orb */}
 <div style={{ position:"absolute", top:-15, right:-15, width:80, height:80, borderRadius:"50%", background:"rgba(192,132,252,0.07)", filter:"blur(20px)", pointerEvents:"none" }} /> <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12, position:"relative" }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase" }}>
 Fuldmagt
 <HjaelpIkon tekst="Fuldmagt bemyndiger SkilsmisseVejen til at handle på klientens (og børns) vegne over for myndigheder. Genereres som PDF ud fra standardskabelon, skal underskrives af klient og evt. af modpart, og registreres derefter som 'Modtaget' med udløbsdato." /> </div>
 {(() => {
 const aktiv_sag = sager.find(s=>s.id===valgt.id)||valgt;
 return (
 <button
 onClick={async () => {
 // Åbn dialog straks med loading-state
 const klient_cpr_nu = sag_detaljer.cpr && sag_detaljer.cpr !== '—' && sag_detaljer.cpr !== '******-****' ? sag_detaljer.cpr : null;
 setFuldmagtDialog({
 sag_id: aktiv_sag.id,
 klient_id: aktiv_sag.klient_id,
 klient_navn: aktiv_sag.klient,
 sagsnummer: aktiv_sag.sagsnummer,
 boern: [],
 valgte_boern: [],
 trin: 'vælg_børn',
 loading: true,
 pdf: null,
 indlæser_boern: true,
 klient_cpr: klient_cpr_nu,
 klient_cpr_indtastet: "",
 });
 // Hent børn fra backend
 try {
 const data = await api(`sager/${aktiv_sag.id}/boern`);
 // BOERN-CPR: Inkluder CPR og sag_id så dialog kan vise og redigere
 // (barn kan være knyttet til en anden sag for samme klient)
 const boern_liste = (data?.boern || []).map(b => ({
 id: b.id, fornavn: b.fornavn, efternavn: b.efternavn,
 sag_id: b.sag_id || aktiv_sag.id,
 cpr: b.cpr || null,
 er_paa_denne_sag: b.er_paa_denne_sag !== false,
 }));
 setFuldmagtDialog(p => p ? ({
 ...p,
 boern: boern_liste,
 valgte_boern: boern_liste.map(b => b.id),
 loading: false,
 indlæser_boern: false,
 }) : null);
 } catch (err) {
 console.error('[FULDMAGT] kunne ikke hente børn:', err);
 setFuldmagtDialog(p => p ? ({ ...p, loading:false, indlæser_boern:false }) : null);
 }
 }}
 style={{ background:T.turkis+"18", border:`1px solid ${T.turkis}44`, borderRadius:6, padding:"4px 10px", color:T.turkis, fontSize:12, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 + Opret fuldmagt
 </button>
 );
 })()}
 </div>
 {(() => {
 const aktiv_sag = sager.find(s=>s.id===valgt.id)||valgt;
 const status = aktiv_sag.fuldmagt_status || 'ingen';
 const dato = aktiv_sag.fuldmagt_dato;
 const udloeb = aktiv_sag.fuldmagt_udloeb;
 const myndigheder = Array.isArray(aktiv_sag.fuldmagt_myndigheder) ? aktiv_sag.fuldmagt_myndigheder : [];
 const status_info = {
 'ingen': { farve:"#94a3b8", tekst:"Ingen fuldmagt oprettet" },
 'afventer': { farve:"#ffd166", tekst:"Afventer underskrift" },
 'afventer_underskrift':{ farve:"#ffd166", tekst:"Afventer underskrift" },
 'modtaget': { farve:"#06d6a0", tekst:"Modtaget og underskrevet" },
 'udloebt': { farve:"#ff6b6b", tekst:"Udløbet — skal fornys" },
 }[status] || { farve:"#94a3b8", tekst:status };
 return (
 <>
 {/* Status-linje */}
 <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:10 }}> <div style={{ width:10, height:10, borderRadius:"50%", background:status_info.farve, flexShrink:0 }} /> <div style={{ fontSize:13, color:T.creme, flex:1, fontWeight:500 }}>{status_info.tekst}</div>
 {dato && <div style={{ fontSize:11, color:T.dæmpet }}>Oprettet: {new Date(dato).toLocaleDateString("da-DK")}</div>}
 </div>
 {udloeb && (() => {
 const dage = Math.ceil((new Date(udloeb) - new Date()) / 86400000);
 const farve = dage < 0 ? T.roed : dage <= 30 ? "#ffd166" : T.groen;
 const baggrund = dage < 0 ? "rgba(251,113,133,0.08)" : dage <= 30 ? "rgba(255,209,102,0.08)" : "rgba(6,214,160,0.05)";
 const besked = dage < 0 ? ` Udløbet for ${Math.abs(dage)} dage siden` : dage <= 30 ? ` Udløber om ${dage} dage — forny nu` : `Gyldig indtil ${new Date(udloeb).toLocaleDateString("da-DK")} (${dage} dage)`;
 return <div style={{ padding:"8px 12px", background:baggrund, border:`1px solid ${farve}33`, borderRadius:6, fontSize:12, color:farve, marginBottom:10 }}>{besked}</div>;
 })()}
 {/* Action-knapper — varierer med status */}
 {status !== 'ingen' && (
 <div style={{ display:"flex", gap:6, flexWrap:"wrap", marginBottom:10 }}>
 {/* Download seneste fuldmagt */}
 <button
 onClick={async () => {
 try {
 const filer_data = await api(`filer/sag/${aktiv_sag.id}`);
 const fuldmagt_fil = (filer_data?.filer || []).find(f => /fuldmagt/i.test(f.original_navn || f.visningsnavn || ''));
 if (!fuldmagt_fil) { toast("Ingen gemt fuldmagt-fil fundet — generér igen", "fejl"); return; }
 // Fetch filen som blob
 const res = await fetch(`/api/filer/${fuldmagt_fil.id}/download`, { credentials: 'include' });
 if (!res.ok) { toast("Download fejlede", "fejl"); return; }
 const blob = await res.blob();
 const url = window.URL.createObjectURL(blob);
 const a = document.createElement('a');
 a.href = url; a.download = fuldmagt_fil.original_navn || 'Fuldmagt.pdf';
 document.body.appendChild(a); a.click(); a.remove();
 window.URL.revokeObjectURL(url);
 } catch (e) { console.error('[Fuldmagt] download fejl:', e); toast("Download fejlede — prøv igen", "fejl"); }
 }}
 style={{ background:"rgba(63,212,199,0.08)", border:`1px solid ${T.turkis}44`, borderRadius:6, padding:"6px 12px", color:T.turkis, fontSize:12, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Download seneste
 </button>
 {/* Markér modtaget (kun hvis afventer) */}
 {(status === 'afventer' || status === 'afventer_underskrift') && (
 <button
 onClick={async () => {
 const i_dag = new Date().toISOString().split('T')[0];
 const bekraeft_dato = window.prompt('Dato for modtagelse af underskrevet fuldmagt (ÅÅÅÅ-MM-DD):', i_dag);
 if (!bekraeft_dato) return;
 try {
 const res = await api("fuldmagt/status", "PATCH", {
 klient_id: aktiv_sag.klient_id,
 sag_id: aktiv_sag.id,
 status: 'modtaget',
 dato: bekraeft_dato,
 });
 if (res?.succes) {
 toast(" Fuldmagt markeret som modtaget. Deadline oprettet 30 dage før udløb.", "success");
 hent_sager();
 } else toast("Fuldmagt-status kunne ikke gemmes — prøv igen", "fejl");
 } catch (e) { console.error('[Fuldmagt] markér modtaget fejl:', e); toast("Fejl — prøv igen", "fejl"); }
 }}
 style={{ background:"rgba(6,214,160,0.1)", border:`1px solid ${T.groen}44`, borderRadius:6, padding:"6px 12px", color:T.groen, fontSize:12, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Markér modtaget
 </button>
 )}
 {/* Send til myndighed */}
 {status === 'modtaget' && (
 <button
 onClick={async () => {
 const myndighed = window.prompt('Hvilken myndighed sendes fuldmagten til?\n(fx: Familieretshuset, Aarhus Kommune, Statsforvaltningen)');
 if (!myndighed || !myndighed.trim()) return;
 const i_dag = new Date().toISOString().split('T')[0];
 const dato_send = window.prompt('Dato for afsendelse (ÅÅÅÅ-MM-DD):', i_dag);
 if (!dato_send) return;
 try {
 const res = await api("fuldmagt/myndighed-send", "POST", {
 klient_id: aktiv_sag.klient_id,
 myndighed: myndighed.trim(),
 dato: dato_send,
 });
 if (res?.succes) {
 toast(` Fuldmagt registreret som sendt til ${myndighed.trim()}`, "success");
 hent_sager();
 } else toast("Fuldmagt-registrering fejlede — prøv igen", "fejl");
 } catch (e) { console.error('[Fuldmagt] send til myndighed fejl:', e); toast("Fejl — prøv igen", "fejl"); }
 }}
 style={{ background:"rgba(192,132,252,0.1)", border:`1px solid #c084fc44`, borderRadius:6, padding:"6px 12px", color:"#c084fc", fontSize:12, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Send til myndighed
 </button>
 )}
 </div>
 )}
 {/* Myndigheder-liste */}
 {myndigheder.length > 0 && (
 <div style={{ padding:"10px 12px", background:"rgba(255,255,255,0.02)", border:T.kort_kant, borderRadius:8, marginTop:4 }}> <div style={{ fontSize:11, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:6 }}>Sendt til</div>
 {myndigheder.map((m, i) => (
 <div key={i} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"4px 0", borderBottom: i < myndigheder.length-1 ? "1px solid rgba(255,255,255,0.04)" : "none" }}> <span style={{ fontSize:12, color:T.creme }}> {m.myndighed || m.navn || m}</span> <span style={{ fontSize:11, color:T.dæmpet }}>{m.dato ? new Date(m.dato).toLocaleDateString("da-DK") : ""}</span> </div>
 ))}
 </div>
 )}
 </>
 );
 })()}
 </div>
 {/* ── SENESTE 5 HÆNDELSER I OVERBLIK ── */}
 <div style={{ ...panel, padding:"16px 20px", marginTop:12, position:"relative", overflow:"hidden" }}>
 {/* Accent strip */}
 <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:"linear-gradient(90deg, #60a5fa, #60a5fa44, transparent)", borderRadius:"16px 16px 0 0", pointerEvents:"none" }} />
 {/* Glow orb */}
 <div style={{ position:"absolute", top:-15, right:-15, width:80, height:80, borderRadius:"50%", background:"rgba(96,165,250,0.07)", filter:"blur(20px)", pointerEvents:"none" }} /> <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12, position:"relative" }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", display:"flex", alignItems:"center", gap:6 }}>Seneste hændelser <HjaelpIkon tekst="Kronologisk log af alt der er sket på sagen: noter, mails, telefonopkald, møder, dokumenter. Hver hændelse har dato og forfatter. Mails og opkald journaliseres automatisk hvis klient-email/tlf er kendt." /></div> <button onClick={()=>skift_fane_lokalt("haendelser")} style={{ background:"none", border:"none", color:T.turkis, fontSize:12, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif", padding:0 }}>
 Se alle hændelser →
 </button> </div>
 {sag_haendelser.length === 0 ? (
 <div style={{ fontSize:12, color:T.dæmpet, fontStyle:"italic" }}>Ingen hændelser endnu</div>
 ) : sag_haendelser.slice(0,5).map((h,i,arr) => (
 <div key={h.id} style={{ display:"flex", gap:10, padding:"9px 0", borderBottom:i<Math.min(arr.length,5)-1?T.skillelinje:"none" }}> <div style={{ width:32, height:32, borderRadius:8, background:"rgba(255,255,255,0.06)", border:T.skillelinje, display:"flex", alignItems:"center", justifyContent:"center", fontSize:14, flexShrink:0 }}>
 {{ note:"", aktindsigt:"", mail_ind:"", mail_ud:"↗", opkald:"", moede:"", dokument:"", myndighedsbrev:"", aftale:"", faktura:"" }[h.type] || ""}
 </div> <div style={{ flex:1, minWidth:0 }}> <div style={{ fontSize:13, fontWeight:500, color:T.lys, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{h.titel}</div> <div style={{ fontSize:12, color:T.dæmpet }}>{new Date(h.dato).toLocaleDateString("da-DK")} · {h.forfatter}</div> </div> </div>
 ))}
 </div> </div>
 )}
 {/* ── TAB: HÆNDELSER OG FILER ── */}
 {aktiv_tab==="haendelser" && (
 <div className="sv-panel-animated" style={{ animationDelay:"0.05s" }}>
 <AiSoegningBoks
 valgt={valgt}
 ai_soeg_spg={ai_soeg_spg} setAiSoegSpg={setAiSoegSpg} ai_soeg_loader={ai_soeg_loader} setAiSoegLoader={setAiSoegLoader} ai_soeg_svar={ai_soeg_svar} setAiSoegSvar={setAiSoegSvar}
 />
 {/* ── GENERER DOKUMENT KNAP ── */}
 <div style={{ display:"flex", justifyContent:"flex-end", marginBottom:12 }}>
 <button
 onClick={() => setWizardModal({ haendelse_id: null, dok_type: '', forud_fil_ids: [] })}
 style={{ background: T.blaa, border:"none", borderRadius:9, padding:"10px 20px", color:"#fff", fontWeight:700, fontSize:13, fontFamily:"'Inter',system-ui,sans-serif", cursor:"pointer" }}>
 Generer dokument
 </button>
 </div>
 <HændelseRegistrering sagId={valgt.id} sager={sager} setSager={setSager} setValgt={setValgt} filRef={fil_ref} onGenererDokument={setWizardModal} maal_haendelse_id={maal_haendelse_id} onMaalAabnet={onMaalAabnet} fjern_nye_haendelse={fjern_nye_haendelse} /> </div>
 )}
 {/* ── TAB: E-MAILS ── */}
 {aktiv_tab==="email" && (
 <div className="sv-panel-animated" style={{ animationDelay:"0.05s" }}>
 {/* ── Import historiske mails ── */}
 <div style={{ ...panel, padding:"14px 20px", marginBottom:12, display:"flex", alignItems:"center", justifyContent:"space-between", gap:12, position:"relative", overflow:"hidden" }}>
 {/* Accent strip */}
 <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:"linear-gradient(90deg, #60a5fa, #60a5fa44, transparent)", borderRadius:"16px 16px 0 0", pointerEvents:"none" }} /> <div> <div style={{ fontSize:13, fontWeight:600, color:T.creme, marginBottom:2, display:"flex", alignItems:"center", gap:6, position:"relative" }}>
 Importér mails fra Outlook
 <HjaelpIkon tekst="Søg Outlook efter alle mails TIL eller FRA bestemte email-adresser og importér dem som hændelser (både indgående og udgående). Duplikater springes automatisk over." /> </div> <div style={{ fontSize:12, color:"rgba(255,255,255,0.5)" }}>
 Hent alle historiske mails til/fra klientens email — tilføjes som hændelser
 </div> </div> <button
 onClick={() => {
 const aktiv_sag = sager.find(s=>s.id===valgt.id)||valgt;
 api(`klient-kontakter/klient/${aktiv_sag.klient_id}`).then(kk => {
 const emails = [];
 api(`klienter/${aktiv_sag.klient_id}`).then(kd => {
 if (kd?.klient?.email) emails.push(kd.klient.email);
 (kk?.kontakter || []).forEach(k => { if (k.type==='email' && k.vaerdi) emails.push(k.vaerdi); });
 setMailImportDialog({
 sag_id: aktiv_sag.id, klient_id: aktiv_sag.klient_id,
 klient_navn: aktiv_sag.klient, sagsnummer: aktiv_sag.sagsnummer,
 emails_tekst: [...new Set(emails)].join('\n'),
 fra_dato: "", til_dato: "", loading: false, resultat: null,
 });
 }).catch(() => {
 setMailImportDialog({
 sag_id: aktiv_sag.id, klient_id: aktiv_sag.klient_id,
 klient_navn: aktiv_sag.klient, sagsnummer: aktiv_sag.sagsnummer,
 emails_tekst: "", fra_dato: "", til_dato: "", loading: false, resultat: null,
 });
 });
 }).catch(() => {});
 }}
 style={{ background:T.turkis, border:"none", borderRadius:8, padding:"9px 18px", color:"#fff", fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif", flexShrink:0, fontWeight:700 }}>
 Importér mails
 </button> </div> <div style={{ ...panel, padding:"20px", position:"relative", overflow:"hidden" }}>
 {/* Accent strip */}
 <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:"linear-gradient(90deg, #818cf8, #818cf844, transparent)", borderRadius:"16px 16px 0 0", pointerEvents:"none" }} />
 {/* Glow */}
 <div style={{ position:"absolute", top:-15, right:20, width:100, height:100, borderRadius:"50%", background:"rgba(129,140,248,0.06)", filter:"blur(25px)", pointerEvents:"none" }} /> <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16, position:"relative" }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase" }}>Seneste mails fra Outlook</div> <button onClick={async () => {
 setEmailLoader(true);
 const data = await api("email/hent?antal=20");
 if (data?.mails) setEmailListe(data.mails);
 setEmailLoader(false);
 }} disabled={email_loader}
 style={{ background:email_loader?"rgba(63,212,199,0.2)":`${T.turkis}22`, border:`1px solid ${T.turkis}55`, borderRadius:8, padding:"7px 16px", color:T.turkis, fontSize:12, fontFamily:"'Inter',system-ui,sans-serif", cursor:email_loader?"wait":"pointer", fontWeight:600 }}>
 {email_loader ? " Henter mails..." : "↻ Hent mails fra Outlook"}
 </button> </div>
 {email_liste.length === 0 && !email_loader && (
 <div style={{ textAlign:"center", padding:"40px 20px", color:T.dæmpet }}> <div style={{ fontSize:32, marginBottom:12 }}></div> <div style={{ fontSize:13 }}>Klik "Hent mails fra Outlook" for at se indgående mails</div> <div style={{ fontSize:12, marginTop:6 }}>Mails der matcher en klient markeres automatisk</div> </div>
 )}
 {email_liste.map(mail => (
 <div key={mail.id} style={{
 padding:"14px 16px", marginBottom:8, borderRadius:10,
 background: mail.journaliseret ? "rgba(6,214,160,0.05)" : mail.match ? "rgba(63,212,199,0.06)" : "rgba(255,255,255,0.03)",
 border: `1px solid ${mail.journaliseret ? "rgba(6,214,160,0.2)" : mail.match ? "rgba(63,212,199,0.2)" : "rgba(255,255,255,0.06)"}`,
 }}> <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:12 }}> <div style={{ flex:1, minWidth:0 }}> <div style={{ fontSize:13, fontWeight:500, color:T.lys, marginBottom:4, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
 {mail.emne}
 </div> <div style={{ fontSize:12, color:T.dæmpet, marginBottom:4 }}>
 {mail.fra} · {new Date(mail.dato).toLocaleDateString("da-DK")} kl. {new Date(mail.dato).toLocaleTimeString("da-DK",{hour:"2-digit",minute:"2-digit"})}
 {mail.har_vedhæftninger && " · "}
 </div> <div style={{ fontSize:12, color:"#b0bec5", lineHeight:1.5 }}>{mail.uddrag}</div>
 {mail.match && (
 <div style={{ marginTop:6, fontSize:12, color:T.turkis }}>
 Matchet: {mail.match.klient_navn} ({mail.match.sagsnummer})
 </div>
 )}
 </div> <div style={{ flexShrink:0 }}>
 {mail.journaliseret ? (
 <span style={{ fontSize:12, padding:"4px 10px", borderRadius:5, background:"rgba(6,214,160,0.1)", color:T.groen }}> Journaliseret</span>
 ) : (
 <button onClick={async () => {
 const target_sag_id = mail.match?.sag_id || valgt?.id;
 if (!target_sag_id) { vis_toast("Vælg en sag først"); return; }
 const data = await api("email/journaliser", "POST", { mail_id: mail.id, sag_id: target_sag_id });
 if (data?.succes) {
 setEmailListe(prev => prev.map(m => m.id === mail.id ? {...m, journaliseret: true} : m));
 vis_toast(" Mail journaliseret på " + (mail.match?.sagsnummer || valgt?.sagsnummer));
 }
 }} style={{ fontSize:12, padding:"5px 12px", borderRadius:6, background:`${T.turkis}22`, border:`1px solid ${T.turkis}44`, color:T.turkis, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif", whiteSpace:"nowrap" }}>
 Journalisér {mail.match ? "→ " + mail.match.sagsnummer : "→ denne sag"}
 </button>
 )}
 </div> </div> </div>
 ))}
 </div> </div>
 )}
 {/* ── TAB: ONEDRIVE FILER ── */}
 {aktiv_tab==="filer" && (
 <>
 <AiSoegningBoks
 valgt={valgt}
 ai_soeg_spg={ai_soeg_spg} setAiSoegSpg={setAiSoegSpg} ai_soeg_loader={ai_soeg_loader} setAiSoegLoader={setAiSoegLoader} ai_soeg_svar={ai_soeg_svar} setAiSoegSvar={setAiSoegSvar}
 />
 <OneDriveFiler sag={valgt} />
 </>
 )}
 {/* ── TAB: UPLOAD-LINKS ── */}
 {aktiv_tab==="upload" && (
 <UploadLinksPanel sag={valgt} />
 )}
 {/* ── TAB: SAGSBEHANDLERE ── */}
 {aktiv_tab==="sagsbehandler" && (
 <div className="sv-panel-animated" style={{ animationDelay:"0.05s" }}>
 {/* Interne sagsbehandlere */}
 <div style={{ ...panel, padding:"20px", marginBottom:14, position:"relative", overflow:"hidden" }}>
 {/* Accent strip */}
 <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:`linear-gradient(90deg, ${T.turkis}, #60a5fa44, transparent)`, borderRadius:"16px 16px 0 0", pointerEvents:"none" }} />
 {/* Glow */}
 <div style={{ position:"absolute", top:-15, right:20, width:100, height:100, borderRadius:"50%", background:`${T.turkis}07`, filter:"blur(25px)", pointerEvents:"none" }} /> <div style={{ fontSize:13, fontWeight:500, color:T.creme, marginBottom:4, position:"relative" }}>Interne sagsbehandlere</div> <div style={{ fontSize:12, color:T.dæmpet, marginBottom:18, lineHeight:1.6 }}>
 Primær har fuld ansvar og godkendelsesret. Sekundær har læse- og redigeringsadgang.
 </div>
 {/* Primær */}
 <div style={{ marginBottom:20 }}> <div style={{ fontSize:12, color:T.turkis, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:8 }}>
 Primær sagsbehandler
 </div> <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
 {ALLE_BRUGERE.map(b => {
 const aktiv = (sager.find(s=>s.id===valgt.id)||valgt).primær === b.navn;
 return (
 <button key={b.id} onClick={()=>{
 setSager(p=>p.map(s=>s.id===valgt.id?{...s,primær:b.navn,primær_id:b.id}:s));
 setValgt(p=>({...p,primær:b.navn,primær_id:b.id}));
 api("sager/"+valgt.id,"PATCH",{primær_sagsbehandler_id:b.id}).catch(err => { console.error(err); toast("En handling fejlede — prøv igen", "fejl"); });
 }}
 style={{ padding:"9px 16px", borderRadius:8, fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif", transition:"all 0.15s",
 border:`1px solid ${aktiv?T.turkis:"rgba(255,255,255,0.06)"}`,
 background:aktiv?`${T.turkis}20`:"rgba(255,255,255,0.04)",
 color:aktiv?T.turkis:T.dæmpet, fontWeight:aktiv?500:400,
 }}>
 {aktiv ? " " : ""}{b.navn}
 </button>
 );
 })}
 </div> </div>
 {/* Sekundær */}
 <div> <div style={{ fontSize:12, color:"#60a5fa", letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:8 }}>
 Sekundær sagsbehandler <span style={{ color:T.dæmpet, fontWeight:400, textTransform:"none", letterSpacing:0 }}>(valgfri)</span> </div> <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
 {/* Ingen-knap */}
 {(() => {
 const aktiv_sag = sager.find(s=>s.id===valgt.id)||valgt;
 const ingen_aktiv = !aktiv_sag.sekundær;
 return (
 <button onClick={()=>{
 setSager(p=>p.map(s=>s.id===valgt.id?{...s,sekundær:null,sekundær_id:null}:s));
 setValgt(p=>({...p,sekundær:null,sekundær_id:null}));
 api("sager/"+valgt.id,"PATCH",{sekundær_sagsbehandler_id:null}).catch(err => { console.error(err); toast("En handling fejlede — prøv igen", "fejl"); });
 }}
 style={{ padding:"9px 16px", borderRadius:8, fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif",
 border:`1px solid ${ingen_aktiv?"rgba(255,107,107,0.4)":"rgba(255,255,255,0.06)"}`,
 background:ingen_aktiv?"rgba(255,107,107,0.1)":"rgba(255,255,255,0.04)",
 color:ingen_aktiv?T.roed:T.dæmpet,
 }}>
 {ingen_aktiv?" ":""}Ingen
 </button>
 );
 })()}
 {/* Bruger-knapper — ekskl. primær */}
 {ALLE_BRUGERE.filter(b => b.navn !== (sager.find(s=>s.id===valgt.id)||valgt).primær).map(b => {
 const aktiv_sag = sager.find(s=>s.id===valgt.id)||valgt;
 const aktiv = aktiv_sag.sekundær === b.navn;
 return (
 <button key={b.id} onClick={()=>{
 setSager(p=>p.map(s=>s.id===valgt.id?{...s,sekundær:b.navn,sekundær_id:b.id}:s));
 setValgt(p=>({...p,sekundær:b.navn,sekundær_id:b.id}));
 api("sager/"+valgt.id,"PATCH",{sekundær_sagsbehandler_id:b.id}).catch(err => { console.error(err); toast("En handling fejlede — prøv igen", "fejl"); });
 }}
 style={{ padding:"9px 16px", borderRadius:8, fontSize:13, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif", transition:"all 0.15s",
 border:`1px solid ${aktiv?"#60a5fa":"rgba(255,255,255,0.06)"}`,
 background:aktiv?"rgba(96,165,250,0.15)":"rgba(255,255,255,0.04)",
 color:aktiv?"#60a5fa":T.dæmpet, fontWeight:aktiv?500:400,
 }}>
 {aktiv?" ":""}{b.navn}
 </button>
 );
 })}
 </div> </div> </div>
 {/* Adgangsoverblik + rettighedsstyring */}
 {(() => {
 const aktiv_sag = sager.find(s=>s.id===valgt.id)||valgt;
 const SEKUND_RETT = [
 { id:"se", label:"Se sagen og alle oplysninger", låst:true },
 { id:"redigere", label:"Redigere sagoplysninger", låst:false },
 { id:"journal", label:"Journalisere hændelser og filer", låst:false },
 { id:"noter", label:"Tilføje og se noter", låst:false },
 { id:"eksterne", label:"Se og redigere eksterne kontakter",låst:false },
 { id:"godkende", label:"Godkende AI-dokumenter", låst:false },
 { id:"sende", label:"Sende dokumenter til klient", låst:false },
 { id:"deadlines",label:"Oprette og ændre deadlines", låst:false },
 { id:"tildele", label:"Tildele opgaver til andre", låst:false },
 ];
 const std = ["se","redigere","journal","noter","eksterne"];
 const nuv_rett = aktiv_sag.sekundær_rettigheder || std;
 const toggle_rett = (id) => {
 const ny = nuv_rett.includes(id) ? nuv_rett.filter(r=>r!==id) : [...nuv_rett,id];
 opdater_sag(aktiv_sag.id,"sekundær_rettigheder",ny);
 setValgt(p=>({...p,sekundær_rettigheder:ny}));
 };
 return (
 <div>
 {/* Primær */}
 <div style={{ ...panel, padding:"16px 20px", marginBottom:12 }}> <div style={{ fontSize:12, color:T.dæmpet, letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:10 }}>Primær — fuld adgang</div> <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:10 }}> <div style={{ width:28,height:28,borderRadius:"50%",background:`${T.turkis}20`,border:`1px solid ${T.turkis}44`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:600,color:T.turkis }}>{aktiv_sag.primær?.split(" ").map(n=>n[0]).join("").slice(0,2)}</div> <span style={{ fontSize:13,color:T.creme }}>{aktiv_sag.primær}</span> </div> <div style={{ display:"flex",gap:6,flexWrap:"wrap" }}>
 {["Se sagen","Redigere","Journalisere","Godkende","Sende","Alle rettigheder"].map(r=>(
 <span key={r} style={{ fontSize:12,padding:"2px 8px",borderRadius:4,color:T.turkis,background:`${T.turkis}12`,border:`1px solid ${T.turkis}25` }}>{r}</span>
 ))}
 </div> </div>
 {/* Sekundær med styring */}
 {aktiv_sag.sekundær ? (
 <div style={{ ...panel, padding:"16px 20px" }}> <div style={{ fontSize:12, color:"#60a5fa", letterSpacing:"0.1em", textTransform:"uppercase", marginBottom:4 }}>Sekundær — tilpassede rettigheder</div> <div style={{ fontSize:12, color:T.dæmpet, marginBottom:14 }}>Styr præcis hvad {aktiv_sag.sekundær} må på denne sag</div> <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:14 }}> <div style={{ width:28,height:28,borderRadius:"50%",background:"rgba(96,165,250,0.15)",border:"1px solid rgba(96,165,250,0.35)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:600,color:"#60a5fa" }}>{aktiv_sag.sekundær?.split(" ").map(n=>n[0]).join("").slice(0,2) || "?"}</div> <span style={{ fontSize:13,color:T.creme }}>{aktiv_sag.sekundær}</span> </div>
 {SEKUND_RETT.map((ret,i)=>(
 <div key={ret.id} style={{ display:"flex",alignItems:"center",justifyContent:"space-between",padding:"10px 0",borderBottom:i<SEKUND_RETT.length-1?T.skillelinje:"none" }}> <div> <span style={{ fontSize:13,color:nuv_rett.includes(ret.id)?T.lys:T.dæmpet }}>{ret.label}</span>
 {ret.låst && <span style={{ fontSize:12,color:T.dæmpet,marginLeft:8 }}> Altid</span>}
 </div> <button onClick={()=>!ret.låst&&toggle_rett(ret.id)}
 style={{ width:40,height:22,borderRadius:11,border:"none",cursor:ret.låst?"default":"pointer",position:"relative",background:nuv_rett.includes(ret.id)?"#60a5fa":"rgba(255,255,255,0.06)",opacity:ret.låst?0.6:1,transition:"background 0.2s",flexShrink:0 }}> <div style={{ width:16,height:16,borderRadius:"50%",background:"white",position:"absolute",top:3,left:nuv_rett.includes(ret.id)?21:3,transition:"left 0.2s",boxShadow:"0 1px 3px rgba(0,0,0,0.3)" }} /> </button> </div>
 ))}
 <div style={{ marginTop:10,fontSize:12,color:T.dæmpet }}>Ændringer gælder kun denne sag</div> </div>
 ) : (
 <div style={{ ...panel,padding:"20px",textAlign:"center" }}> <div style={{ color:T.dæmpet,fontSize:13 }}>Ingen sekundær tildelt</div> <button onClick={()=>skift_fane_lokalt("sagsbehandler")} style={{ marginTop:10,background:"none",border:"none",color:T.turkis,fontSize:12,cursor:"pointer",fontFamily:"'Inter',system-ui,sans-serif" }}>Tildel sekundær →</button> </div>
 )}
 </div>
 );
 })()}
 </div>
 )}
 {/* ── TAB: EKSTERNE KONTAKTER ── */}
 {aktiv_tab==="eksterne" && (
 <EksterneKontakter sagId={valgt.id} sager={sager} setSager={setSager} />
 )}
 </div>
 )}

 {wizard_modal !== null && valgt && createPortal(
   <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.6)", zIndex:20000, display:"flex", alignItems:"center", justifyContent:"center", padding:16, overflowY:"auto" }}
     onClick={e => { if (e.target === e.currentTarget) setWizardModal(null); }}>
     <div style={{ background:"#fff", borderRadius:18, maxWidth:900, width:"100%", maxHeight:"90vh", overflowY:"auto", boxShadow:"0 24px 80px rgba(0,0,0,0.6)", position:"relative" }}>
       <button onClick={() => setWizardModal(null)} style={{ position:"absolute", top:14, right:14, zIndex:10, background:"none", border:"1px solid rgba(15,23,42,0.15)", borderRadius:6, padding:"4px 10px", fontSize:18, cursor:"pointer", color:"#64748b", lineHeight:1 }}>✕</button>
       {wizard_modal?.haendelse_titel && (
         <div style={{ padding:"16px 28px 0" }}>
           <div style={{ background:"rgba(79,70,229,0.08)", border:"1px solid rgba(79,70,229,0.2)", borderRadius:8, padding:"8px 14px", fontSize:13, color:"#4f46e5" }}>
             Fra hændelse: "{wizard_modal.haendelse_titel}"
           </div>
         </div>
       )}
       <DokumentGeneratorWizard
         sagId={valgt.id}
         haendelse_kontekst={wizard_modal}
         modal_mode={true}
         onLuk={() => setWizardModal(null)}
       />
     </div>
   </div>,
   document.body
 )} </div> <Toast /> </>
 );
}
export { HændelseRegistrering, EksterneKontakter, SagsbehandlerPanel, KlientOversigt, Toast, vis_toast, beregn_deadline_info };

